// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/owl.carousel/dist/assets/owl.carousel.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/owl.carousel/dist/assets/owl.theme.default.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Inter/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Inter/Inter-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Inter/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/museo/MuseoSansRounded100.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/museo/MuseoSansRounded300.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/museo/MuseoSansRounded500.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/museo/MuseoSansRounded700.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/museo/MuseoSansRounded900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/museo/MuseoSansRounded1000.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328a745%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../assets/images/navigation/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../src/assets/images/negocio/fondo-negocio.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/images/descarga/bg-dekstop.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
/* 100 - Thin */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
/* 300 - Light */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
/* 500 - Medium */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
/* 700 - Bold */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
/* 900 - Black */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
/* 1000 - Heavy / Ultra */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-weight: 1000;
  font-style: normal;
  font-display: swap;
}
/*!
 * Bootstrap v4.6.2 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #007bff;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #0056b3;
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: 2.5rem;
}

h2, .h2 {
  font-size: 2rem;
}

h3, .h3 {
  font-size: 1.75rem;
}

h4, .h4 {
  font-size: 1.5rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 0.875em;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #b8daff;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #7abaff;
}

.table-hover .table-primary:hover {
  background-color: #9fcdff;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #9fcdff;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d6d8db;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #b3b7bb;
}

.table-hover .table-secondary:hover {
  background-color: #c8cbcf;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #c8cbcf;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c3e6cb;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #8fd19e;
}

.table-hover .table-success:hover {
  background-color: #b1dfbb;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #b1dfbb;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bee5eb;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #86cfda;
}

.table-hover .table-info:hover {
  background-color: #abdde5;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #abdde5;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffeeba;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #ffdf7e;
}

.table-hover .table-warning:hover {
  background-color: #ffe8a1;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #ffe8a1;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #f5c6cb;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #ed969e;
}

.table-hover .table-danger:hover {
  background-color: #f1b0b7;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #f1b0b7;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fdfdfe;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #fbfcfc;
}

.table-hover .table-light:hover {
  background-color: #ececf6;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #ececf6;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c6c8ca;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #95999c;
}

.table-hover .table-dark:hover {
  background-color: #b9bbbe;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b9bbbe;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #454d55;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #28a745;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #28a745;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_9___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #28a745;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #34ce57;
  background-color: #34ce57;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_11___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #e4606d;
  background-color: #e4606d;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
.form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #212529;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.btn-primary:hover {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
}
.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #0062cc;
  border-color: #005cbf;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.btn-success:hover {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #1e7e34;
  border-color: #1c7430;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info:hover {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
}
.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #117a8b;
  border-color: #10707f;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:hover {
  color: #212529;
  background-color: #e0a800;
  border-color: #d39e00;
}
.btn-warning:focus, .btn-warning.focus {
  color: #212529;
  background-color: #e0a800;
  border-color: #d39e00;
  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: #d39e00;
  border-color: #c69500;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #bd2130;
  border-color: #b21f2d;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}
.btn-light:focus, .btn-light.focus {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
}
.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #1d2124;
  border-color: #171a1d;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}

.btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #007bff;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-outline-success {
  color: #28a745;
  border-color: #28a745;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #28a745;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #17a2b8;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #dc3545;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #007bff;
  text-decoration: none;
}
.btn-link:hover {
  color: #0056b3;
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #80bdff;
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #b3d7ff;
  border-color: #b3d7ff;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #adb5bd;
}
.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #007bff;
  background-color: #007bff;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_10___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}
.custom-select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #b3d7ff;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
.custom-file-label,
.custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
.navbar-expand-sm > .container-fluid,
.navbar-expand-sm > .container-sm,
.navbar-expand-sm > .container-md,
.navbar-expand-sm > .container-lg,
.navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
.navbar-expand-sm > .container-fluid,
.navbar-expand-sm > .container-sm,
.navbar-expand-sm > .container-md,
.navbar-expand-sm > .container-lg,
.navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
.navbar-expand-md > .container-fluid,
.navbar-expand-md > .container-sm,
.navbar-expand-md > .container-md,
.navbar-expand-md > .container-lg,
.navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
.navbar-expand-md > .container-fluid,
.navbar-expand-md > .container-sm,
.navbar-expand-md > .container-md,
.navbar-expand-md > .container-lg,
.navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
.navbar-expand-lg > .container-fluid,
.navbar-expand-lg > .container-sm,
.navbar-expand-lg > .container-md,
.navbar-expand-lg > .container-lg,
.navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
.navbar-expand-lg > .container-fluid,
.navbar-expand-lg > .container-sm,
.navbar-expand-lg > .container-md,
.navbar-expand-lg > .container-lg,
.navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
.navbar-expand-xl > .container-fluid,
.navbar-expand-xl > .container-sm,
.navbar-expand-xl > .container-md,
.navbar-expand-xl > .container-lg,
.navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
.navbar-expand-xl > .container-fluid,
.navbar-expand-xl > .container-sm,
.navbar-expand-xl > .container-md,
.navbar-expand-xl > .container-lg,
.navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0 0%;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
.card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
.card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
.card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
.card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #0056b3;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #007bff;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: #0062cc;
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: #545b62;
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: #1e7e34;
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #17a2b8;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: #117a8b;
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #212529;
  background-color: #d39e00;
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #dc3545;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: #bd2130;
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #f8f9fa;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: #dae0e5;
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: #1d2124;
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff;
}
.alert-primary hr {
  border-top-color: #9fcdff;
}
.alert-primary .alert-link {
  color: #002752;
}

.alert-secondary {
  color: #383d41;
  background-color: #e2e3e5;
  border-color: #d6d8db;
}
.alert-secondary hr {
  border-top-color: #c8cbcf;
}
.alert-secondary .alert-link {
  color: #202326;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}
.alert-success hr {
  border-top-color: #b1dfbb;
}
.alert-success .alert-link {
  color: #0b2e13;
}

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
.alert-info hr {
  border-top-color: #abdde5;
}
.alert-info .alert-link {
  color: #062c33;
}

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.alert-warning hr {
  border-top-color: #ffe8a1;
}
.alert-warning .alert-link {
  color: #533f03;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
.alert-danger hr {
  border-top-color: #f1b0b7;
}
.alert-danger .alert-link {
  color: #491217;
}

.alert-light {
  color: #818182;
  background-color: #fefefe;
  border-color: #fdfdfe;
}
.alert-light hr {
  border-top-color: #ececf6;
}
.alert-light .alert-link {
  color: #686868;
}

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca;
}
.alert-dark hr {
  border-top-color: #b9bbbe;
}
.alert-dark .alert-link {
  color: #040505;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #004085;
  background-color: #b8daff;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #004085;
  background-color: #9fcdff;
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #004085;
  border-color: #004085;
}

.list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #383d41;
  background-color: #c8cbcf;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #383d41;
  border-color: #383d41;
}

.list-group-item-success {
  color: #155724;
  background-color: #c3e6cb;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #155724;
  background-color: #b1dfbb;
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #155724;
  border-color: #155724;
}

.list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #0c5460;
  background-color: #abdde5;
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #0c5460;
  border-color: #0c5460;
}

.list-group-item-warning {
  color: #856404;
  background-color: #ffeeba;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #856404;
  background-color: #ffe8a1;
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #856404;
  border-color: #856404;
}

.list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #721c24;
  background-color: #f1b0b7;
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #721c24;
  border-color: #721c24;
}

.list-group-item-light {
  color: #818182;
  background-color: #fdfdfe;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #818182;
  background-color: #ececf6;
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #818182;
  border-color: #818182;
}

.list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #1b1e21;
  background-color: #b9bbbe;
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #1b1e21;
  border-color: #1b1e21;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
.modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
.carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
.spinner-grow {
    animation-duration: 1.5s;
  }
}
.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #007bff !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #0062cc !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #545b62 !important;
}

.bg-success {
  background-color: #28a745 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #1e7e34 !important;
}

.bg-info {
  background-color: #17a2b8 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #117a8b !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #d39e00 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #bd2130 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #dae0e5 !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #1d2124 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #007bff !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #28a745 !important;
}

.border-info {
  border-color: #17a2b8 !important;
}

.border-warning {
  border-color: #ffc107 !important;
}

.border-danger {
  border-color: #dc3545 !important;
}

.border-light {
  border-color: #f8f9fa !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
.my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
.mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
.my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
.mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
.my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
.mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
.my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
.mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
.my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
.mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
.my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
.mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
.my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
.mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
.my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
.mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
.my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
.mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
.my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
.mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
.my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
.mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
.my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
.mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
.py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
.px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
.py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
.px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
.py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
.px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
.py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
.px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
.py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
.px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
.py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
.px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
.py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
.px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
.py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
.px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
.py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
.px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
.py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
.px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
.py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
.px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
.py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
.px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
.my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
.mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
.my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
.mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
.my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
.mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
.my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
.mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
.my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
.mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
.my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
.mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
.my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
.mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
.my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
.mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
.my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
.mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
.my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
.mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
.my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
.mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
.my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
.mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
.my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
.mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
.my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
.mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
.my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
.mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
.my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
.mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
.my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
.mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
.my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
.mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
.my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
.mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
.my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
.mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
.my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
.mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
.my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
.mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
.my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
.mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
.my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
.mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
.py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
.px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
.py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
.px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
.py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
.px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
.py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
.px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
.py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
.px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
.py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
.px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
.py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
.px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
.py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
.px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
.py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
.px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
.py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
.px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
.py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
.px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
.py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
.px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
.my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
.mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
.my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
.mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
.my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
.mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
.my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
.mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
.my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
.mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
.my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
.mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
.my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
.mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
.my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
.mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
.my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
.mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
.my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
.mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
.my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
.mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
.my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
.mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
.my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
.mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
.my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
.mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
.my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
.mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
.my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
.mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
.my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
.mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
.my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
.mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
.my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
.mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
.my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
.mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
.my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
.mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
.my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
.mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
.my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
.mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
.my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
.mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
.py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
.px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
.py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
.px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
.py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
.px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
.py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
.px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
.py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
.px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
.py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
.px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
.py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
.px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
.py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
.px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
.py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
.px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
.py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
.px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
.py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
.px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
.py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
.px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
.my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
.mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
.my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
.mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
.my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
.mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
.my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
.mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
.my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
.mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
.my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
.mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
.my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
.mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
.my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
.mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
.my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
.mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
.my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
.mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
.my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
.mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
.my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
.mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
.my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
.mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
.my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
.mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
.my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
.mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
.my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
.mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
.my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
.mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
.my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
.mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
.my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
.mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
.my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
.mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
.my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
.mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
.my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
.mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
.my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
.mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
.my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
.mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
.py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
.px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
.py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
.px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
.py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
.px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
.py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
.px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
.py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
.px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
.py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
.px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
.py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
.px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
.py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
.px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
.py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
.px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
.py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
.px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
.py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
.px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
.py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
.px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
.my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
.mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
.my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
.mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
.my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
.mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
.my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
.mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
.my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
.mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
.my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
.mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
.my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
.mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
.my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
.mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
.my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
.mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
.my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
.mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
.my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
.mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
.my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
.mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #007bff !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #0056b3 !important;
}

.text-secondary {
  color: #6c757d !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #494f54 !important;
}

.text-success {
  color: #28a745 !important;
}

a.text-success:hover, a.text-success:focus {
  color: #19692c !important;
}

.text-info {
  color: #17a2b8 !important;
}

a.text-info:hover, a.text-info:focus {
  color: #0f6674 !important;
}

.text-warning {
  color: #ffc107 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #ba8b00 !important;
}

.text-danger {
  color: #dc3545 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #a71d2a !important;
}

.text-light {
  color: #f8f9fa !important;
}

a.text-light:hover, a.text-light:focus {
  color: #cbd3da !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: #121416 !important;
}

.text-body {
  color: #212529 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
*::before,
*::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
img {
    page-break-inside: avoid;
  }
  p,
h2,
h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
.table th {
    background-color: #fff !important;
  }
  .table-bordered th,
.table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
    border-color: #dee2e6;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
  }
}
body {
  font-family: "Inter", sans-serif;
}

html {
  scroll-behavior: smooth;
}

.no-gutter[class*=col-] {
  padding: 0;
}

.link-global {
  text-decoration: none;
  font-size: 16px;
  background-color: #00A6A6;
  color: #fff;
  font-weight: 600;
  padding: 12px 20px;
  text-align: center;
  border-radius: 24px;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.link-global--block {
  display: block;
}
@media (min-width: 1200px) {
  .link-global--block {
    font-size: 16px;
    padding: 16px;
  }
}
.link-global--semi-block {
  display: block;
}
@media (min-width: 1200px) {
  .link-global--semi-block {
    font-size: 16px;
  }
}
.link-global--purple {
  background-color: #5649B3;
}
.link-global--lg {
  padding: 12px 36px;
  font-size: 16px;
}
.link-global:hover {
  opacity: 0.8;
  color: #fff;
  text-decoration: none;
}
.link-global--white {
  background-color: #fff;
  color: #362893;
}
.link-global--fade {
  background-color: #F7F5FD;
  color: #3B3187;
  font-size: 16px;
}
.link-global--fade:hover {
  opacity: 0.9;
  color: #352c78;
  text-decoration: none;
}

.container--space {
  padding: 0 40px;
}
@media (min-width: 1024px) {
  .container--shrink {
    max-width: 978px;
  }
}
.container--large {
  max-width: 1260px;
}

.global-tabs {
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  white-space: nowrap;
  scrollbar-width: thin;
}
@media (min-width: 768px) {
  .global-tabs {
    justify-content: center;
    gap: 24px;
  }
}

.global-tab {
  border: none;
  background-color: transparent;
  color: #151D28;
  border: 1px solid #C4CAD4;
  padding: 12px 20px;
}
.global-tab:hover {
  background-color: #362893;
  color: #fff;
  opacity: 0.9;
  border: 1px solid #362893;
}
@media (min-width: 1024px) {
  .global-tab {
    flex-basis: 176px;
  }
}
.global-tab--active {
  background-color: #362893;
  color: #fff;
  border: 1px solid #362893;
}

.navigation {
  position: fixed;
  z-index: 99;
  width: 100%;
  top: 0;
  right: 0;
  left: 0;
  background-color: #fff;
}
@media (min-width: 1024px) {
  .navigation {
    position: fixed;
    z-index: 99;
    width: 100%;
    top: 0;
    right: 0;
    left: 0;
    background-color: transparent;
  }
}
.navigation__logo-image {
  width: 80px;
}
@media (min-width: 1024px) {
  .navigation--sticky {
    background-color: #fff;
    transition: all ease-out 0.5s;
  }
  .navigation--sticky .navigation__link {
    color: #362893;
  }
  .navigation--sticky .navigation__popup-cta {
    background-color: #5649B3;
    color: #fff;
  }
}
.navigation__inner {
  border-bottom: 1px solid rgba(126, 138, 159, 0.24);
  padding: 24px 0;
}
@media (min-width: 1024px) {
  .navigation__inner {
    padding: 19px 0;
    border: none;
  }
}
.navigation__actions .navigation__hamburger {
  background-color: transparent;
  height: 44px;
  width: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.navigation__actions .navigation__hamburger:hover {
  background-color: #f2f2f2;
}
.navigation__popup {
  position: relative;
}
@media (min-width: 1024px) {
  .navigation__popup {
    display: none;
  }
}
.navigation__popup-item {
  gap: 16px;
}
.navigation__popup-close {
  gap: 16px;
  position: absolute;
  top: 0;
  left: 0;
}
.navigation__popup {
  padding: 13px 16px;
}
.navigation__popup-description {
  font-size: 12px;
  margin: 0;
  color: #485974;
}
.navigation__popup-description p {
  margin: 0;
}
.navigation__mobile {
  background-color: #fff;
  display: none;
  height: calc(100vh - 94px);
}
@media (min-width: 1024px) {
  .navigation__mobile {
    height: auto;
    display: flex;
    background-color: transparent;
  }
}
.navigation__mobile--desktop {
  display: block;
}
.navigation__list {
  padding: 0;
  margin: 0;
  list-style: none;
  border: 1px solid rgba(126, 138, 159, 0.24);
}
.navigation__list--mobile {
  background-color: #fff;
}
@media (min-width: 1024px) {
  .navigation__list--mobile {
    background-color: transparent;
  }
}
@media (min-width: 1024px) {
  .navigation__list {
    border: none;
    display: flex;
  }
}
.navigation__item {
  padding: 26px 15px;
}
@media (min-width: 1024px) {
  .navigation__item {
    padding: 10px 15px;
  }
}
.navigation__item--active {
  background-color: #E2DCFD;
}
@media (min-width: 1024px) {
  .navigation__item--active {
    background-color: transparent;
  }
}
.navigation__link {
  color: #362893;
  font-weight: 700;
  display: block;
  position: relative;
}
@media (min-width: 1024px) {
  .navigation__link {
    font-size: 14px;
    color: #fff;
  }
  .navigation__link:hover {
    color: #00A6A6;
    text-decoration: none;
  }
}
.navigation__link.dropdown-toggle::after {
  position: absolute;
  border: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  height: 20px;
  width: 20px;
  right: 0;
  margin: 0;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0;
}
@media (min-width: 1024px) {
  .navigation__link.dropdown-toggle::after {
    right: -28px;
  }
}
.navigation__slide {
  border-top: 1px solid rgba(126, 138, 159, 0.24);
  border-bottom: 1px solid rgba(126, 138, 159, 0.24);
  padding: 15px 0;
}
.navigation .navigation__owl img {
  aspect-ratio: 15/8;
}
.navigation .navigation__owl .owl-item.cloned {
  margin-right: 0 !important;
}
.navigation .navigation__owl .owl-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.navigation .navigation__owl .owl-dots .owl-dot span {
  width: 8px;
  height: 8px;
  background-color: #AC9AED;
  border-radius: 50%;
  display: inline-block;
}
.navigation .navigation__owl .owl-dots .owl-dot.active span {
  background-color: #2F1886;
}
.navigation__slide-title {
  color: #00A6A6;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}
.navigation__mobile-actions {
  padding: 28px 0;
  gap: 8px;
}
.navigation__mobile-actions-item {
  gap: 8px;
}
@media (min-width: 1024px) {
  .navigation .container--gap {
    gap: 32px;
  }
}

.banner-slider {
  margin-top: 93px;
}
@media (min-width: 1024px) {
  .banner-slider {
    margin-top: 0;
  }
}
.banner-slider__carousel {
  width: 100%;
  background-color: #362893;
}
.banner-slider__slide {
  padding: 18px 0;
}
@media (min-width: 1024px) {
  .banner-slider__slide {
    font-size: 48px;
    padding: 80px 0 48px 0;
  }
}
.banner-slider__title {
  font-family: "Museo Sans Rounded";
  color: #fff;
  font-weight: 900;
  font-size: 40px;
  margin-bottom: 18px;
  line-height: 48px;
}
@media (min-width: 1200px) {
  .banner-slider__title {
    font-size: 48px;
    line-height: 56px;
    margin-bottom: 48px;
  }
}
.banner-slider__description {
  font-family: "Inter";
  color: #fff;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 18px;
  letter-spacing: 0.2px;
}
@media (min-width: 1200px) {
  .banner-slider__description {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 40px;
  }
}
.banner-slider__stores {
  gap: 12px;
  margin-bottom: 16px;
}
@media (min-width: 1200px) {
  .banner-slider__stores {
    margin-bottom: 40px;
  }
}
.banner-slider__stores img {
  height: 30px;
}
@media (min-width: 1200px) {
  .banner-slider__stores img {
    height: 43px;
  }
}
.banner-slider__link {
  margin-bottom: 16px;
  flex-basis: 343px;
  display: block;
}
@media (min-width: 1200px) {
  .banner-slider__link {
    margin-bottom: 0;
    flex-basis: 258px;
  }
}
@media (min-width: 1200px) {
  .banner-slider__link-box {
    margin-bottom: 0;
  }
}
.banner-slider .owl-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-bottom: 16px;
}
.banner-slider .owl-dots .owl-dot span {
  width: 8px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.2117647059);
  border-radius: 50%;
  display: inline-block;
}
.banner-slider .owl-dots .owl-dot.active span {
  background-color: #fff;
}

.intro {
  padding: 48px 0;
  position: relative;
}
@media (min-width: 1024px) {
  .intro {
    padding-bottom: 24px;
  }
}
.intro__decal {
  position: absolute;
  right: 15%;
  top: -120px;
  z-index: 9;
}
.intro__content {
  line-height: 140%;
  font-size: 16px;
  color: #485974;
  font-weight: 400;
  letter-spacing: 0.2px;
  margin-bottom: 26px;
}
@media (min-width: 1024px) {
  .intro__content {
    max-width: 1024px;
    font-size: 20px;
    line-height: 28px;
  }
}
@media (min-width: 1024px) {
  .intro__actions {
    max-width: 185px;
    display: inline-block;
  }
  .intro__actions a {
    max-width: 185px;
    width: 185px;
    display: inline-block;
  }
}

.ventajas {
  padding: 30px 16px;
  position: relative;
}
.ventajas__decal {
  position: absolute;
  left: 15%;
  top: -92px;
  z-index: 9;
}
@media (min-width: 1024px) {
  .ventajas {
    padding: 48px 64px;
  }
}
.ventajas__box {
  background-color: #F2F2F2;
  border-radius: 16px;
  padding: 18px 16px;
}
@media (min-width: 1024px) {
  .ventajas__box {
    border-radius: 56px;
    padding: 36px;
  }
}
.ventajas__title {
  font-size: 40px;
  text-align: center;
  font-family: "Museo Sans Rounded";
  color: #362893;
  font-weight: 900;
  line-height: 48px;
}
@media (min-width: 1024px) {
  .ventajas__title {
    margin-bottom: 16px;
  }
  .ventajas__title br {
    display: none;
  }
}
.ventajas__subtitle {
  font-size: 16px;
  text-align: center;
  font-family: "Inter";
  color: #485974;
  font-weight: 400;
}
@media (min-width: 1024px) {
  .ventajas__subtitle {
    font-size: 20px;
  }
}
.ventajas__item {
  margin-bottom: 28px;
  gap: 30px;
}
.ventajas__item-title {
  font-size: 18px;
  font-weight: 700;
  font-family: "Museo Sans Rounded";
  color: #362893;
  margin-bottom: 8px;
}
@media (min-width: 1024px) {
  .ventajas__item-title {
    margin-bottom: 12px;
    font-size: 24px;
  }
}
.ventajas__item-subtitle {
  color: #485974;
  line-height: 140%;
  letter-spacing: 0.2px;
  font-size: 16px;
  margin-bottom: 0;
}
@media (min-width: 1024px) {
  .ventajas__item-subtitle {
    font-size: 20px;
  }
}
@media (min-width: 1024px) {
  .ventajas__item-image {
    margin-bottom: 28px;
    width: 160px;
  }
}
@media (min-width: 1024px) {
  .ventajas__item-box {
    margin-bottom: 80px;
  }
  .ventajas__item-box:last-of-type {
    margin-bottom: 0;
  }
}

.unete {
  padding: 32px 0;
}
.unete__image img {
  width: 100%;
}
.unete__title {
  font-size: 40px;
  text-align: center;
  font-family: "Museo Sans Rounded";
  color: #362893;
  font-weight: 900;
  line-height: 48px;
  margin-bottom: 16px;
}
@media (min-width: 1024px) {
  .unete__title {
    margin-bottom: 16px;
  }
  .unete__title br {
    display: none;
  }
}
.unete__intro {
  color: #485974;
  font-family: "Inter";
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 36px;
}
@media (min-width: 1024px) {
  .unete__intro br {
    display: none;
  }
}
.unete__steps {
  list-style: none;
  padding: 0;
  margin-bottom: 32px;
}
@media (min-width: 1200px) {
  .unete__steps {
    padding-right: 54px;
  }
}
.unete__step {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 24px;
}
@media (min-width: 1200px) {
  .unete__step {
    margin-bottom: 32px;
    gap: 32px;
  }
}
.unete__step:last-of-type {
  margin-bottom: 0;
}
.unete__step-number {
  width: 32px;
  height: 32px;
  background-color: #362893;
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-weight: 800;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-family: "Museo Sans Rounded";
  font-size: 22px;
}
.unete__description {
  line-height: 140%;
  color: #485974;
  letter-spacing: 0.2px;
  font-weight: 400;
  margin-bottom: 32px;
}
.unete__step-title {
  font-size: 16px;
  font-weight: 600;
  font-family: "Inter";
  line-height: 140%;
  margin-bottom: 0;
  color: #485974;
  letter-spacing: 0.2px;
}
.unete__step-text {
  line-height: 140%;
  margin-bottom: 0;
  color: #485974;
  letter-spacing: 0.2px;
  font-weight: 400;
}
@media (min-width: 1200px) {
  .unete__step-text {
    line-height: 28px;
  }
}

.beneficios {
  position: relative;
  background: linear-gradient(to bottom, #9A7FF6, #2F1886);
  padding: 48px 0;
}
@media (min-width: 1200px) {
  .beneficios {
    padding: 84px 0;
  }
}
@media (min-width: 1024px) {
  .beneficios__header {
    padding: 14px 0;
  }
}
@media (min-width: 1200px) {
  .beneficios__header {
    display: flex;
    flex: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
.beneficios__titulo {
  color: #fff;
  font-family: "Museo Sans Rounded";
  font-weight: 900;
  line-height: 44px;
  font-size: 36px;
  margin-bottom: 20px;
}
.beneficios__subtitulo {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 28px;
}
@media (min-width: 1024px) {
  .beneficios__subtitulo {
    margin-bottom: 0;
  }
}
.beneficios__grid {
  display: flex;
  flex-wrap: wrap;
}
.beneficios__item {
  width: 50%;
}
.beneficios__item[class*=col-] {
  padding: 4px;
}
@media (min-width: 1200px) {
  .beneficios__item[class*=col-] {
    padding: 13px;
  }
}
.beneficios__card {
  background-color: #fff;
  border-radius: 20px;
  aspect-ratio: 1;
  text-align: center;
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  overflow: hidden;
  position: relative;
}
@media (min-width: 1200px) {
  .beneficios__card {
    aspect-ratio: 21/23;
    padding: 16px;
  }
}
.beneficios__icono {
  margin-bottom: 16px;
}
.beneficios__item-titulo {
  font-family: "Museo Sans Rounded";
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: #485974;
  margin: 0;
  width: 100%;
}
.beneficios__item-titulo--flipped {
  color: #fff;
  margin-bottom: 12px;
}
@media (min-width: 1200px) {
  .beneficios__item-titulo {
    font-size: 22px;
  }
}
.beneficios__descripcion {
  position: absolute;
  inset: 0;
  align-content: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  background-color: #362893;
  color: #fff;
  font-size: 12px;
  border-radius: 18px;
  margin: 0;
  transform: translateY(12px);
}
@media (min-width: 1200px) {
  .beneficios__descripcion {
    font-size: 16px;
  }
}
.beneficios__card:hover {
  background-color: #362893;
}
.beneficios__card:hover .beneficios__descripcion {
  opacity: 1;
  transform: translateY(0);
  display: block;
}
.beneficios__decal {
  position: absolute;
  left: 10%;
  top: -92px;
  z-index: 9;
}

.activar {
  padding: 48px 0;
  scroll-margin-top: 86px;
}
@media (min-width: 1024px) {
  .activar__intro {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.activar__title {
  font-family: "Museo Sans Rounded";
  color: #362893;
  font-weight: 900;
  font-size: 36px;
  margin-bottom: 18px;
  line-height: 48px;
}
@media (min-width: 1024px) {
  .activar__title {
    text-align: center;
    padding: 0 164px;
  }
}
@media (min-width: 1200px) {
  .activar__title {
    font-size: 48px;
    line-height: 56px;
    margin-bottom: 48px;
  }
}
.activar__description {
  font-size: 16px;
  font-weight: 400;
  color: #485974;
  margin-bottom: 32px;
  text-align: center;
}
.activar__overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.46) 100%);
}
@media (min-width: 1024px) {
  .activar__overlay {
    background: linear-gradient(188.33deg, rgba(0, 0, 0, 0.162) 56.32%, rgba(0, 0, 0, 0.7128) 112.93%);
  }
}
.activar__box-step {
  border-radius: 32px;
  width: 100%;
  margin-bottom: 16px;
  aspect-ratio: 3/2;
  display: flex;
  position: relative;
  padding: 34px 26px;
  align-items: flex-end;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  background-color: #00A6A6;
  position: relative;
  overflow: hidden;
}
@media (min-width: 1024px) {
  .activar__box-step {
    margin-bottom: 0;
    aspect-ratio: 1;
    background-size: cover;
    background-repeat: no-repeat;
  }
}
.activar__step-text {
  color: #fff;
  font-size: "Museo Sans Rounded";
  font-weight: 600;
  font-size: 18px;
  position: relative;
  z-index: 2;
}
.activar__step-text p {
  margin-bottom: 0;
}
@media (min-width: 1024px) {
  .activar__step-text {
    margin-bottom: 0;
    background-position: right;
  }
  .activar__step-text br {
    display: none;
  }
}

#negocio-1 {
  scroll-margin-top: 92px;
}

#negocio-2 {
  scroll-margin-top: 92px;
}

.negocio {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-position: center;
  background-repeat: no-repeat;
  padding: 24px 12px;
  scroll-margin-top: 86px;
}
@media (min-width: 1024px) {
  .negocio {
    padding: 80px 0;
  }
}
.negocio__slide {
  background-color: #fff;
  height: 100%;
  border-radius: 40px;
}
@media (min-width: 1024px) {
  .negocio__slide {
    margin-bottom: 40px;
  }
  .negocio__slide:last-of-type {
    margin-bottom: 0;
  }
}
.negocio .owl-item {
  padding: 0 8px;
}
.negocio__img {
  width: 100%;
  aspect-ratio: 1;
}
.negocio__body {
  padding: 16px;
  padding-top: 0;
}
@media (min-width: 1024px) {
  .negocio__body {
    padding: 80px 60px;
  }
}
.negocio__title {
  font-family: "Museo Sans Rounded";
  font-weight: 600;
  font-style: 700;
  font-size: 40px;
  line-height: 48px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #362893;
  margin-bottom: 24px;
}
.negocio__text {
  font-family: "Inter";
  font-weight: 400;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 28px;
  letter-spacing: 0%;
  color: #485974;
  margin-bottom: 24px;
}
.negocio__text ul {
  padding-left: 20px;
}
@media (min-width: 1024px) {
  .negocio__cta {
    max-width: 185px;
    width: 185px;
    display: inline-block;
  }
}
.negocio .owl-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-bottom: 16px;
}
.negocio .owl-dots .owl-dot span {
  width: 8px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.2117647059);
  border-radius: 50%;
  display: inline-block;
}
.negocio .owl-dots .owl-dot.active span {
  background-color: #fff;
}

.testimonios {
  background-color: #fff;
  padding: 38px 0;
}
@media (min-width: 1024px) {
  .testimonios {
    font-size: 48px;
    padding: 80px 0;
  }
}
.testimonios__title {
  font-size: 40px;
  text-align: center;
  font-family: "Museo Sans Rounded";
  color: #362893;
  font-weight: 900;
  line-height: 48px;
  margin-bottom: 16px;
}
@media (min-width: 1024px) {
  .testimonios__title {
    margin-bottom: 16px;
    margin-bottom: 56px;
  }
  .testimonios__title br {
    display: none;
  }
}
.testimonios__slide {
  font-family: "Inter";
  border-radius: 12px;
  opacity: 1;
  padding: 28px 16px;
  background-color: #DCD9F2;
}
.testimonios__slide--par {
  background-color: #28205A;
}
.testimonios__slide--par .testimonios__comentario {
  color: #fff;
}
.testimonios__slide--par .testimonios__autor {
  color: #fff;
}
@media (min-width: 1024px) {
  .testimonios__slide {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
  }
}
.testimonios__comentario {
  color: #151D28;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  font-family: "Inter";
}
.testimonios__comentario--impar {
  color: #fff;
}
.testimonios__cita {
  width: 12px !important;
  margin-bottom: 8px;
  font-size: 12px;
}
@media (min-width: 1024px) {
  .testimonios__cita {
    width: 24px !important;
  }
}
.testimonios__autor {
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  font-family: "Inter";
  color: #362893;
  margin: 0;
}
.testimonios__autor--impar {
  color: #fff;
}
.testimonios .owl-stage {
  display: flex;
  align-items: center;
}
.testimonios .owl-item {
  height: 100%;
}
.testimonios .owl-item.center {
  height: calc(100% + 24px);
  opacity: 1;
  transition: all ease-out 0.5s;
}
.testimonios .owl-item.center .testimonios__slide {
  padding: 48px 16px;
}

.descarga {
  padding: 48px 0;
  background-color: #5649B3;
  padding-bottom: 0;
}
@media (min-width: 1024px) {
  .descarga {
    padding: 48px 0;
    padding-bottom: 48px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    background-size: 50%;
    background-position: right;
    background-repeat: no-repeat;
  }
}
@media (min-width: 1200px) {
  .descarga {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    background-size: 50%;
    background-position: right;
    background-repeat: no-repeat;
    padding: 148px 0;
  }
}
.descarga__title {
  font-family: "Museo Sans Rounded";
  color: #fff;
  font-weight: 900;
  font-size: 36px;
  margin-bottom: 18px;
  line-height: 48px;
}
@media (min-width: 1200px) {
  .descarga__title {
    font-size: 48px;
    line-height: 56px;
    margin-bottom: 48px;
  }
}
.descarga__description {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  margin-bottom: 32px;
}
@media (min-width: 1024px) {
  .descarga__description {
    font-size: 20px;
    line-height: 30px;
  }
}
.descarga__image {
  width: 100%;
  margin-top: 32px;
}
.descarga__stores {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.descarga__store {
  display: inline-block;
  transition: transform 0.2s ease;
}
.descarga__store:hover {
  transform: scale(1.05);
}
.descarga__store-img {
  height: 48px;
  display: block;
}

.preguntas {
  padding: 80px 0;
  scroll-margin-top: 86px;
}
@media (min-width: 992px) {
  .preguntas {
    margin-bottom: 0;
    padding-right: 40px;
  }
}
.preguntas__info {
  margin-bottom: 32px;
}
@media (min-width: 992px) {
  .preguntas__info {
    margin-bottom: 0;
    padding-right: 40px;
  }
}
.preguntas__title {
  font-family: "Museo Sans Rounded";
  color: #362893;
  font-weight: 900;
  font-size: 36px;
  margin-bottom: 18px;
  line-height: 48px;
}
@media (min-width: 1200px) {
  .preguntas__title {
    font-size: 41px;
    line-height: 56px;
  }
}
.preguntas__description {
  margin-bottom: 20px;
}
.preguntas__link {
  display: inline-block;
  font-weight: 600;
}
.preguntas__item {
  border-bottom: 1px solid #eee;
  padding: 12px 0;
}
.preguntas__question {
  width: 100%;
  background: none;
  border: 0;
  text-align: left;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 0;
  font-size: 18px;
  color: #151D28;
}
.preguntas__answer {
  margin-top: 8px;
  color: #485974;
  font-size: 16px;
}
.preguntas__question {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 14px 0;
  font-weight: 600;
}
.preguntas__chevron {
  width: 24px;
  height: 24px;
  transition: transform 0.25s ease;
}
.preguntas__item.is-open .preguntas__chevron {
  transform: rotate(180deg);
}

.footer {
  background-color: #3B3187;
  color: #fff;
}
.footer__top {
  padding: 64px 0;
}
.footer__bottom {
  border-top: 1px solid rgba(241, 241, 241, 0.4823529412);
  padding: 36px 0;
}
.footer__brand {
  margin-bottom: 32px;
}
.footer__logo {
  margin-bottom: 32px;
}
.footer__stores {
  display: flex;
  gap: 16px;
}
@media (min-width: 1024px) {
  .footer__stores {
    flex-wrap: wrap;
  }
}
.footer__store-img {
  width: 75px;
}
@media (min-width: 1024px) {
  .footer__store-img {
    flex-basis: 1;
    width: 135px;
  }
}
.footer__legales {
  margin-bottom: 50px;
}
@media (min-width: 1024px) {
  .footer__legales {
    margin-bottom: 0;
  }
}
.footer__contact {
  margin-bottom: 50px;
}
@media (min-width: 1024px) {
  .footer__contact {
    margin-bottom: 0;
  }
}
.footer__title {
  font-size: 14px;
}
.footer__list {
  padding: 0;
  list-style: none;
}
.footer__item {
  font-weight: 600;
  color: #fff;
  margin-bottom: 12px;
}
.footer__item:last-of-type {
  margin-bottom: 0;
}
.footer__link {
  color: #fff;
}
.footer__link:hover {
  color: #fff;
  opacity: 0.9;
}
.footer__contact-link {
  color: #fff;
  display: flex;
  gap: 12px;
}
.footer__contact-link:hover {
  color: #fff;
  opacity: 0.9;
}
.footer__social {
  display: flex;
  gap: 24px;
}
.footer__disclaimer {
  margin-bottom: 32px;
}
@media (min-width: 1024px) {
  .footer__disclaimer {
    margin-bottom: 0;
  }
}
.toke-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toke-modal__overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}

.toke-modal__container {
  position: relative;
  z-index: 1;
  width: 90%;
  max-width: 500px;
  padding: 48px;
  background: #fff;
  border-radius: 48px;
  text-align: center;
}

.toke-modal__title {
  margin: 0 0 12px;
  font-size: 40px;
  font-weight: 900;
  font-family: "Museo Sans Rounded";
}

.toke-modal__subtitle {
  margin: 0 0 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
}

.toke-modal__qr {
  display: flex;
  justify-content: center;
}

.toke-modal__qr-image {
  width: 180px;
  max-width: 100%;
  height: auto;
}

.toke-modal__close {
  position: absolute;
  top: 12px;
  right: 24px;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.toke-modal__close::before {
  content: "✕";
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/_variables.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/styles/_custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACoBhB;EACI,oBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADhBJ;ACmBA;EACI,oBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADjBJ;ACoBA;EACI,oBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADlBJ;ACqBA,eAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADnBJ;ACsBA,gBAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADpBJ;ACuBA,iBAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADrBJ;ACwBA,eAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADtBJ;ACyBA,gBAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADvBJ;AC0BA,yBAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ADxBJ;AEvEA;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,kOAAA;EACA,6GAAA;AH0FF;;AIzFA;;;EAGE,sBAAA;AJ4FF;;AIzFA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AJ4FF;;AItFA;EACE,cAAA;AJyFF;;AI/EA;EACE,SAAA;EACA,qNCsO4B;ECjGxB,eAAA;EFnIJ,gBC+O4B;ED9O5B,gBCmP4B;EDlP5B,cCnCS;EDoCT,gBAAA;EACA,sBC9CS;ALgIX;;AItEA;EACE,qBAAA;AJyEF;;AIhEA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AJmEF;;AItDA;EACE,aAAA;EACA,qBCiN4B;ALxJ9B;;AIlDA;EACE,aAAA;EACA,mBCoF0B;AL/B5B;;AI1CA;;EAEE,0BAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AJ6CF;;AI1CA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJ6CF;;AI1CA;;;EAGE,aAAA;EACA,mBAAA;AJ6CF;;AI1CA;;;;EAIE,gBAAA;AJ6CF;;AI1CA;EACE,gBCkJ4B;ALrG9B;;AI1CA;EACE,qBAAA;EACA,cAAA;AJ6CF;;AI1CA;EACE,gBAAA;AJ6CF;;AI1CA;;EAEE,mBCqI4B;ALxF9B;;AI1CA;EEII,cAAA;AN0CJ;;AIrCA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;AJwCF;;AIrCA;EAAM,eAAA;AJyCN;;AIxCA;EAAM,WAAA;AJ4CN;;AIrCA;EACE,cCXwC;EDYxC,qBCXwC;EDYxC,6BAAA;AJwCF;AOxNE;EHmLE,cCdsC;EDetC,0BCdsC;ALsD1C;;AI/BA;EACE,cAAA;EACA,qBAAA;AJkCF;AOjOE;EHkME,cAAA;EACA,qBAAA;AJkCJ;;AIzBA;;;;EAIE,iGC0D4B;EClH1B,cAAA;ANqFJ;;AIzBA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AJuBF;;AIfA;EAEE,gBAAA;AJiBF;;AITA;EACE,sBAAA;EACA,kBAAA;AJYF;;AITA;EAGE,gBAAA;EACA,sBAAA;AJUF;;AIFA;EACE,yBAAA;AJKF;;AIFA;EACE,oBC8E4B;ED7E5B,uBC6E4B;ED5E5B,cCtQS;EDuQT,gBAAA;EACA,oBAAA;AJKF;;AIEA;EAEE,mBAAA;EACA,gCAAA;AJAF;;AIQA;EAEE,qBAAA;EACA,qBC4JsC;ALlKxC;;AIYA;EAEE,gBAAA;AJVF;;AIkBA;EACE,UAAA;AJfF;;AIkBA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AJfF;;AIkBA;;EAEE,iBAAA;AJfF;;AIkBA;;EAEE,oBAAA;AJfF;;AIqBA;EACE,eAAA;AJlBF;;AIwBA;EACE,iBAAA;AJrBF;;AI4BA;;;;EAIE,0BAAA;AJzBF;;AIkCI;;;;EACE,eAAA;AJ5BN;;AIkCA;;;;EAIE,UAAA;EACA,kBAAA;AJ/BF;;AIkCA;;EAEE,sBAAA;EACA,UAAA;AJ/BF;;AImCA;EACE,cAAA;EAEA,gBAAA;AJjCF;;AIoCA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AJvCF;;AI4CA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE9OI,iBAAA;EFgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AJzCF;;AI4CA;EACE,wBAAA;AJzCF;;AI6CA;;EAEE,YAAA;AJ1CF;;AI6CA;EAKE,oBAAA;EACA,wBAAA;AJ9CF;;AIqDA;EACE,wBAAA;AJlDF;;AI0DA;EACE,aAAA;EACA,0BAAA;AJvDF;;AI8DA;EACE,qBAAA;AJ3DF;;AI8DA;EACE,kBAAA;EACA,eAAA;AJ3DF;;AI8DA;EACE,aAAA;AJ3DF;;AIgEA;EACE,wBAAA;AJ7DF;;AQ/ZA;;EAEE,qBHsS4B;EGpS5B,gBHsS4B;EGrS5B,gBHsS4B;AL2H9B;;AQ7ZA;EFqKM,iBAAA;AN4PN;;AQhaA;EFoKM,eAAA;ANgQN;;AQnaA;EFmKM,kBAAA;ANoQN;;AQtaA;EFkKM,iBAAA;ANwQN;;AQzaA;EFiKM,kBAAA;AN4QN;;AQ5aA;EFgKM,eAAA;ANgRN;;AQ9aA;EF8JM,kBAAA;EE5JJ,gBHwS4B;ALyI9B;;AQ7aA;EFwJM,eAAA;EEtJJ,gBH2R4B;EG1R5B,gBHkR4B;AL8J9B;;AQ9aA;EFmJM,iBAAA;EEjJJ,gBHuR4B;EGtR5B,gBH6Q4B;ALoK9B;;AQ/aA;EF8IM,iBAAA;EE5IJ,gBHmR4B;EGlR5B,gBHwQ4B;AL0K9B;;AQhbA;EFyIM,iBAAA;EEvIJ,gBH+Q4B;EG9Q5B,gBHmQ4B;ALgL9B;;AQ3aA;EACE,gBHgFO;EG/EP,mBH+EO;EG9EP,SAAA;EACA,wCAAA;AR8aF;;AQtaA;;EFkGI,kBAAA;EE/FF,gBH2N4B;AL8M9B;;AQtaA;;EAEE,cHmQ4B;EGlQ5B,yBH2Q4B;AL8J9B;;AQjaA;EC/EE,eAAA;EACA,gBAAA;ATofF;;AQjaA;ECpFE,eAAA;EACA,gBAAA;ATyfF;;AQnaA;EACE,qBAAA;ARsaF;AQpaE;EACE,oBHqP0B;ALiL9B;;AQ5ZA;EF2DI,cAAA;EEzDF,yBAAA;AR+ZF;;AQ3ZA;EACE,mBHuBO;EC6CH,kBAAA;AN2VN;;AQ3ZA;EACE,cAAA;EF+CE,kBAAA;EE7CF,cH1GS;ALwgBX;AQ5ZE;EACE,aAAA;AR8ZJ;;AUjhBA;ECIE,eAAA;EAGA,YAAA;AX+gBF;;AUhhBA;EACE,gBLqgCkC;EKpgClC,sBLRS;EKST,yBAAA;EEEE,sBAAA;EDPF,eAAA;EAGA,YAAA;AXwhBF;;AU1gBA;EAEE,qBAAA;AV4gBF;;AUzgBA;EACE,qBAAA;EACA,cAAA;AV4gBF;;AUzgBA;EJ8HI,cAAA;EI5HF,cL3BS;ALuiBX;;AanjBA;EPmKI,gBAAA;EOjKF,cRmCQ;EQlCR,qBAAA;AbsjBF;AanjBE;EACE,cAAA;AbqjBJ;;AahjBA;EACE,sBAAA;EPsJE,gBAAA;EOpJF,WRTS;EQUT,yBRDS;EOEP,qBAAA;AZmjBJ;AahjBE;EACE,UAAA;EP8IA,eAAA;EO5IA,gBRyQ0B;ALyS9B;;Aa5iBA;EACE,cAAA;EPqIE,gBAAA;EOnIF,cRjBS;ALgkBX;Aa5iBE;EPgIE,kBAAA;EO9HA,cAAA;EACA,kBAAA;Ab8iBJ;;AaziBA;EACE,iBRikCkC;EQhkClC,kBAAA;Ab4iBF;;AcplBE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Af8lBF;;AgB3iBI;EFzCE;IACE,gBT8Le;EL0ZrB;AACF;AgBjjBI;EFzCE;IACE,gBT8Le;EL+ZrB;AACF;AgBtjBI;EFzCE;IACE,gBT8Le;ELoarB;AACF;AgB3jBI;EFzCE;IACE,iBT8Le;ELyarB;AACF;Ac5kBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AfknBF;;Ac5kBE;EACE,eAAA;EACA,cAAA;Ad+kBJ;Ac7kBI;;EAEE,gBAAA;EACA,eAAA;Ad+kBN;;AiBroBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AjB6oBJ;;AiBvnBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AjB0nBR;;Ae9lBE;EACE,cAAA;EACA,eAAA;AfimBJ;;AenmBE;EACE,aAAA;EACA,cAAA;AfsmBJ;;AexmBE;EACE,wBAAA;EACA,yBAAA;Af2mBJ;;Ae7mBE;EACE,aAAA;EACA,cAAA;AfgnBJ;;AelnBE;EACE,aAAA;EACA,cAAA;AfqnBJ;;AevnBE;EACE,wBAAA;EACA,yBAAA;Af0nBJ;;AiB7oBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;AfgpBF;;AiB7oBU;EFbR,qBAAA;EAIA,sBAAA;Af2pBF;;AiBlpBU;EFbR,sBAAA;EAIA,uBAAA;AfgqBF;;AiBvpBU;EFbR,aAAA;EAIA,cAAA;AfqqBF;;AiB5pBU;EFbR,sBAAA;EAIA,uBAAA;Af0qBF;;AiBjqBU;EFbR,sBAAA;EAIA,uBAAA;Af+qBF;;AiBtqBU;EFbR,aAAA;EAIA,cAAA;AforBF;;AiB3qBU;EFbR,sBAAA;EAIA,uBAAA;AfyrBF;;AiBhrBU;EFbR,sBAAA;EAIA,uBAAA;Af8rBF;;AiBrrBU;EFbR,aAAA;EAIA,cAAA;AfmsBF;;AiB1rBU;EFbR,sBAAA;EAIA,uBAAA;AfwsBF;;AiB/rBU;EFbR,sBAAA;EAIA,uBAAA;Af6sBF;;AiBpsBU;EFbR,cAAA;EAIA,eAAA;AfktBF;;AiBnsBM;EAAwB,SAAA;AjBusB9B;;AiBrsBM;EAAuB,SAAA;AjBysB7B;;AiBtsBQ;EAAwB,QADb;AjB2sBnB;;AiB1sBQ;EAAwB,QADb;AjB+sBnB;;AiB9sBQ;EAAwB,QADb;AjBmtBnB;;AiBltBQ;EAAwB,QADb;AjButBnB;;AiBttBQ;EAAwB,QADb;AjB2tBnB;;AiB1tBQ;EAAwB,QADb;AjB+tBnB;;AiB9tBQ;EAAwB,QADb;AjBmuBnB;;AiBluBQ;EAAwB,QADb;AjBuuBnB;;AiBtuBQ;EAAwB,QADb;AjB2uBnB;;AiB1uBQ;EAAwB,QADb;AjB+uBnB;;AiB9uBQ;EAAwB,SADb;AjBmvBnB;;AiBlvBQ;EAAwB,SADb;AjBuvBnB;;AiBtvBQ;EAAwB,SADb;AjB2vBnB;;AiBnvBY;EFhBV,wBAAA;AfuwBF;;AiBvvBY;EFhBV,yBAAA;Af2wBF;;AiB3vBY;EFhBV,gBAAA;Af+wBF;;AiB/vBY;EFhBV,yBAAA;AfmxBF;;AiBnwBY;EFhBV,yBAAA;AfuxBF;;AiBvwBY;EFhBV,gBAAA;Af2xBF;;AiB3wBY;EFhBV,yBAAA;Af+xBF;;AiB/wBY;EFhBV,yBAAA;AfmyBF;;AiBnxBY;EFhBV,gBAAA;AfuyBF;;AiBvxBY;EFhBV,yBAAA;Af2yBF;;AiB3xBY;EFhBV,yBAAA;Af+yBF;;AgB1yBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBy0BN;Ee7yBA;IACE,cAAA;IACA,eAAA;Ef+yBF;EejzBA;IACE,aAAA;IACA,cAAA;EfmzBF;EerzBA;IACE,wBAAA;IACA,yBAAA;EfuzBF;EezzBA;IACE,aAAA;IACA,cAAA;Ef2zBF;Ee7zBA;IACE,aAAA;IACA,cAAA;Ef+zBF;Eej0BA;IACE,wBAAA;IACA,yBAAA;Efm0BF;EiBt1BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Efw1BA;EiBr1BQ;IFbR,qBAAA;IAIA,sBAAA;Efk2BA;EiBz1BQ;IFbR,sBAAA;IAIA,uBAAA;Efs2BA;EiB71BQ;IFbR,aAAA;IAIA,cAAA;Ef02BA;EiBj2BQ;IFbR,sBAAA;IAIA,uBAAA;Ef82BA;EiBr2BQ;IFbR,sBAAA;IAIA,uBAAA;Efk3BA;EiBz2BQ;IFbR,aAAA;IAIA,cAAA;Efs3BA;EiB72BQ;IFbR,sBAAA;IAIA,uBAAA;Ef03BA;EiBj3BQ;IFbR,sBAAA;IAIA,uBAAA;Ef83BA;EiBr3BQ;IFbR,aAAA;IAIA,cAAA;Efk4BA;EiBz3BQ;IFbR,sBAAA;IAIA,uBAAA;Efs4BA;EiB73BQ;IFbR,sBAAA;IAIA,uBAAA;Ef04BA;EiBj4BQ;IFbR,cAAA;IAIA,eAAA;Ef84BA;EiB/3BI;IAAwB,SAAA;EjBk4B5B;EiBh4BI;IAAuB,SAAA;EjBm4B3B;EiBh4BM;IAAwB,QADb;EjBo4BjB;EiBn4BM;IAAwB,QADb;EjBu4BjB;EiBt4BM;IAAwB,QADb;EjB04BjB;EiBz4BM;IAAwB,QADb;EjB64BjB;EiB54BM;IAAwB,QADb;EjBg5BjB;EiB/4BM;IAAwB,QADb;EjBm5BjB;EiBl5BM;IAAwB,QADb;EjBs5BjB;EiBr5BM;IAAwB,QADb;EjBy5BjB;EiBx5BM;IAAwB,QADb;EjB45BjB;EiB35BM;IAAwB,QADb;EjB+5BjB;EiB95BM;IAAwB,SADb;EjBk6BjB;EiBj6BM;IAAwB,SADb;EjBq6BjB;EiBp6BM;IAAwB,SADb;EjBw6BjB;EiBh6BU;IFhBV,cAAA;Efm7BA;EiBn6BU;IFhBV,wBAAA;Efs7BA;EiBt6BU;IFhBV,yBAAA;Efy7BA;EiBz6BU;IFhBV,gBAAA;Ef47BA;EiB56BU;IFhBV,yBAAA;Ef+7BA;EiB/6BU;IFhBV,yBAAA;Efk8BA;EiBl7BU;IFhBV,gBAAA;Efq8BA;EiBr7BU;IFhBV,yBAAA;Efw8BA;EiBx7BU;IFhBV,yBAAA;Ef28BA;EiB37BU;IFhBV,gBAAA;Ef88BA;EiB97BU;IFhBV,yBAAA;Efi9BA;EiBj8BU;IFhBV,yBAAA;Efo9BA;AACF;AgBh9BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjB8+BN;Eel9BA;IACE,cAAA;IACA,eAAA;Efo9BF;Eet9BA;IACE,aAAA;IACA,cAAA;Efw9BF;Ee19BA;IACE,wBAAA;IACA,yBAAA;Ef49BF;Ee99BA;IACE,aAAA;IACA,cAAA;Efg+BF;Eel+BA;IACE,aAAA;IACA,cAAA;Efo+BF;Eet+BA;IACE,wBAAA;IACA,yBAAA;Efw+BF;EiB3/BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ef6/BA;EiB1/BQ;IFbR,qBAAA;IAIA,sBAAA;EfugCA;EiB9/BQ;IFbR,sBAAA;IAIA,uBAAA;Ef2gCA;EiBlgCQ;IFbR,aAAA;IAIA,cAAA;Ef+gCA;EiBtgCQ;IFbR,sBAAA;IAIA,uBAAA;EfmhCA;EiB1gCQ;IFbR,sBAAA;IAIA,uBAAA;EfuhCA;EiB9gCQ;IFbR,aAAA;IAIA,cAAA;Ef2hCA;EiBlhCQ;IFbR,sBAAA;IAIA,uBAAA;Ef+hCA;EiBthCQ;IFbR,sBAAA;IAIA,uBAAA;EfmiCA;EiB1hCQ;IFbR,aAAA;IAIA,cAAA;EfuiCA;EiB9hCQ;IFbR,sBAAA;IAIA,uBAAA;Ef2iCA;EiBliCQ;IFbR,sBAAA;IAIA,uBAAA;Ef+iCA;EiBtiCQ;IFbR,cAAA;IAIA,eAAA;EfmjCA;EiBpiCI;IAAwB,SAAA;EjBuiC5B;EiBriCI;IAAuB,SAAA;EjBwiC3B;EiBriCM;IAAwB,QADb;EjByiCjB;EiBxiCM;IAAwB,QADb;EjB4iCjB;EiB3iCM;IAAwB,QADb;EjB+iCjB;EiB9iCM;IAAwB,QADb;EjBkjCjB;EiBjjCM;IAAwB,QADb;EjBqjCjB;EiBpjCM;IAAwB,QADb;EjBwjCjB;EiBvjCM;IAAwB,QADb;EjB2jCjB;EiB1jCM;IAAwB,QADb;EjB8jCjB;EiB7jCM;IAAwB,QADb;EjBikCjB;EiBhkCM;IAAwB,QADb;EjBokCjB;EiBnkCM;IAAwB,SADb;EjBukCjB;EiBtkCM;IAAwB,SADb;EjB0kCjB;EiBzkCM;IAAwB,SADb;EjB6kCjB;EiBrkCU;IFhBV,cAAA;EfwlCA;EiBxkCU;IFhBV,wBAAA;Ef2lCA;EiB3kCU;IFhBV,yBAAA;Ef8lCA;EiB9kCU;IFhBV,gBAAA;EfimCA;EiBjlCU;IFhBV,yBAAA;EfomCA;EiBplCU;IFhBV,yBAAA;EfumCA;EiBvlCU;IFhBV,gBAAA;Ef0mCA;EiB1lCU;IFhBV,yBAAA;Ef6mCA;EiB7lCU;IFhBV,yBAAA;EfgnCA;EiBhmCU;IFhBV,gBAAA;EfmnCA;EiBnmCU;IFhBV,yBAAA;EfsnCA;EiBtmCU;IFhBV,yBAAA;EfynCA;AACF;AgBrnCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBmpCN;EevnCA;IACE,cAAA;IACA,eAAA;EfynCF;Ee3nCA;IACE,aAAA;IACA,cAAA;Ef6nCF;Ee/nCA;IACE,wBAAA;IACA,yBAAA;EfioCF;EenoCA;IACE,aAAA;IACA,cAAA;EfqoCF;EevoCA;IACE,aAAA;IACA,cAAA;EfyoCF;Ee3oCA;IACE,wBAAA;IACA,yBAAA;Ef6oCF;EiBhqCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfkqCA;EiB/pCQ;IFbR,qBAAA;IAIA,sBAAA;Ef4qCA;EiBnqCQ;IFbR,sBAAA;IAIA,uBAAA;EfgrCA;EiBvqCQ;IFbR,aAAA;IAIA,cAAA;EforCA;EiB3qCQ;IFbR,sBAAA;IAIA,uBAAA;EfwrCA;EiB/qCQ;IFbR,sBAAA;IAIA,uBAAA;Ef4rCA;EiBnrCQ;IFbR,aAAA;IAIA,cAAA;EfgsCA;EiBvrCQ;IFbR,sBAAA;IAIA,uBAAA;EfosCA;EiB3rCQ;IFbR,sBAAA;IAIA,uBAAA;EfwsCA;EiB/rCQ;IFbR,aAAA;IAIA,cAAA;Ef4sCA;EiBnsCQ;IFbR,sBAAA;IAIA,uBAAA;EfgtCA;EiBvsCQ;IFbR,sBAAA;IAIA,uBAAA;EfotCA;EiB3sCQ;IFbR,cAAA;IAIA,eAAA;EfwtCA;EiBzsCI;IAAwB,SAAA;EjB4sC5B;EiB1sCI;IAAuB,SAAA;EjB6sC3B;EiB1sCM;IAAwB,QADb;EjB8sCjB;EiB7sCM;IAAwB,QADb;EjBitCjB;EiBhtCM;IAAwB,QADb;EjBotCjB;EiBntCM;IAAwB,QADb;EjButCjB;EiBttCM;IAAwB,QADb;EjB0tCjB;EiBztCM;IAAwB,QADb;EjB6tCjB;EiB5tCM;IAAwB,QADb;EjBguCjB;EiB/tCM;IAAwB,QADb;EjBmuCjB;EiBluCM;IAAwB,QADb;EjBsuCjB;EiBruCM;IAAwB,QADb;EjByuCjB;EiBxuCM;IAAwB,SADb;EjB4uCjB;EiB3uCM;IAAwB,SADb;EjB+uCjB;EiB9uCM;IAAwB,SADb;EjBkvCjB;EiB1uCU;IFhBV,cAAA;Ef6vCA;EiB7uCU;IFhBV,wBAAA;EfgwCA;EiBhvCU;IFhBV,yBAAA;EfmwCA;EiBnvCU;IFhBV,gBAAA;EfswCA;EiBtvCU;IFhBV,yBAAA;EfywCA;EiBzvCU;IFhBV,yBAAA;Ef4wCA;EiB5vCU;IFhBV,gBAAA;Ef+wCA;EiB/vCU;IFhBV,yBAAA;EfkxCA;EiBlwCU;IFhBV,yBAAA;EfqxCA;EiBrwCU;IFhBV,gBAAA;EfwxCA;EiBxwCU;IFhBV,yBAAA;Ef2xCA;EiB3wCU;IFhBV,yBAAA;Ef8xCA;AACF;AgB1xCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBwzCN;Ee5xCA;IACE,cAAA;IACA,eAAA;Ef8xCF;EehyCA;IACE,aAAA;IACA,cAAA;EfkyCF;EepyCA;IACE,wBAAA;IACA,yBAAA;EfsyCF;EexyCA;IACE,aAAA;IACA,cAAA;Ef0yCF;Ee5yCA;IACE,aAAA;IACA,cAAA;Ef8yCF;EehzCA;IACE,wBAAA;IACA,yBAAA;EfkzCF;EiBr0CI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Efu0CA;EiBp0CQ;IFbR,qBAAA;IAIA,sBAAA;Efi1CA;EiBx0CQ;IFbR,sBAAA;IAIA,uBAAA;Efq1CA;EiB50CQ;IFbR,aAAA;IAIA,cAAA;Efy1CA;EiBh1CQ;IFbR,sBAAA;IAIA,uBAAA;Ef61CA;EiBp1CQ;IFbR,sBAAA;IAIA,uBAAA;Efi2CA;EiBx1CQ;IFbR,aAAA;IAIA,cAAA;Efq2CA;EiB51CQ;IFbR,sBAAA;IAIA,uBAAA;Efy2CA;EiBh2CQ;IFbR,sBAAA;IAIA,uBAAA;Ef62CA;EiBp2CQ;IFbR,aAAA;IAIA,cAAA;Efi3CA;EiBx2CQ;IFbR,sBAAA;IAIA,uBAAA;Efq3CA;EiB52CQ;IFbR,sBAAA;IAIA,uBAAA;Efy3CA;EiBh3CQ;IFbR,cAAA;IAIA,eAAA;Ef63CA;EiB92CI;IAAwB,SAAA;EjBi3C5B;EiB/2CI;IAAuB,SAAA;EjBk3C3B;EiB/2CM;IAAwB,QADb;EjBm3CjB;EiBl3CM;IAAwB,QADb;EjBs3CjB;EiBr3CM;IAAwB,QADb;EjBy3CjB;EiBx3CM;IAAwB,QADb;EjB43CjB;EiB33CM;IAAwB,QADb;EjB+3CjB;EiB93CM;IAAwB,QADb;EjBk4CjB;EiBj4CM;IAAwB,QADb;EjBq4CjB;EiBp4CM;IAAwB,QADb;EjBw4CjB;EiBv4CM;IAAwB,QADb;EjB24CjB;EiB14CM;IAAwB,QADb;EjB84CjB;EiB74CM;IAAwB,SADb;EjBi5CjB;EiBh5CM;IAAwB,SADb;EjBo5CjB;EiBn5CM;IAAwB,SADb;EjBu5CjB;EiB/4CU;IFhBV,cAAA;Efk6CA;EiBl5CU;IFhBV,wBAAA;Efq6CA;EiBr5CU;IFhBV,yBAAA;Efw6CA;EiBx5CU;IFhBV,gBAAA;Ef26CA;EiB35CU;IFhBV,yBAAA;Ef86CA;EiB95CU;IFhBV,yBAAA;Efi7CA;EiBj6CU;IFhBV,gBAAA;Efo7CA;EiBp6CU;IFhBV,yBAAA;Efu7CA;EiBv6CU;IFhBV,yBAAA;Ef07CA;EiB16CU;IFhBV,gBAAA;Ef67CA;EiB76CU;IFhBV,yBAAA;Efg8CA;EiBh7CU;IFhBV,yBAAA;Efm8CA;AACF;AkBv/CA;EACE,WAAA;EACA,mBbiIO;EahIP,cbSS;ALg/CX;AkBt/CE;;EAEE,gBbmV0B;EalV1B,mBAAA;EACA,6BAAA;AlBw/CJ;AkBr/CE;EACE,sBAAA;EACA,gCAAA;AlBu/CJ;AkBp/CE;EACE,6BAAA;AlBs/CJ;;AkB5+CE;;EAEE,eb6T0B;ALkrC9B;;AkBt+CA;EACE,yBAAA;AlBy+CF;AkBv+CE;;EAEE,yBAAA;AlBy+CJ;AkBr+CI;;EAEE,wBAAA;AlBu+CN;;AkBj+CE;;;;EAIE,SAAA;AlBo+CJ;;AkB39CE;EACE,qCbyR0B;ALqsC9B;;AO7hDE;EW2EI,cbvEK;EawEL,sCb8QwB;ALwsC9B;;AmBxiDI;;;EAGE,yBD2F+B;AlBg9CrC;AmBviDM;;;;EAIE,qBDmFyE;AlBs9CjF;;AO9iDE;EYiBM,yBAJe;AnBqiDvB;AmB/hDQ;;EAEE,yBARa;AnByiDvB;;AmB5jDI;;;EAGE,yBD2F+B;AlBo+CrC;AmB3jDM;;;;EAIE,qBDmFyE;AlB0+CjF;;AOlkDE;EYiBM,yBAJe;AnByjDvB;AmBnjDQ;;EAEE,yBARa;AnB6jDvB;;AmBhlDI;;;EAGE,yBD2F+B;AlBw/CrC;AmB/kDM;;;;EAIE,qBDmFyE;AlB8/CjF;;AOtlDE;EYiBM,yBAJe;AnB6kDvB;AmBvkDQ;;EAEE,yBARa;AnBilDvB;;AmBpmDI;;;EAGE,yBD2F+B;AlB4gDrC;AmBnmDM;;;;EAIE,qBDmFyE;AlBkhDjF;;AO1mDE;EYiBM,yBAJe;AnBimDvB;AmB3lDQ;;EAEE,yBARa;AnBqmDvB;;AmBxnDI;;;EAGE,yBD2F+B;AlBgiDrC;AmBvnDM;;;;EAIE,qBDmFyE;AlBsiDjF;;AO9nDE;EYiBM,yBAJe;AnBqnDvB;AmB/mDQ;;EAEE,yBARa;AnBynDvB;;AmB5oDI;;;EAGE,yBD2F+B;AlBojDrC;AmB3oDM;;;;EAIE,qBDmFyE;AlB0jDjF;;AOlpDE;EYiBM,yBAJe;AnByoDvB;AmBnoDQ;;EAEE,yBARa;AnB6oDvB;;AmBhqDI;;;EAGE,yBD2F+B;AlBwkDrC;AmB/pDM;;;;EAIE,qBDmFyE;AlB8kDjF;;AOtqDE;EYiBM,yBAJe;AnB6pDvB;AmBvpDQ;;EAEE,yBARa;AnBiqDvB;;AmBprDI;;;EAGE,yBD2F+B;AlB4lDrC;AmBnrDM;;;;EAIE,qBDmFyE;AlBkmDjF;;AO1rDE;EYiBM,yBAJe;AnBirDvB;AmB3qDQ;;EAEE,yBARa;AnBqrDvB;;AmBxsDI;;;EAGE,sCd6VwB;AL82C9B;;AOxsDE;EYiBM,sCAJe;AnB+rDvB;AmBzrDQ;;EAEE,sCARa;AnBmsDvB;;AkB3mDI;EACE,Wb3GK;Ea4GL,yBbpGK;EaqGL,qBbiQwB;AL62C9B;AkBzmDI;EACE,cb5GK;Ea6GL,yBblHK;EamHL,qBblHK;AL6tDX;;AkBtmDA;EACE,Wb3HS;Ea4HT,yBbpHS;AL6tDX;AkBvmDE;;;EAGE,qBb6O0B;AL43C9B;AkBtmDE;EACE,SAAA;AlBwmDJ;AkBpmDI;EACE,2CbiOwB;ALq4C9B;AO3uDE;EW4IM,WbjJG;EakJH,4Cb2NsB;ALu4C9B;;AgBlrDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBolDN;EkBjlDM;IACE,SAAA;ElBmlDR;AACF;AgB9rDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElB+lDN;EkB5lDM;IACE,SAAA;ElB8lDR;AACF;AgBzsDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElB0mDN;EkBvmDM;IACE,SAAA;ElBymDR;AACF;AgBptDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBqnDN;EkBlnDM;IACE,SAAA;ElBonDR;AACF;AkB9nDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AlB+nDR;AkB5nDQ;EACE,SAAA;AlB8nDV;;AoB3yDA;EACE,cAAA;EACA,WAAA;EACA,mCf2esC;Ee1etC,yBAAA;Ed0KI,eAAA;EcvKJ,gBfmR4B;EelR5B,gBfuR4B;EetR5B,cfDS;EeET,sBfTS;EeUT,4BAAA;EACA,yBAAA;ERAE,sBAAA;ESFE,wEDQJ;ApByyDF;AqB7yDM;EDdN;ICeQ,gBAAA;ErBgzDN;AACF;AoB3yDE;EACE,6BAAA;EACA,SAAA;ApB6yDJ;AsB7zDE;EACE,cAAA;EACA,sBjBRO;EiBSP,qBjBsdoC;EiBrdpC,UAAA;EAKE,gDjBqXwB;ALs8C9B;AoB7yDE;EACE,cfxBO;Ee0BP,UAAA;ApB8yDJ;AoBtyDE;EAEE,yBfxCO;Ee0CP,UAAA;ApBsyDJ;;AoB9xDE;;;;EACE,gBAAA;ApBoyDJ;;AoB9xDE;EACE,kBAAA;EACA,0BAAA;ApBiyDJ;AoB9xDE;EAME,cf/DO;EegEP,sBfvEO;ALk2DX;;AoBtxDA;;EAEE,cAAA;EACA,WAAA;ApByxDF;;AoB/wDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EdiEE,kBAAA;Ec/DF,gBfgM4B;ALklD9B;;AoB/wDA;EACE,+BAAA;EACA,kCAAA;Ed0EI,kBAAA;EcxEJ,gBf6H4B;ALqpD9B;;AoB/wDA;EACE,gCAAA;EACA,mCAAA;EdmEI,mBAAA;EcjEJ,gBfuH4B;AL2pD9B;;AoBzwDA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EdoDI,eAAA;EclDJ,gBfmK4B;EelK5B,cfnHS;EeoHT,6BAAA;EACA,yBAAA;EACA,mBAAA;ApB4wDF;AoB1wDE;EAEE,gBAAA;EACA,eAAA;ApB2wDJ;;AoB/vDA;EACE,kCf6VsC;Ee5VtC,uBAAA;Ed2BI,mBAAA;EczBJ,gBf+E4B;EOxN1B,qBAAA;AZ44DJ;;AoB/vDA;EACE,gCfsVsC;EerVtC,oBAAA;EdmBI,kBAAA;EcjBJ,gBfsE4B;EOvN1B,qBAAA;AZo5DJ;;AoB7vDE;EAEE,YAAA;ApB+vDJ;;AoB3vDA;EACE,YAAA;ApB8vDF;;AoBtvDA;EACE,mBf2UsC;AL86CxC;;AoBtvDA;EACE,cAAA;EACA,mBf4TsC;AL67CxC;;AoBjvDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ApBovDF;AoBlvDE;;EAEE,kBAAA;EACA,iBAAA;ApBovDJ;;AoB3uDA;EACE,kBAAA;EACA,cAAA;EACA,qBfiSsC;AL68CxC;;AoB3uDA;EACE,kBAAA;EACA,kBf6RsC;Ee5RtC,qBAAA;ApB8uDF;AoB3uDE;EAEE,cfzNO;ALq8DX;;AoBxuDA;EACE,gBAAA;ApB2uDF;;AoBxuDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf8QsC;AL69CxC;AoBxuDE;EACE,gBAAA;EACA,aAAA;EACA,uBfyQoC;EexQpC,cAAA;ApB0uDJ;;AsBv7DE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;ECtVpC,kBAAA;EgBnHA,cFqNqC;ApBquDzC;;AsBv7DE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,mBAAA;EgBtHF,gBjBuO0B;EiBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;AZy+DJ;AsBt7DI;EAEE,SAAA;AtBu7DN;;AsBl7DI;;;;EAEE,cAAA;AtBu7DN;;AsBr+DI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AtBm7DR;AsBh7DM;EACE,qBFuKiC;EEtKjC,gDAAA;AtBk7DR;;AsBl/DI;EAyEI,8BAAA;EACA,wCAAA;AtB66DR;;AsBv/DI;EAmFI,oCjB6XgC;EiB5XhC,kFAAA;AtBw6DR;;AsB5/DI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,yNAAA;AtBm6DR;AsBh6DM;EACE,qBFmIiC;EElIjC,gDAAA;AtBk6DR;;AsB35DM;EACE,cF0HiC;ApBoyDzC;AsB35DM;;;EAEE,cAAA;AtB85DR;;AsBv5DM;EACE,cF6GiC;ApB6yDzC;AsBx5DQ;EACE,qBF0G+B;ApBgzDzC;AsBr5DQ;EACE,qBAAA;EC5JN,yBD6J2B;AtBu5D/B;AsBl5DQ;EACE,gDAAA;AtBo5DV;AsBj5DQ;EACE,qBFyF+B;ApB0zDzC;;AsB14DM;EACE,qBF+EiC;ApB8zDzC;AsBz4DQ;EACE,qBF0E+B;EEzE/B,gDAAA;AtB24DV;;AsB5hEE;EACE,aAAA;EACA,WAAA;EACA,mBjB2coC;ECtVpC,kBAAA;EgBnHA,cFqNqC;ApB00DzC;;AsB5hEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,mBAAA;EgBtHF,gBjBuO0B;EiBtO1B,WAAA;EACA,wCAAA;EV9CA,sBAAA;AZ8kEJ;AsB3hEI;EAEE,SAAA;AtB4hEN;;AsBvhEI;;;;EAEE,cAAA;AtB4hEN;;AsB1kEI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AtBwhER;AsBrhEM;EACE,qBFuKiC;EEtKjC,gDAAA;AtBuhER;;AsBvlEI;EAyEI,8BAAA;EACA,wCAAA;AtBkhER;;AsB5lEI;EAmFI,oCjB6XgC;EiB5XhC,kFAAA;AtB6gER;;AsBjmEI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,0NAAA;AtBwgER;AsBrgEM;EACE,qBFmIiC;EElIjC,gDAAA;AtBugER;;AsBhgEM;EACE,cF0HiC;ApBy4DzC;AsBhgEM;;;EAEE,cAAA;AtBmgER;;AsB5/DM;EACE,cF6GiC;ApBk5DzC;AsB7/DQ;EACE,qBF0G+B;ApBq5DzC;AsB1/DQ;EACE,qBAAA;EC5JN,yBD6J2B;AtB4/D/B;AsBv/DQ;EACE,gDAAA;AtBy/DV;AsBt/DQ;EACE,qBFyF+B;ApB+5DzC;;AsB/+DM;EACE,qBF+EiC;ApBm6DzC;AsB9+DQ;EACE,qBF0E+B;EEzE/B,gDAAA;AtBg/DV;;AoB35DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ApB85DF;AoBz5DE;EACE,WAAA;ApB25DJ;AgB1nEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EpBy5DJ;EoBr5DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EpBu5DJ;EoBn5DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EpBq5DJ;EoBj5DE;IACE,qBAAA;EpBm5DJ;EoBh5DE;;IAEE,WAAA;EpBk5DJ;EoB74DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EpB+4DJ;EoB74DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBfgLkC;Ie/KlC,cAAA;EpB+4DJ;EoB54DE;IACE,mBAAA;IACA,uBAAA;EpB84DJ;EoB54DE;IACE,gBAAA;EpB84DJ;AACF;;AwBhuEA;EACE,qBAAA;EAEA,gBnBuR4B;EmBtR5B,cnBMS;EmBLT,kBAAA;EAGA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,yBAAA;EnB4EI,eAAA;EmB1EJ,gBpB2L4B;EOnR1B,sBAAA;ESFE,qIGGJ;AxBmuEF;AqBluEM;EGdN;IHeQ,gBAAA;ErBquEN;AACF;AO/uEE;EiBUE,cnBNO;EmBOP,qBAAA;AxBwuEJ;AwBruEE;EAEE,UAAA;EACA,gDnB8W0B;ALw3D9B;AwBluEE;EAEE,anBkZ0B;ALi1D9B;AwB/tEE;EACE,eAAA;AxBiuEJ;AwBntEA;;EAEE,oBAAA;AxBqtEF;;AwB5sEE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ALusEf;AOvwEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBmxEzG;AyBvwEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AzBowEN;AyB/vEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALutEf;AyBzvEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBmyE7L;AyBpvEI;EAKI,gDAAA;AzBkvER;;AwB1uEE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ALquEf;AOryEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBizEzG;AyBryEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;AzBkyEN;AyB7xEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALqvEf;AyBvxEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBi0E7L;AyBlxEI;EAKI,iDAAA;AzBgxER;;AwBxwEE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ALmwEf;AOn0EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AzB+0EzG;AyBn0EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;AzBg0EN;AyB3zEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALmxEf;AyBrzEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB+1E7L;AyBhzEI;EAKI,+CAAA;AzB8yER;;AwBtyEE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ALiyEf;AOj2EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AzB62EzG;AyBj2EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AzB81EN;AyBz1EE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALizEf;AyBn1EE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB63E7L;AyB90EI;EAKI,gDAAA;AzB40ER;;AwBp0EE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AL+zEf;AO/3EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzB24EzG;AyB/3EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AzB43EN;AyBv3EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AL+0Ef;AyBj3EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB25E7L;AyB52EI;EAKI,gDAAA;AzB02ER;;AwBl2EE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AL61Ef;AO75EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBy6EzG;AyB75EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;AzB05EN;AyBr5EE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AL62Ef;AyB/4EE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBy7E7L;AyB14EI;EAKI,+CAAA;AzBw4ER;;AwBh4EE;EC3DA,cAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;AL23Ef;AO37EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBu8EzG;AyB37EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;AzBw7EN;AyBn7EE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AL24Ef;AyB76EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBu9E7L;AyBx6EI;EAKI,iDAAA;AzBs6ER;;AwB95EE;EC3DA,WAAA;EFAE,yBlBsEW;EoBpEb,qBpBoEa;ALy5Ef;AOz9EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBq+EzG;AyBz9EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,8CAAA;AzBs9EN;AyBj9EE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALy6Ef;AyB38EE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBq/E7L;AyBt8EI;EAKI,8CAAA;AzBo8ER;;AwBt7EE;ECPA,cpBYa;EoBXb,qBpBWa;ALs7Ef;AOt/EE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AL27Ef;AyB97EE;EAEE,+CAAA;AzB+7EJ;AyB57EE;EAEE,cpBJW;EoBKX,6BAAA;AzB67EJ;AyB17EE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ALu8Ef;AyBx7EI;EAKI,+CAAA;AzBs7ER;;AwB/8EE;ECPA,cpBYa;EoBXb,qBpBWa;AL+8Ef;AO/gFE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ALo9Ef;AyBv9EE;EAEE,iDAAA;AzBw9EJ;AyBr9EE;EAEE,cpBJW;EoBKX,6BAAA;AzBs9EJ;AyBn9EE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ALg+Ef;AyBj9EI;EAKI,iDAAA;AzB+8ER;;AwBx+EE;ECPA,cpBYa;EoBXb,qBpBWa;ALw+Ef;AOxiFE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AL6+Ef;AyBh/EE;EAEE,+CAAA;AzBi/EJ;AyB9+EE;EAEE,cpBJW;EoBKX,6BAAA;AzB++EJ;AyB5+EE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ALy/Ef;AyB1+EI;EAKI,+CAAA;AzBw+ER;;AwBjgFE;ECPA,cpBYa;EoBXb,qBpBWa;ALigFf;AOjkFE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ALsgFf;AyBzgFE;EAEE,gDAAA;AzB0gFJ;AyBvgFE;EAEE,cpBJW;EoBKX,6BAAA;AzBwgFJ;AyBrgFE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ALkhFf;AyBngFI;EAKI,gDAAA;AzBigFR;;AwB1hFE;ECPA,cpBYa;EoBXb,qBpBWa;AL0hFf;AO1lFE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AL+hFf;AyBliFE;EAEE,+CAAA;AzBmiFJ;AyBhiFE;EAEE,cpBJW;EoBKX,6BAAA;AzBiiFJ;AyB9hFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AL2iFf;AyB5hFI;EAKI,+CAAA;AzB0hFR;;AwBnjFE;ECPA,cpBYa;EoBXb,qBpBWa;ALmjFf;AOnnFE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ALwjFf;AyB3jFE;EAEE,+CAAA;AzB4jFJ;AyBzjFE;EAEE,cpBJW;EoBKX,6BAAA;AzB0jFJ;AyBvjFE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ALokFf;AyBrjFI;EAKI,+CAAA;AzBmjFR;;AwB5kFE;ECPA,cpBYa;EoBXb,qBpBWa;AL4kFf;AO5oFE;EkBwDE,cALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;ALilFf;AyBplFE;EAEE,iDAAA;AzBqlFJ;AyBllFE;EAEE,cpBJW;EoBKX,6BAAA;AzBmlFJ;AyBhlFE;EAGE,cAAA;EACA,yBpBZW;EoBaX,qBpBbW;AL6lFf;AyB9kFI;EAKI,iDAAA;AzB4kFR;;AwBrmFE;ECPA,cpBYa;EoBXb,qBpBWa;ALqmFf;AOrqFE;EkBwDE,WALgD;EAMhD,yBpBOW;EoBNX,qBpBMW;AL0mFf;AyB7mFE;EAEE,8CAAA;AzB8mFJ;AyB3mFE;EAEE,cpBJW;EoBKX,6BAAA;AzB4mFJ;AyBzmFE;EAGE,WAAA;EACA,yBpBZW;EoBaX,qBpBbW;ALsnFf;AyBvmFI;EAKI,8CAAA;AzBqmFR;;AwBnnFA;EACE,gBnB6M4B;EmB5M5B,cnB2FwC;EmB1FxC,qBnB2FwC;AL2hF1C;AO/rFE;EiB4EE,cnByFsC;EmBxFtC,0BnByFsC;AL6hF1C;AwBnnFE;EAEE,0BnBoFsC;ALgiF1C;AwBjnFE;EAEE,cnBtFO;EmBuFP,oBAAA;AxBknFJ;;AwBvmFA;ECPE,oBAAA;EnB4EI,kBAAA;EmB1EJ,gBpB+H4B;EOvN1B,qBAAA;AZ2sFJ;;AwB1mFA;ECXE,uBAAA;EnB4EI,mBAAA;EmB1EJ,gBpBgI4B;EOxN1B,qBAAA;AZktFJ;;AwBxmFA;EACE,cAAA;EACA,WAAA;AxB2mFF;AwBxmFE;EACE,kBnBwT0B;ALkzE9B;;AwBlmFE;;;EACE,WAAA;AxBumFJ;;A0BlvFA;ELgBM,gCKfJ;A1BqvFF;AqBluFM;EKpBN;ILqBQ,gBAAA;ErBquFN;AACF;A0BxvFE;EACE,UAAA;A1B0vFJ;;A0BrvFE;EACE,aAAA;A1BwvFJ;;A0BpvFA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A1BuvFF;AqBrvFM;EKNN;ILOQ,gBAAA;ErBwvFN;AACF;A0B1vFE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;A1B4vFJ;AqB/vFM;EKAJ;ILCM,gBAAA;ErBkwFN;AACF;;A2BvxFA;;;;EAIE,kBAAA;A3B0xFF;;A2BvxFA;EACE,mBAAA;A3B0xFF;A4BtwFI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A5ByyFF;A4BpvFI;EACE,cAAA;A5BsvFN;;A2BhyFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBypBkC;EsBxpBlC,aAAA;EACA,WAAA;EACA,gBtBiuBkC;EsBhuBlC,iBAAA;EACA,oBAAA;ErB2JI,eAAA;EqBzJJ,ctBXS;EsBYT,gBAAA;EACA,gBAAA;EACA,sBtBvBS;EsBwBT,4BAAA;EACA,qCAAA;EfdE,sBAAA;AZkzFJ;;A2B3xFI;EACE,WAAA;EACA,OAAA;A3B8xFN;;A2B3xFI;EACE,QAAA;EACA,UAAA;A3B8xFN;;AgBlxFI;EWnBA;IACE,WAAA;IACA,OAAA;E3ByyFJ;E2BtyFE;IACE,QAAA;IACA,UAAA;E3BwyFJ;AACF;AgB7xFI;EWnBA;IACE,WAAA;IACA,OAAA;E3BmzFJ;E2BhzFE;IACE,QAAA;IACA,UAAA;E3BkzFJ;AACF;AgBvyFI;EWnBA;IACE,WAAA;IACA,OAAA;E3B6zFJ;E2B1zFE;IACE,QAAA;IACA,UAAA;E3B4zFJ;AACF;AgBjzFI;EWnBA;IACE,WAAA;IACA,OAAA;E3Bu0FJ;E2Bp0FE;IACE,QAAA;IACA,UAAA;E3Bs0FJ;AACF;A2B/zFE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtB+rBgC;ALkoEpC;A4Bh2FI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A5B43FF;A4B90FI;EACE,cAAA;A5Bg1FN;;A2Br0FE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtBirBgC;ALupEpC;A4Br3FI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A5B04FF;A4Bn2FI;EACE,cAAA;A5Bq2FN;A2Bh1FI;EACE,iBAAA;A3Bk1FN;;A2B50FE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtBgqBgC;AL+qEpC;A4B74FI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;A5B+4FN;A4Bp4FM;EACE,aAAA;A5Bs4FR;A4Bn4FM;EACE,qBAAA;EACA,qBvB4MsB;EuB3MtB,uBvB0MsB;EuBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A5Bo6FF;A4Bn4FI;EACE,cAAA;A5Bq4FN;A2B/1FI;EACE,iBAAA;A3Bi2FN;;A2Bz1FE;EAIE,WAAA;EACA,YAAA;A3By1FJ;;A2Bp1FA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A7Bs8FF;;A2Bp1FA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBtBiK4B;EsBhK5B,ctBhHS;EsBiHT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A3Bs1FF;AO38FE;EoBoIE,ctBonBgC;EsBnnBhC,qBAAA;EJ/IA,yBlBGO;ALu9FX;A2Bv0FE;EAEE,WtBpJO;EsBqJP,qBAAA;EJtJA,yBlBoP0B;AL2uF9B;A2Br0FE;EAEE,ctBtJO;EsBuJP,oBAAA;EACA,6BAAA;A3Bs0FJ;;A2B9zFA;EACE,cAAA;A3Bi0FF;;A2B7zFA;EACE,cAAA;EACA,sBtBimBkC;EsBhmBlC,gBAAA;ErBAI,mBAAA;EqBEJ,ctBzKS;EsB0KT,mBAAA;A3Bg0FF;;A2B5zFA;EACE,cAAA;EACA,uBAAA;EACA,ctB9KS;AL6+FX;;A8B1/FA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A9B6/FF;A8B3/FE;;EACE,kBAAA;EACA,cAAA;A9B8/FJ;AO7/FE;;EuBII,UAAA;A9B6/FN;A8B3/FI;;;;EAGE,UAAA;A9B8/FN;;A8Bx/FA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A9B2/FF;A8Bz/FE;EACE,WAAA;A9B2/FJ;;A8Br/FE;;EAEE,iBAAA;A9Bw/FJ;A8Bp/FE;;ElBXE,0BAAA;EACA,6BAAA;AZmgGJ;A8Bp/FE;;ElBFE,yBAAA;EACA,4BAAA;AZ0/FJ;;A8Bv+FA;EACE,wBAAA;EACA,uBAAA;A9B0+FF;A8Bx+FE;EAGE,cAAA;A9Bw+FJ;A8Br+FE;EACE,eAAA;A9Bu+FJ;;A8Bn+FA;EACE,uBAAA;EACA,sBAAA;A9Bs+FF;;A8Bn+FA;EACE,sBAAA;EACA,qBAAA;A9Bs+FF;;A8Bl9FA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A9Bq9FF;A8Bn9FE;;EAEE,WAAA;A9Bq9FJ;A8Bl9FE;;EAEE,gBAAA;A9Bo9FJ;A8Bh9FE;;ElBrFE,6BAAA;EACA,4BAAA;AZyiGJ;A8Bh9FE;;ElBxGE,yBAAA;EACA,0BAAA;AZ4jGJ;;A8Bj8FE;;EAEE,gBAAA;A9Bo8FJ;A8Bl8FI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9Bs8FN;;A+B/lGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/BkmGF;A+BhmGE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A/BkmGJ;A+BhmGI;;;;;;;;;;;;EAGE,iBAAA;A/B2mGN;A+BtmGE;;;EAGE,UAAA;A/BwmGJ;A+BpmGE;EACE,UAAA;A/BsmGJ;A+BjmGI;;EnBIA,yBAAA;EACA,4BAAA;AZimGJ;A+BjmGE;EACE,aAAA;EACA,mBAAA;A/BmmGJ;A+BjmGI;EnBnBA,0BAAA;EACA,6BAAA;AZunGJ;A+BnmGI;EnBPA,yBAAA;EACA,4BAAA;AZ6mGJ;A+BnmGI;;;;EnBzBA,0BAAA;EACA,6BAAA;AZkoGJ;A+BjmGI;;;;EnBlCA,0BAAA;EACA,6BAAA;AZyoGJ;;A+BxlGA;;EAEE,aAAA;A/B2lGF;A+BtlGE;;EACE,kBAAA;EACA,UAAA;A/BylGJ;A+BvlGI;;EACE,UAAA;A/B0lGN;A+BtlGE;;;;;;;;EAIE,iBAAA;A/B4lGJ;;A+BxlGA;EAAuB,kBAAA;A/B4lGvB;;A+B3lGA;EAAsB,iBAAA;A/B+lGtB;;A+BvlGA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EzB2DI,eAAA;EyBzDJ,gB1BqK4B;E0BpK5B,gB1ByK4B;E0BxK5B,c1B/GS;E0BgHT,kBAAA;EACA,mBAAA;EACA,yB1BvHS;E0BwHT,yBAAA;EnB/GE,sBAAA;AZ0sGJ;A+BvlGE;;EAEE,aAAA;A/BylGJ;;A+B/kGA;;EAEE,gC1BmWsC;AL+uFxC;;A+B/kGA;;;;;;EAME,oBAAA;EzBwBI,kBAAA;EyBtBJ,gB1B2E4B;EOvN1B,qBAAA;AZ+tGJ;;A+B/kGA;;EAEE,kC1BiVsC;ALiwFxC;;A+B/kGA;;;;;;EAME,uBAAA;EzBOI,mBAAA;EyBLJ,gB1B2D4B;EOxN1B,qBAAA;AZgvGJ;;A+B/kGA;;EAEE,sBAAA;A/BklGF;;A+BvkGA;;;;;;;;EnB9JI,0BAAA;EACA,6BAAA;AZgvGJ;;A+BxkGA;;;;;;EnB3JI,yBAAA;EACA,4BAAA;AZ4uGJ;;AgCpxGA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AhCuxGF;;AgCpxGA;EACE,oBAAA;EACA,kB3ByfsC;AL8xFxC;;AgCpxGA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W3BqfsC;E2BpftC,eAAA;EACA,UAAA;AhCuxGF;AgCrxGE;EACE,W3BzBO;E2B0BP,qB3ByN0B;EkBpP1B,yBlBoP0B;AL+jG9B;AgCnxGE;EAKI,gD3BgWwB;ALi7F9B;AgC7wGE;EACE,qB3BsboC;ALy1FxC;AgC5wGE;EACE,W3B7CO;E2B8CP,yB3Bkf4C;E2Bjf5C,qB3Bif4C;AL6xFhD;AgCvwGI;EACE,c3BjDK;AL0zGX;AgCvwGM;EACE,yB3BxDG;ALi0GX;;AgC/vGA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AhCiwGF;AgC7vGE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W3BwboC;E2BvbpC,Y3BuboC;E2BtbpC,oBAAA;EACA,WAAA;EACA,sB3BrFO;E2BsFP,yBAAA;AhC+vGJ;AgC1vGE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W3ByaoC;E2BxapC,Y3BwaoC;E2BvapC,WAAA;EACA,iCAAA;AhC4vGJ;;AgClvGE;EpBlGE,sBAAA;AZw1GJ;AgCjvGI;EACE,0DAAA;AhCmvGN;AgC9uGI;EACE,qB3B0HwB;EkBpP1B,yBlBoP0B;ALunG9B;AgC7uGI;EACE,0DAAA;AhC+uGN;AgC1uGI;ETpIA,wClByhB4C;ALw1FhD;AgC1uGI;ETvIA,wClByhB4C;AL21FhD;;AgCluGE;EAEE,kB3B0Z4C;AL00FhD;AgChuGI;EACE,0DAAA;AhCkuGN;AgC7tGI;ET9JA,wClByhB4C;ALq2FhD;;AgCrtGA;EACE,qBAAA;AhCwtGF;AgCrtGI;EACE,cAAA;EACA,c3BkY0C;E2BjY1C,mBAAA;EAEA,qB3BgY0C;ALs1FhD;AgCntGI;EACE,wBAAA;EACA,0BAAA;EACA,uB3B2X0C;E2B1X1C,wB3B0X0C;E2BzX1C,yB3BpLK;E2BsLL,qB3BsX0C;EgBxiB1C,yIWmLA;AhCotGN;AqBn4GM;EWuKF;IXtKI,gBAAA;ErBs4GN;AACF;AgCptGI;EACE,sB3BlMK;E2BmML,8BAAA;AhCstGN;AgCjtGI;ETzMA,wClByhB4C;ALo4FhD;;AgCvsGA;EACE,qBAAA;EACA,WAAA;EACA,mC3BqRsC;E2BpRtC,0CAAA;E1B5CI,eAAA;E0B+CJ,gB3B6D4B;E2B5D5B,gB3BiE4B;E2BhE5B,c3BvNS;E2BwNT,sBAAA;EACA,iGAAA;EACA,yBAAA;EpBtNE,sBAAA;EoByNF,gBAAA;AhCwsGF;AgCtsGE;EACE,qB3BwPoC;E2BvPpC,UAAA;EAKE,gD3BmW8B;ALi2FpC;AgCjsGI;EAME,c3B/OK;E2BgPL,sB3BvPK;ALq7GX;AgC1rGE;EAEE,YAAA;EACA,sB3B+H0B;E2B9H1B,sBAAA;AhC2rGJ;AgCxrGE;EACE,c3B7PO;E2B8PP,yB3BlQO;AL47GX;AgCtrGE;EACE,aAAA;AhCwrGJ;AgCprGE;EACE,kBAAA;EACA,0BAAA;AhCsrGJ;;AgClrGA;EACE,kC3B0NsC;E2BzNtC,oB3BiH4B;E2BhH5B,uB3BgH4B;E2B/G5B,oB3BgH4B;EC1NxB,mBAAA;ANgyGN;;AgClrGA;EACE,gC3BmNsC;E2BlNtC,mB3B8G4B;E2B7G5B,sB3B6G4B;E2B5G5B,kB3B6G4B;EC/NxB,kBAAA;ANwyGN;;AgC7qGA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC3BiMsC;E2BhMtC,gBAAA;AhCgrGF;;AgC7qGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC3ByLsC;E2BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;AhCgrGF;AgC9qGE;EACE,qB3BqKoC;E2BpKpC,gD3ByE0B;ALumG9B;AgC5qGE;EAEE,yB3B/TO;AL4+GX;AgCzqGI;EACE,iB3B2Ta;ALg3FnB;AgCvqGE;EACE,0BAAA;AhCyqGJ;;AgCrqGA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC3BwJsC;E2BvJtC,yBAAA;EACA,gBAAA;EAEA,gB3BhE4B;E2BiE5B,gB3B5D4B;E2B6D5B,c3BpVS;E2BqVT,sB3B5VS;E2B6VT,yBAAA;EpBlVE,sBAAA;AZ0/GJ;AgCpqGE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B3BiIoC;E2BhIpC,yBAAA;EACA,gB3B5E0B;E2B6E1B,c3BpWO;E2BqWP,iBAAA;ET7WA,yBlBGO;E2B4WP,oBAAA;EpBnWA,kCAAA;AZ0gHJ;;AgC5pGA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;AhC+pGF;AgC7pGE;EACE,UAAA;AhC+pGJ;AgC3pGI;EAA0B,gE3BoOe;AL07F7C;AgC7pGI;EAA0B,gE3BmOe;AL67F7C;AgC/pGI;EAA0B,gE3BkOe;ALg8F7C;AgC/pGE;EACE,SAAA;AhCiqGJ;AgC9pGE;EACE,W3BoNyC;E2BnNzC,Y3BmNyC;E2BlNzC,oBAAA;ETlZA,yBlBoP0B;E2BgK1B,S3BmNyC;EO3lBzC,mBAAA;ESFE,4GW6YF;EACA,gBAAA;AhC+pGJ;AqBziHM;EWiYJ;IXhYM,gBAAA;ErB4iHN;AACF;AgClqGI;ET1ZA,yBlB4mByC;ALm9F7C;AgChqGE;EACE,W3B6LgC;E2B5LhC,c3B6LgC;E2B5LhC,kBAAA;EACA,e3B4LgC;E2B3LhC,yB3BhaO;E2BiaP,yBAAA;EpBzZA,mBAAA;AZ4jHJ;AgC9pGE;EACE,W3ByLyC;E2BxLzC,Y3BwLyC;EkBpmBzC,yBlBoP0B;E2B0L1B,S3ByLyC;EO3lBzC,mBAAA;ESFE,4GWuaF;EACA,gBAAA;AhC+pGJ;AqBnkHM;EW4ZJ;IX3ZM,gBAAA;ErBskHN;AACF;AgClqGI;ETpbA,yBlB4mByC;AL6+F7C;AgChqGE;EACE,W3BmKgC;E2BlKhC,c3BmKgC;E2BlKhC,kBAAA;EACA,e3BkKgC;E2BjKhC,yB3B1bO;E2B2bP,yBAAA;EpBnbA,mBAAA;AZslHJ;AgC9pGE;EACE,W3B+JyC;E2B9JzC,Y3B8JyC;E2B7JzC,aAAA;EACA,oB3BrE0B;E2BsE1B,mB3BtE0B;EkBnY1B,yBlBoP0B;E2BuN1B,S3B4JyC;EO3lBzC,mBAAA;ESFE,4GWocF;EACA,gBAAA;AhC+pGJ;AqBhmHM;EWsbJ;IXrbM,gBAAA;ErBmmHN;AACF;AgClqGI;ETjdA,yBlB4mByC;AL0gG7C;AgChqGE;EACE,W3BsIgC;E2BrIhC,c3BsIgC;E2BrIhC,kBAAA;EACA,e3BqIgC;E2BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;AhCkqGJ;AgC9pGE;EACE,yB3B9dO;EOQP,mBAAA;AZunHJ;AgC7pGE;EACE,kBAAA;EACA,yB3BpeO;EOQP,mBAAA;AZ4nHJ;AgC3pGI;EACE,yB3BxeK;ALqoHX;AgC1pGI;EACE,eAAA;AhC4pGN;AgCzpGI;EACE,yB3BhfK;AL2oHX;AgCxpGI;EACE,eAAA;AhC0pGN;AgCvpGI;EACE,yB3BxfK;ALipHX;;AgCppGA;;;EXzfM,4GW4fJ;AhCupGF;AqB/oHM;EWqfN;;;IXpfQ,gBAAA;ErBopHN;AACF;;AiCrqHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjCwqHF;;AiCrqHA;EACE,cAAA;EACA,oBAAA;AjCwqHF;AOvqHE;E0BGE,qBAAA;AjCuqHJ;AiCnqHE;EACE,c5BXO;E4BYP,oBAAA;EACA,eAAA;AjCqqHJ;;AiC7pHA;EACE,gCAAA;AjCgqHF;AiC9pHE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,+BAAA;EACA,gCAAA;AZ8qHJ;AO1rHE;E0B6BI,kBAAA;EACA,qC5BipB8B;AL+gGpC;AiC7pHI;EACE,c5BrCK;E4BsCL,6BAAA;EACA,yBAAA;AjC+pHN;AiC3pHE;;EAEE,c5B5CO;E4B6CP,sB5BpDO;E4BqDP,kC5BsoBgC;ALuhGpC;AiC1pHE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;AZksHJ;;AiCjpHE;EACE,gBAAA;EACA,SAAA;ErB7DA,sBAAA;AZktHJ;AiCjpHE;;EAEE,W5B9EO;E4B+EP,yB5BoK0B;AL++G9B;;AiCzoHE;;EAEE,cAAA;EACA,kBAAA;AjC4oHJ;;AiCvoHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AjC0oHJ;;AiChoHE;EACE,aAAA;AjCmoHJ;AiCjoHE;EACE,cAAA;AjCmoHJ;;AkC5uHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AlC+uHF;AkC3uHE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AlCkvHJ;AkC9tHA;EACE,qBAAA;EACA,sB7BkqBkC;E6BjqBlC,yB7BiqBkC;E6BhqBlC,kB7BgFO;EC6CH,kBAAA;E4B3HJ,oBAAA;EACA,mBAAA;AlCguHF;AO1wHE;E2B6CE,qBAAA;AlCguHJ;;AkCvtHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlC0tHF;AkCxtHE;EACE,gBAAA;EACA,eAAA;AlC0tHJ;AkCvtHE;EACE,gBAAA;EACA,WAAA;AlCytHJ;;AkChtHA;EACE,qBAAA;EACA,mB7BylBkC;E6BxlBlC,sB7BwlBkC;AL2nGpC;;AkCvsHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AlCwsHF;;AkCpsHA;EACE,wBAAA;E5B8DI,kBAAA;E4B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,sBAAA;AZgzHJ;AOlzHE;E2B8GE,qBAAA;AlCusHJ;;AkCjsHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AlCosHF;;AkCjsHA;EACE,gB7BglBkC;E6B/kBlC,gBAAA;AlCosHF;;AgB1wHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCisHR;AACF;AgBnyHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCsrHN;EkCprHM;IACE,mBAAA;ElCsrHR;EkCprHQ;IACE,kBAAA;ElCsrHV;EkCnrHQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EL6pGlC;EkChrHM;;;;;;IACE,iBAAA;ElCurHR;EkCzqHM;IACE,iBAAA;ElC2qHR;EkCxqHM;IACE,wBAAA;IAGA,gBAAA;ElCwqHR;EkCrqHM;IACE,aAAA;ElCuqHR;AACF;AgBxzHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElC8uHR;AACF;AgBh1HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCmuHN;EkCjuHM;IACE,mBAAA;ElCmuHR;EkCjuHQ;IACE,kBAAA;ElCmuHV;EkChuHQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;EL0sGlC;EkC7tHM;;;;;;IACE,iBAAA;ElCouHR;EkCttHM;IACE,iBAAA;ElCwtHR;EkCrtHM;IACE,wBAAA;IAGA,gBAAA;ElCqtHR;EkCltHM;IACE,aAAA;ElCotHR;AACF;AgBr2HI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElC2xHR;AACF;AgB73HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCgxHN;EkC9wHM;IACE,mBAAA;ElCgxHR;EkC9wHQ;IACE,kBAAA;ElCgxHV;EkC7wHQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;ELuvGlC;EkC1wHM;;;;;;IACE,iBAAA;ElCixHR;EkCnwHM;IACE,iBAAA;ElCqwHR;EkClwHM;IACE,wBAAA;IAGA,gBAAA;ElCkwHR;EkC/vHM;IACE,aAAA;ElCiwHR;AACF;AgBl5HI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCw0HR;AACF;AgB16HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElC6zHN;EkC3zHM;IACE,mBAAA;ElC6zHR;EkC3zHQ;IACE,kBAAA;ElC6zHV;EkC1zHQ;IACE,qB7ByhBwB;I6BxhBxB,oB7BwhBwB;ELoyGlC;EkCvzHM;;;;;;IACE,iBAAA;ElC8zHR;EkChzHM;IACE,iBAAA;ElCkzHR;EkC/yHM;IACE,wBAAA;IAGA,gBAAA;ElC+yHR;EkC5yHM;IACE,aAAA;ElC8yHR;AACF;AkC/2HI;EAoBI,qBAAA;EACA,2BAAA;AlC81HR;AkCj3HQ;;;;;;EACE,gBAAA;EACA,eAAA;AlCw3HV;AkCr2HQ;EACE,mBAAA;AlCu2HV;AkCr2HU;EACE,kBAAA;AlCu2HZ;AkCp2HU;EACE,qB7ByhBwB;E6BxhBxB,oB7BwhBwB;AL80GpC;AkCj2HQ;;;;;;EACE,iBAAA;AlCw2HV;AkC11HQ;EACE,iBAAA;AlC41HV;AkCz1HQ;EACE,wBAAA;EAGA,gBAAA;AlCy1HV;AkCt1HQ;EACE,aAAA;AlCw1HV;;AkC10HE;EACE,yB7BigBgC;AL40GpC;AOriIE;E2B2NI,yB7B8f8B;AL+0GpC;AkCx0HI;EACE,yB7Bsf8B;ALo1GpC;AO3iIE;E2BoOM,yB7Bof4B;ALs1GpC;AkCv0HM;EACE,yB7Bkf4B;ALu1GpC;AkCr0HI;;;;EAIE,yB7Bye8B;AL81GpC;AkCn0HE;EACE,yB7BkegC;E6BjehC,gC7BsegC;AL+1GpC;AkCl0HE;EACE,0DAAA;AlCo0HJ;AkCj0HE;EACE,yB7BydgC;AL02GpC;AkCl0HI;EACE,yB7Byd8B;AL22GpC;AOpkIE;E2BmQM,yB7Bsd4B;AL82GpC;;AkC5zHE;EACE,W7BrRO;ALolIX;AO3kIE;E2B+QI,W7BxRK;ALulIX;AkC1zHI;EACE,+B7B2b8B;ALi4GpC;AOjlIE;E2BwRM,gC7Byb4B;ALm4GpC;AkCzzHM;EACE,gC7Bub4B;ALo4GpC;AkCvzHI;;;;EAIE,W7B7SK;ALsmIX;AkCrzHE;EACE,+B7BuagC;E6BtahC,sC7B2agC;AL44GpC;AkCpzHE;EACE,0DAAA;AlCszHJ;AkCnzHE;EACE,+B7B8ZgC;ALu5GpC;AkCpzHI;EACE,W7B7TK;ALmnIX;AO1mIE;E2BuTM,W7BhUG;ALsnIX;;AmCznIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sB9BJS;E8BKT,2BAAA;EACA,sCAAA;EvBKE,sBAAA;AZunIJ;AmCznIE;EACE,eAAA;EACA,cAAA;AnC2nIJ;AmCxnIE;EACE,mBAAA;EACA,sBAAA;AnC0nIJ;AmCxnII;EACE,mBAAA;EvBCF,2CAAA;EACA,4CAAA;AZ0nIJ;AmCxnII;EACE,sBAAA;EvBUF,+CAAA;EACA,8CAAA;AZinIJ;AmCrnIE;;EAEE,aAAA;AnCunIJ;;AmCnnIA;EAGE,cAAA;EAGA,eAAA;EACA,gB9BgxBkC;ALk2GpC;;AmC9mIA;EACE,sB9B0wBkC;ALu2GpC;;AmC9mIA;EACE,qBAAA;EACA,gBAAA;AnCinIF;;AmC9mIA;EACE,gBAAA;AnCinIF;;AOtqIE;E4B0DE,qBAAA;AnCgnIJ;AmC7mIE;EACE,oB9ByvBgC;ALs3GpC;;AmCvmIA;EACE,wBAAA;EACA,gBAAA;EAEA,qC9BkvBkC;E8BjvBlC,6CAAA;AnCymIF;AmCvmIE;EvBvEE,0DAAA;AZirIJ;;AmCrmIA;EACE,wBAAA;EAEA,qC9BuuBkC;E8BtuBlC,0CAAA;AnCumIF;AmCrmIE;EvBlFE,0DAAA;AZ0rIJ;;AmC9lIA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AnCimIF;;AmC9lIA;EACE,uBAAA;EACA,sBAAA;AnCimIF;;AmC7lIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB9B6sBkC;EO5zBhC,kCAAA;AZgtIJ;;AmC7lIA;;;EAGE,cAAA;EACA,WAAA;AnCgmIF;;AmC7lIA;;EvBjHI,2CAAA;EACA,4CAAA;AZmtIJ;;AmC9lIA;;EvBxGI,+CAAA;EACA,8CAAA;AZ2sIJ;;AmC3lIE;EACE,mB9BqrBgC;ALy6GpC;AgB7rII;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EnC8lIF;EmC5lIE;IAEE,YAAA;IACA,kB9ByqB8B;I8BxqB9B,gBAAA;IACA,iB9BuqB8B;ELs7GlC;AACF;;AmCjlIE;EACE,mB9BypBgC;AL27GpC;AgB/sII;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EnColIF;EmCjlIE;IAEE,YAAA;IACA,gBAAA;EnCklIJ;EmChlII;IACE,cAAA;IACA,cAAA;EnCklIN;EmC7kIM;IvBzKJ,0BAAA;IACA,6BAAA;EZyvIF;EmC9kIQ;;IAGE,0BAAA;EnC+kIV;EmC7kIQ;;IAGE,6BAAA;EnC8kIV;EmC1kIM;IvB1KJ,yBAAA;IACA,4BAAA;EZuvIF;EmC3kIQ;;IAGE,yBAAA;EnC4kIV;EmC1kIQ;;IAGE,4BAAA;EnC2kIV;AACF;;AmC9jIE;EACE,sB9B8kBgC;ALm/GpC;AgBzvII;EmBsLJ;IAMI,e9B2lBgC;I8B1lBhC,mB9B2lBgC;I8B1lBhC,UAAA;IACA,SAAA;EnCikIF;EmC/jIE;IACE,qBAAA;IACA,WAAA;EnCikIJ;AACF;;AmCxjIA;EACE,qBAAA;AnC2jIF;AmCzjIE;EACE,gBAAA;AnC2jIJ;AmCzjII;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;AZmyIJ;AmCzjII;EvBzPA,yBAAA;EACA,0BAAA;AZqzIJ;AmCzjII;EvBtQA,gBAAA;EuBwQE,mBAAA;AnC2jIN;;AoCr1IA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BqiCkC;E+BniClC,gBAAA;EACA,yB/BES;EOSP,sBAAA;AZ60IJ;;AoCl1IE;EACE,oB/ByhCgC;AL4zGpC;AoCn1II;EACE,WAAA;EACA,qB/BqhC8B;E+BphC9B,c/BNK;E+BOL,YAAA;ApCq1IN;AoC30IE;EACE,0BAAA;ApC60IJ;AoC10IE;EACE,qBAAA;ApC40IJ;AoCz0IE;EACE,c/B1BO;ALq2IX;;AqCl3IA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,sBAAA;AZu2IJ;;AqCn3IA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhCoxBkC;EgCnxBlC,chCmKwC;EgCjKxC,sBhCPS;EgCQT,yBAAA;ArCq3IF;AqCn3IE;EACE,UAAA;EACA,chC8JsC;EgC7JtC,qBAAA;EACA,yBhCZO;EgCaP,qBhCZO;ALi4IX;AqCl3IE;EACE,UAAA;EACA,UhC4wBgC;EgC3wBhC,gDhC+W0B;ALqgI9B;;AqC92II;EACE,cAAA;EzBaF,+BAAA;EACA,kCAAA;AZq2IJ;AqC92II;EzBNA,gCAAA;EACA,mCAAA;AZu3IJ;AqC72IE;EACE,UAAA;EACA,WhCxCO;EgCyCP,yBhC0M0B;EgCzM1B,qBhCyM0B;ALsqI9B;AqC52IE;EACE,chCxCO;EgCyCP,oBAAA;EAEA,YAAA;EACA,sBhClDO;EgCmDP,qBhChDO;AL65IX;;AsCp6IE;EACE,uBAAA;EhCgLE,kBAAA;EgC9KF,gBjCmO0B;ALosI9B;AsCl6IM;E1BqCF,8BAAA;EACA,iCAAA;AZg4IJ;AsCj6IM;E1BkBF,+BAAA;EACA,kCAAA;AZk5IJ;;AsCl7IE;EACE,uBAAA;EhCgLE,mBAAA;EgC9KF,gBjCoO0B;ALitI9B;AsCh7IM;E1BqCF,8BAAA;EACA,iCAAA;AZ84IJ;AsC/6IM;E1BkBF,+BAAA;EACA,kCAAA;AZg6IJ;;AuC97IA;EACE,qBAAA;EACA,qBAAA;EjC6JE,cAAA;EiC3JF,gBlCwR4B;EkCvR5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,sBAAA;ESFE,qIkBDJ;AvCi8IF;AqB57IM;EkBfN;IlBgBQ,gBAAA;ErB+7IN;AACF;AOr8IE;EgCGI,qBAAA;AvCq8IN;;AuCh8IE;EACE,aAAA;AvCm8IJ;;AuC97IA;EACE,kBAAA;EACA,SAAA;AvCi8IF;;AuC17IA;EACE,oBlCi4BkC;EkCh4BlC,mBlCg4BkC;EOv5BhC,oBAAA;AZq9IJ;;AuCr7IE;ECjDA,WAAA;EACA,yBnC0Ea;ALg6If;AO59IE;EiCVI,WAAA;EACA,yBAAA;AxCy+IN;AwCt+II;EAEE,UAAA;EACA,+CAAA;AxCu+IN;;AuCl8IE;ECjDA,WAAA;EACA,yBnC0Ea;AL66If;AOz+IE;EiCVI,WAAA;EACA,yBAAA;AxCs/IN;AwCn/II;EAEE,UAAA;EACA,iDAAA;AxCo/IN;;AuC/8IE;ECjDA,WAAA;EACA,yBnC0Ea;AL07If;AOt/IE;EiCVI,WAAA;EACA,yBAAA;AxCmgJN;AwChgJI;EAEE,UAAA;EACA,+CAAA;AxCigJN;;AuC59IE;ECjDA,WAAA;EACA,yBnC0Ea;ALu8If;AOngJE;EiCVI,WAAA;EACA,yBAAA;AxCghJN;AwC7gJI;EAEE,UAAA;EACA,gDAAA;AxC8gJN;;AuCz+IE;ECjDA,cAAA;EACA,yBnC0Ea;ALo9If;AOhhJE;EiCVI,cAAA;EACA,yBAAA;AxC6hJN;AwC1hJI;EAEE,UAAA;EACA,+CAAA;AxC2hJN;;AuCt/IE;ECjDA,WAAA;EACA,yBnC0Ea;ALi+If;AO7hJE;EiCVI,WAAA;EACA,yBAAA;AxC0iJN;AwCviJI;EAEE,UAAA;EACA,+CAAA;AxCwiJN;;AuCngJE;ECjDA,cAAA;EACA,yBnC0Ea;AL8+If;AO1iJE;EiCVI,cAAA;EACA,yBAAA;AxCujJN;AwCpjJI;EAEE,UAAA;EACA,iDAAA;AxCqjJN;;AuChhJE;ECjDA,WAAA;EACA,yBnC0Ea;AL2/If;AOvjJE;EiCVI,WAAA;EACA,yBAAA;AxCokJN;AwCjkJI;EAEE,UAAA;EACA,8CAAA;AxCkkJN;;AyC/kJA;EACE,kBAAA;EACA,mBpCyzBkC;EoCvzBlC,yBpCKS;EOSP,qBAAA;AZokJJ;AgB1hJI;EyB5DJ;IAQI,kBAAA;EzCklJF;AACF;;AyC/kJA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;AZ+kJJ;;A0C7lJA;EACE,kBAAA;EACA,wBAAA;EACA,mBrCy9BkC;EqCx9BlC,6BAAA;E9BUE,sBAAA;AZulJJ;;A0C5lJA;EAEE,cAAA;A1C8lJF;;A0C1lJA;EACE,gBrC6Q4B;ALg1I9B;;A0CrlJA;EACE,mBAAA;A1CwlJF;A0CrlJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;A1CulJJ;;A0C7kJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A1CklJvE;A2C9nJE;EACE,yBAAA;A3CgoJJ;A2C7nJE;EACE,cAAA;A3C+nJJ;;A0CzlJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A1C8lJvE;A2C1oJE;EACE,yBAAA;A3C4oJJ;A2CzoJE;EACE,cAAA;A3C2oJJ;;A0CrmJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A1C0mJvE;A2CtpJE;EACE,yBAAA;A3CwpJJ;A2CrpJE;EACE,cAAA;A3CupJJ;;A0CjnJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A1CsnJvE;A2ClqJE;EACE,yBAAA;A3CoqJJ;A2CjqJE;EACE,cAAA;A3CmqJJ;;A0C7nJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A1CkoJvE;A2C9qJE;EACE,yBAAA;A3CgrJJ;A2C7qJE;EACE,cAAA;A3C+qJJ;;A0CzoJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A1C8oJvE;A2C1rJE;EACE,yBAAA;A3C4rJJ;A2CzrJE;EACE,cAAA;A3C2rJJ;;A0CrpJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A1C0pJvE;A2CtsJE;EACE,yBAAA;A3CwsJJ;A2CrsJE;EACE,cAAA;A3CusJJ;;A0CjqJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A1CsqJvE;A2CltJE;EACE,yBAAA;A3CotJJ;A2CjtJE;EACE,cAAA;A3CmtJJ;;A4C3tJE;EACE;IAAO,2BAAA;E5C+tJT;E4C9tJE;IAAK,wBAAA;E5CiuJP;AACF;A4C9tJA;EACE,aAAA;EACA,YvCk+BkC;EuCj+BlC,gBAAA;EACA,cAAA;EtCwKI,kBAAA;EsCtKJ,yBvCLS;EOSP,sBAAA;AZ6tJJ;;A4C5tJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WvCjBS;EuCkBT,kBAAA;EACA,mBAAA;EACA,yBvCu9BkC;EgBl+B9B,2BuBYJ;A5C+tJF;AqBvuJM;EuBDN;IvBEQ,gBAAA;ErB0uJN;AACF;;A4CjuJA;ErBYE,qMAAA;EqBVA,0BAAA;A5CouJF;;A4ChuJE;EACE,kDAAA;A5CmuJJ;A4ChuJM;EAJJ;IAKM,eAAA;E5CmuJN;AACF;;A6C9wJA;EACE,aAAA;EACA,uBAAA;A7CixJF;;A6C9wJA;EACE,OAAA;A7CixJF;;A8CnxJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,sBAAA;AZ6wJJ;;A8C3wJA;EACE,WAAA;EACA,czCRS;EyCST,mBAAA;A9C8wJF;AOrxJE;EuCWE,UAAA;EACA,czCdO;EyCeP,qBAAA;EACA,yBzCtBO;ALmyJX;A8C1wJE;EACE,czClBO;EyCmBP,yBzC1BO;ALsyJX;;A8CnwJA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,sBzC3CS;EyC4CT,sCAAA;A9CowJF;A8ClwJE;ElC1BE,+BAAA;EACA,gCAAA;AZ+xJJ;A8ClwJE;ElChBE,mCAAA;EACA,kCAAA;AZqxJJ;A8ClwJE;EAEE,czClDO;EyCmDP,oBAAA;EACA,sBzC1DO;AL6zJX;A8C/vJE;EACE,UAAA;EACA,WzChEO;EyCiEP,yBzCkL0B;EyCjL1B,qBzCiL0B;ALglJ9B;A8C9vJE;EACE,mBAAA;A9CgwJJ;A8C9vJI;EACE,gBAAA;EACA,qBzC2JwB;ALqmJ9B;;A8ClvJI;EACE,mBAAA;A9CqvJN;A8ClvJQ;ElC1BJ,kCAAA;EAZA,0BAAA;AZ4xJJ;A8CjvJQ;ElC3CJ,gCAAA;EAYA,4BAAA;AZoxJJ;A8ChvJQ;EACE,aAAA;A9CkvJV;A8C/uJQ;EACE,qBzC0HoB;EyCzHpB,oBAAA;A9CivJV;A8C/uJU;EACE,iBAAA;EACA,sBzCqHkB;AL4nJ9B;;AgB5yJI;E8BmCA;IACE,mBAAA;E9C6wJJ;E8C1wJM;IlC1BJ,kCAAA;IAZA,0BAAA;EZozJF;E8CzwJM;IlC3CJ,gCAAA;IAYA,4BAAA;EZ4yJF;E8CxwJM;IACE,aAAA;E9C0wJR;E8CvwJM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E9CywJR;E8CvwJQ;IACE,iBAAA;IACA,sBzCqHkB;ELopJ5B;AACF;AgBr0JI;E8BmCA;IACE,mBAAA;E9CqyJJ;E8ClyJM;IlC1BJ,kCAAA;IAZA,0BAAA;EZ40JF;E8CjyJM;IlC3CJ,gCAAA;IAYA,4BAAA;EZo0JF;E8ChyJM;IACE,aAAA;E9CkyJR;E8C/xJM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E9CiyJR;E8C/xJQ;IACE,iBAAA;IACA,sBzCqHkB;EL4qJ5B;AACF;AgB71JI;E8BmCA;IACE,mBAAA;E9C6zJJ;E8C1zJM;IlC1BJ,kCAAA;IAZA,0BAAA;EZo2JF;E8CzzJM;IlC3CJ,gCAAA;IAYA,4BAAA;EZ41JF;E8CxzJM;IACE,aAAA;E9C0zJR;E8CvzJM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E9CyzJR;E8CvzJQ;IACE,iBAAA;IACA,sBzCqHkB;ELosJ5B;AACF;AgBr3JI;E8BmCA;IACE,mBAAA;E9Cq1JJ;E8Cl1JM;IlC1BJ,kCAAA;IAZA,0BAAA;EZ43JF;E8Cj1JM;IlC3CJ,gCAAA;IAYA,4BAAA;EZo3JF;E8Ch1JM;IACE,aAAA;E9Ck1JR;E8C/0JM;IACE,qBzC0HoB;IyCzHpB,oBAAA;E9Ci1JR;E8C/0JQ;IACE,iBAAA;IACA,sBzCqHkB;EL4tJ5B;AACF;A8Cp0JA;ElCnHI,gBAAA;AZ07JJ;A8Cp0JE;EACE,qBAAA;A9Cs0JJ;A8Cp0JI;EACE,sBAAA;A9Cs0JN;;A+C/8JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C+zJ3C;AOv8JE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/Ci9JR;A+C98JM;EACE,W1CPG;E0CQH,yBDyIkE;ECxIlE,qBDwIkE;A9Cw0J1E;;A+C79JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C60J3C;AOr9JE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/C+9JR;A+C59JM;EACE,W1CPG;E0CQH,yBDyIkE;ECxIlE,qBDwIkE;A9Cs1J1E;;A+C3+JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C21J3C;AOn+JE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/C6+JR;A+C1+JM;EACE,W1CPG;E0CQH,yBDyIkE;ECxIlE,qBDwIkE;A9Co2J1E;;A+Cz/JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Cy2J3C;AOj/JE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/C2/JR;A+Cx/JM;EACE,W1CPG;E0CQH,yBDyIkE;ECxIlE,qBDwIkE;A9Ck3J1E;;A+CvgKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Cu3J3C;AO//JE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/CygKR;A+CtgKM;EACE,W1CPG;E0CQH,yBDyIkE;ECxIlE,qBDwIkE;A9Cg4J1E;;A+CrhKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Cq4J3C;AO7gKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/CuhKR;A+CphKM;EACE,W1CPG;E0CQH,yBDyIkE;ECxIlE,qBDwIkE;A9C84J1E;;A+CniKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Cm5J3C;AO3hKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/CqiKR;A+CliKM;EACE,W1CPG;E0CQH,yBDyIkE;ECxIlE,qBDwIkE;A9C45J1E;;A+CjjKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Ci6J3C;AOziKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/CmjKR;A+ChjKM;EACE,W1CPG;E0CQH,yBDyIkE;ECxIlE,qBDwIkE;A9C06J1E;;AgDlkKA;EACE,YAAA;E1CmLI,iBAAA;E0CjLJ,gB3C8R4B;E2C7R5B,cAAA;EACA,W3CYS;E2CXT,yB3CylCkC;E2CxlClC,YAAA;AhDqkKF;AOhkKE;EyCDE,W3CMO;E2CLP,qBAAA;AhDokKJ;AOhkKE;EyCCI,aAAA;AhDkkKN;;AgDvjKA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AhD0jKF;;AgDpjKA;EACE,oBAAA;AhDujKF;;AiD7lKA;EAGE,iB5C24BkC;E4C14BlC,gB5C04BkC;EC1tB9B,mBAAA;E2C7KJ,2C5C44BkC;E4C34BlC,4BAAA;EACA,oCAAA;EACA,gD5C64BkC;E4C54BlC,UAAA;ErCOE,sBAAA;AZulKJ;AiD3lKE;EACE,sB5Cg4BgC;AL6tIpC;AiD1lKE;EACE,UAAA;AjD4lKJ;AiDzlKE;EACE,cAAA;EACA,UAAA;AjD2lKJ;AiDxlKE;EACE,aAAA;AjD0lKJ;;AiDtlKA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c5CvBS;E4CwBT,2C5Cq3BkC;E4Cp3BlC,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;AZsmKJ;;AiDvlKA;EACE,gB5Cm2BkC;ALuvIpC;;AkDhoKA;EAEE,gBAAA;AlDkoKF;AkDhoKE;EACE,kBAAA;EACA,gBAAA;AlDkoKJ;;AkD7nKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7C4pBkC;E6C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AlD8nKF;;AkDvnKA;EACE,kBAAA;EACA,WAAA;EACA,c7Ci5BkC;E6C/4BlC,oBAAA;AlDynKF;AkDtnKE;E7B3BI,mC6B4BF;EACA,8B7Cu6BgC;ALitIpC;AqBjpKM;E6BuBJ;I7BtBM,gBAAA;ErBopKN;AACF;AkD3nKE;EACE,e7Cq6BgC;ALwtIpC;AkDznKE;EACE,sB7Ck6BgC;ALytIpC;;AkDvnKA;EACE,aAAA;EACA,6BAAA;AlD0nKF;AkDxnKE;EACE,8BAAA;EACA,gBAAA;AlD0nKJ;AkDvnKE;;EAEE,cAAA;AlDynKJ;AkDtnKE;EACE,gBAAA;AlDwnKJ;;AkDpnKA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AlDunKF;AkDpnKE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AlDsnKJ;AkDlnKE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AlDonKJ;AkDlnKI;EACE,gBAAA;AlDonKN;AkDjnKI;EACE,aAAA;AlDmnKN;;AkD7mKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB7C3GS;E6C4GT,4BAAA;EACA,oCAAA;EtClGE,qBAAA;EsCsGF,UAAA;AlD4mKF;;AkDxmKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7CgjBkC;E6C/iBlC,YAAA;EACA,aAAA;EACA,sB7ClHS;AL6tKX;AkDxmKE;EAAS,UAAA;AlD2mKX;AkD1mKE;EAAS,Y7C+zByB;AL8yIpC;;AkDxmKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB7C6zBkC;E6C5zBlC,gCAAA;EtCtHE,0CAAA;EACA,2CAAA;AZkuKJ;AkD1mKE;EACE,kB7CwzBgC;E6CtzBhC,8BAAA;AlD2mKJ;;AkDtmKA;EACE,gBAAA;EACA,gB7CuI4B;ALk+J9B;;AkDpmKA;EACE,kBAAA;EAGA,cAAA;EACA,a7C0wBkC;AL21IpC;;AkDjmKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;EtCzIE,8CAAA;EACA,6CAAA;AZ8uKJ;AkDhmKE;EACE,eAAA;AlDkmKJ;;AkD7lKA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AlDgmKF;;AgBvuKI;EkC6IF;IACE,gB7CuwBgC;I6CtwBhC,oBAAA;ElD8lKF;EkD3lKA;IACE,+BAAA;ElD6lKF;EkD3lKE;IACE,gCAAA;ElD6lKJ;EkDzlKA;IACE,+BAAA;ElD2lKF;EkDzlKE;IACE,4BAAA;IACA,mBAAA;ElD2lKJ;EkDnlKA;IAAY,gB7C+uBsB;ELu2IlC;AACF;AgB9vKI;EkC2KF;;IAEE,gB7CuuBgC;EL+2IlC;AACF;AgBpwKI;EkCkLF;IAAY,iB7CiuBsB;ELq3IlC;AACF;AmDp0KA;EACE,kBAAA;EACA,a9CgrBkC;E8C/qBlC,cAAA;EACA,S9C61BkC;E+Cj2BlC,qN/CoR4B;E+ClR5B,kBAAA;EACA,gB/C4R4B;E+C3R5B,gB/CgS4B;E+C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,mBAAA;E6CzKJ,qBAAA;EACA,UAAA;AnDg1KF;AmD90KE;EAAS,Y9Ci1ByB;ALggJpC;AmD/0KE;EACE,kBAAA;EACA,cAAA;EACA,a9Ci1BgC;E8Ch1BhC,c9Ci1BgC;ALggJpC;AmD/0KI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDi1KN;;AmD50KA;EACE,iBAAA;AnD+0KF;AmD70KE;EACE,SAAA;AnD+0KJ;AmD70KI;EACE,MAAA;EACA,6BAAA;EACA,sB9CvBK;ALs2KX;;AmD10KA;EACE,iBAAA;AnD60KF;AmD30KE;EACE,OAAA;EACA,a9CmzBgC;E8ClzBhC,c9CizBgC;AL4hJpC;AmD30KI;EACE,QAAA;EACA,oCAAA;EACA,wB9CvCK;ALo3KX;;AmDx0KA;EACE,iBAAA;AnD20KF;AmDz0KE;EACE,MAAA;AnD20KJ;AmDz0KI;EACE,SAAA;EACA,6BAAA;EACA,yB9CrDK;ALg4KX;;AmDt0KA;EACE,iBAAA;AnDy0KF;AmDv0KE;EACE,QAAA;EACA,a9CqxBgC;E8CpxBhC,c9CmxBgC;ALsjJpC;AmDv0KI;EACE,OAAA;EACA,oCAAA;EACA,uB9CrEK;AL84KX;;AmDpzKA;EACE,gB9C+uBkC;E8C9uBlC,uBAAA;EACA,W9CvGS;E8CwGT,kBAAA;EACA,sB9C/FS;EOCP,sBAAA;AZs5KJ;;AqDx6KA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,ahD8qBkC;EgD7qBlC,cAAA;EACA,gBhD+2BkC;E+Cp3BlC,qN/CoR4B;E+ClR5B,kBAAA;EACA,gB/C4R4B;E+C3R5B,gB/CgS4B;E+C/R5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,mBAAA;E+CxKJ,qBAAA;EACA,sBhDNS;EgDOT,4BAAA;EACA,oCAAA;EzCGE,qBAAA;AZm7KJ;AqDl7KE;EACE,kBAAA;EACA,cAAA;EACA,WhD+2BgC;EgD92BhC,chD+2BgC;EgD92BhC,gBAAA;ArDo7KJ;AqDl7KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDm7KN;;AqD96KA;EACE,qBhDg2BkC;ALilJpC;AqD/6KE;EACE,2BAAA;ArDi7KJ;AqD/6KI;EACE,SAAA;EACA,6BAAA;EACA,qChD21B8B;ALslJpC;AqD96KI;EACE,WhD0LwB;EgDzLxB,6BAAA;EACA,sBhD7CK;AL69KX;;AqD36KA;EACE,mBhD40BkC;ALkmJpC;AqD56KE;EACE,yBAAA;EACA,ahDw0BgC;EgDv0BhC,YhDs0BgC;EgDr0BhC,gBAAA;ArD86KJ;AqD56KI;EACE,OAAA;EACA,oCAAA;EACA,uChDo0B8B;AL0mJpC;AqD36KI;EACE,ShDmKwB;EgDlKxB,oCAAA;EACA,wBhDpEK;ALi/KX;;AqDx6KA;EACE,kBhDqzBkC;ALsnJpC;AqDz6KE;EACE,wBAAA;ArD26KJ;AqDz6KI;EACE,MAAA;EACA,oCAAA;EACA,wChDgzB8B;AL2nJpC;AqDx6KI;EACE,QhD+IwB;EgD9IxB,oCAAA;EACA,yBhDxFK;ALkgLX;AqDr6KE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WhD4xBgC;EgD3xBhC,oBAAA;EACA,WAAA;EACA,gCAAA;ArDu6KJ;;AqDn6KA;EACE,oBhDqxBkC;ALipJpC;AqDp6KE;EACE,0BAAA;EACA,ahDixBgC;EgDhxBhC,YhD+wBgC;EgD9wBhC,gBAAA;ArDs6KJ;AqDp6KI;EACE,QAAA;EACA,oCAAA;EACA,sChD6wB8B;ALypJpC;AqDn6KI;EACE,UhD4GwB;EgD3GxB,oCAAA;EACA,uBhD3HK;ALgiLX;;AqD/4KA;EACE,uBAAA;EACA,gBAAA;E/C0BI,eAAA;E+CvBJ,yBhD+tBkC;EgD9tBlC,gCAAA;EzCnIE,0CAAA;EACA,2CAAA;AZqhLJ;AqDh5KE;EACE,aAAA;ArDk5KJ;;AqD94KA;EACE,uBAAA;EACA,chDxJS;ALyiLX;;AsD5iLA;EACE,kBAAA;AtD+iLF;;AsD5iLA;EACE,mBAAA;AtD+iLF;;AsD5iLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtD+iLF;AuDtkLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDwkLJ;;AsDhjLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;AtDmjLF;AqBlkLM;EiCQN;IjCPQ,gBAAA;ErBqkLN;AACF;;AsDrjLA;;;EAGE,cAAA;AtDwjLF;;AsDrjLA;;EAEE,2BAAA;AtDwjLF;;AsDrjLA;;EAEE,4BAAA;AtDwjLF;;AsD/iLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDkjLJ;AsD/iLE;;;EAGE,UAAA;EACA,UAAA;AtDijLJ;AsD9iLE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;AtDgjLJ;AqBzmLM;EiCqDJ;;IjCpDM,gBAAA;ErB6mLN;AACF;;AsD7iLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDs9BmC;EiDr9BnC,UAAA;EACA,WjD3FS;EiD4FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjDi9BmC;EgBviC/B,8BiCuFJ;AtD+iLF;AqBloLM;EiCkEN;;IjCjEQ,gBAAA;ErBsoLN;AACF;AO5oLE;;;E+C2FE,WjDpGO;EiDqGP,qBAAA;EACA,UAAA;EACA,YjD08BiC;AL4mJrC;;AsDnjLA;EACE,OAAA;AtDsjLF;;AsDjjLA;EACE,QAAA;AtDojLF;;AsD7iLA;;EAEE,qBAAA;EACA,WjDm8BmC;EiDl8BnC,YjDk8BmC;EiDj8BnC,mCAAA;AtDgjLF;;AsD9iLA;EACE,0DAAA;AtDijLF;;AsD/iLA;EACE,0DAAA;AtDkjLF;;AsDziLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBjDy5BmC;EiDx5BnC,gBjDw5BmC;EiDv5BnC,gBAAA;AtD2iLF;AsDziLE;EACE,uBAAA;EACA,cAAA;EACA,WjDu5BiC;EiDt5BjC,WjDu5BiC;EiDt5BjC,iBjDw5BiC;EiDv5BjC,gBjDu5BiC;EiDt5BjC,mBAAA;EACA,eAAA;EACA,sBjDnKO;EiDoKP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;AtD0iLJ;AqBtsLM;EiC6IJ;IjC5IM,gBAAA;ErBysLN;AACF;AsD5iLE;EACE,UAAA;AtD8iLJ;;AsDriLA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WjD9LS;EiD+LT,kBAAA;AtDwiLF;;AwD1uLA;EACE;IAAK,yBAAA;ExD8uLL;AACF;AwD5uLA;EACE,qBAAA;EACA,WnDskCwB;EmDrkCxB,YnDqkCwB;EmDpkCxB,wBnDskCwB;EmDrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AxD6uLF;;AwD1uLA;EACE,WnDgkCwB;EmD/jCxB,YnD+jCwB;EmD9jCxB,mBnDgkCwB;AL6qJ1B;;AwDtuLA;EACE;IACE,mBAAA;ExDyuLF;EwDvuLA;IACE,UAAA;IACA,eAAA;ExDyuLF;AACF;AwDtuLA;EACE,qBAAA;EACA,WnDsiCwB;EmDriCxB,YnDqiCwB;EmDpiCxB,wBnDsiCwB;EmDriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AxDuuLF;;AwDpuLA;EACE,WnDgiCwB;EmD/hCxB,YnD+hCwB;ALwsJ1B;;AwDnuLE;EACE;;IAEE,wBAAA;ExDsuLJ;AACF;AyDlyLA;EAAqB,mCAAA;AzDqyLrB;;AyDpyLA;EAAqB,8BAAA;AzDwyLrB;;AyDvyLA;EAAqB,iCAAA;AzD2yLrB;;AyD1yLA;EAAqB,iCAAA;AzD8yLrB;;AyD7yLA;EAAqB,sCAAA;AzDizLrB;;AyDhzLA;EAAqB,mCAAA;AzDozLrB;;A0DtzLE;EACE,oCAAA;A1DyzLJ;;AO/yLE;;;EmDLI,oCAAA;A1D0zLN;;A0Dh0LE;EACE,oCAAA;A1Dm0LJ;;AOzzLE;;;EmDLI,oCAAA;A1Do0LN;;A0D10LE;EACE,oCAAA;A1D60LJ;;AOn0LE;;;EmDLI,oCAAA;A1D80LN;;A0Dp1LE;EACE,oCAAA;A1Du1LJ;;AO70LE;;;EmDLI,oCAAA;A1Dw1LN;;A0D91LE;EACE,oCAAA;A1Di2LJ;;AOv1LE;;;EmDLI,oCAAA;A1Dk2LN;;A0Dx2LE;EACE,oCAAA;A1D22LJ;;AOj2LE;;;EmDLI,oCAAA;A1D42LN;;A0Dl3LE;EACE,oCAAA;A1Dq3LJ;;AO32LE;;;EmDLI,oCAAA;A1Ds3LN;;A0D53LE;EACE,oCAAA;A1D+3LJ;;AOr3LE;;;EmDLI,oCAAA;A1Dg4LN;;A2D/3LA;EACE,iCAAA;A3Dk4LF;;A2D/3LA;EACE,wCAAA;A3Dk4LF;;A4D74LA;EAAkB,oCAAA;A5Di5LlB;;A4Dh5LA;EAAkB,wCAAA;A5Do5LlB;;A4Dn5LA;EAAkB,0CAAA;A5Du5LlB;;A4Dt5LA;EAAkB,2CAAA;A5D05LlB;;A4Dz5LA;EAAkB,yCAAA;A5D65LlB;;A4D35LA;EAAmB,oBAAA;A5D+5LnB;;A4D95LA;EAAmB,wBAAA;A5Dk6LnB;;A4Dj6LA;EAAmB,0BAAA;A5Dq6LnB;;A4Dp6LA;EAAmB,2BAAA;A5Dw6LnB;;A4Dv6LA;EAAmB,yBAAA;A5D26LnB;;A4Dx6LE;EACE,gCAAA;A5D26LJ;;A4D56LE;EACE,gCAAA;A5D+6LJ;;A4Dh7LE;EACE,gCAAA;A5Dm7LJ;;A4Dp7LE;EACE,gCAAA;A5Du7LJ;;A4Dx7LE;EACE,gCAAA;A5D27LJ;;A4D57LE;EACE,gCAAA;A5D+7LJ;;A4Dh8LE;EACE,gCAAA;A5Dm8LJ;;A4Dp8LE;EACE,gCAAA;A5Du8LJ;;A4Dn8LA;EACE,6BAAA;A5Ds8LF;;A4D/7LA;EACE,gCAAA;A5Dk8LF;;A4D/7LA;EACE,iCAAA;A5Dk8LF;;A4D/7LA;EACE,0CAAA;EACA,2CAAA;A5Dk8LF;;A4D/7LA;EACE,2CAAA;EACA,8CAAA;A5Dk8LF;;A4D/7LA;EACE,8CAAA;EACA,6CAAA;A5Dk8LF;;A4D/7LA;EACE,0CAAA;EACA,6CAAA;A5Dk8LF;;A4D/7LA;EACE,gCAAA;A5Dk8LF;;A4D/7LA;EACE,6BAAA;A5Dk8LF;;A4D/7LA;EACE,+BAAA;A5Dk8LF;;A4D/7LA;EACE,2BAAA;A5Dk8LF;;AuD1gME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD6gMJ;;A6DtgMM;EAAwB,wBAAA;A7D0gM9B;;A6D1gMM;EAAwB,0BAAA;A7D8gM9B;;A6D9gMM;EAAwB,gCAAA;A7DkhM9B;;A6DlhMM;EAAwB,yBAAA;A7DshM9B;;A6DthMM;EAAwB,yBAAA;A7D0hM9B;;A6D1hMM;EAAwB,6BAAA;A7D8hM9B;;A6D9hMM;EAAwB,8BAAA;A7DkiM9B;;A6DliMM;EAAwB,wBAAA;A7DsiM9B;;A6DtiMM;EAAwB,+BAAA;A7D0iM9B;;AgBz/LI;E6CjDE;IAAwB,wBAAA;E7D+iM5B;E6D/iMI;IAAwB,0BAAA;E7DkjM5B;E6DljMI;IAAwB,gCAAA;E7DqjM5B;E6DrjMI;IAAwB,yBAAA;E7DwjM5B;E6DxjMI;IAAwB,yBAAA;E7D2jM5B;E6D3jMI;IAAwB,6BAAA;E7D8jM5B;E6D9jMI;IAAwB,8BAAA;E7DikM5B;E6DjkMI;IAAwB,wBAAA;E7DokM5B;E6DpkMI;IAAwB,+BAAA;E7DukM5B;AACF;AgBvhMI;E6CjDE;IAAwB,wBAAA;E7D4kM5B;E6D5kMI;IAAwB,0BAAA;E7D+kM5B;E6D/kMI;IAAwB,gCAAA;E7DklM5B;E6DllMI;IAAwB,yBAAA;E7DqlM5B;E6DrlMI;IAAwB,yBAAA;E7DwlM5B;E6DxlMI;IAAwB,6BAAA;E7D2lM5B;E6D3lMI;IAAwB,8BAAA;E7D8lM5B;E6D9lMI;IAAwB,wBAAA;E7DimM5B;E6DjmMI;IAAwB,+BAAA;E7DomM5B;AACF;AgBpjMI;E6CjDE;IAAwB,wBAAA;E7DymM5B;E6DzmMI;IAAwB,0BAAA;E7D4mM5B;E6D5mMI;IAAwB,gCAAA;E7D+mM5B;E6D/mMI;IAAwB,yBAAA;E7DknM5B;E6DlnMI;IAAwB,yBAAA;E7DqnM5B;E6DrnMI;IAAwB,6BAAA;E7DwnM5B;E6DxnMI;IAAwB,8BAAA;E7D2nM5B;E6D3nMI;IAAwB,wBAAA;E7D8nM5B;E6D9nMI;IAAwB,+BAAA;E7DioM5B;AACF;AgBjlMI;E6CjDE;IAAwB,wBAAA;E7DsoM5B;E6DtoMI;IAAwB,0BAAA;E7DyoM5B;E6DzoMI;IAAwB,gCAAA;E7D4oM5B;E6D5oMI;IAAwB,yBAAA;E7D+oM5B;E6D/oMI;IAAwB,yBAAA;E7DkpM5B;E6DlpMI;IAAwB,6BAAA;E7DqpM5B;E6DrpMI;IAAwB,8BAAA;E7DwpM5B;E6DxpMI;IAAwB,wBAAA;E7D2pM5B;E6D3pMI;IAAwB,+BAAA;E7D8pM5B;AACF;A6DrpMA;EAEI;IAAqB,wBAAA;E7DupMvB;E6DvpME;IAAqB,0BAAA;E7D0pMvB;E6D1pME;IAAqB,gCAAA;E7D6pMvB;E6D7pME;IAAqB,yBAAA;E7DgqMvB;E6DhqME;IAAqB,yBAAA;E7DmqMvB;E6DnqME;IAAqB,6BAAA;E7DsqMvB;E6DtqME;IAAqB,8BAAA;E7DyqMvB;E6DzqME;IAAqB,wBAAA;E7D4qMvB;E6D5qME;IAAqB,+BAAA;E7D+qMvB;AACF;A8DrsMA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A9DusMF;A8DrsME;EACE,cAAA;EACA,WAAA;A9DusMJ;A8DpsME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A9DssMJ;;A8D7rMI;EACE,yBAAA;A9DgsMN;;A8DjsMI;EACE,mBAAA;A9DosMN;;A8DrsMI;EACE,gBAAA;A9DwsMN;;A8DzsMI;EACE,iBAAA;A9D4sMN;;A+DruMI;EAAgC,8BAAA;A/DyuMpC;;A+DxuMI;EAAgC,iCAAA;A/D4uMpC;;A+D3uMI;EAAgC,sCAAA;A/D+uMpC;;A+D9uMI;EAAgC,yCAAA;A/DkvMpC;;A+DhvMI;EAA8B,0BAAA;A/DovMlC;;A+DnvMI;EAA8B,4BAAA;A/DuvMlC;;A+DtvMI;EAA8B,kCAAA;A/D0vMlC;;A+DzvMI;EAA8B,yBAAA;A/D6vMlC;;A+D5vMI;EAA8B,uBAAA;A/DgwMlC;;A+D/vMI;EAA8B,uBAAA;A/DmwMlC;;A+DlwMI;EAA8B,yBAAA;A/DswMlC;;A+DrwMI;EAA8B,yBAAA;A/DywMlC;;A+DvwMI;EAAoC,sCAAA;A/D2wMxC;;A+D1wMI;EAAoC,oCAAA;A/D8wMxC;;A+D7wMI;EAAoC,kCAAA;A/DixMxC;;A+DhxMI;EAAoC,yCAAA;A/DoxMxC;;A+DnxMI;EAAoC,wCAAA;A/DuxMxC;;A+DrxMI;EAAiC,kCAAA;A/DyxMrC;;A+DxxMI;EAAiC,gCAAA;A/D4xMrC;;A+D3xMI;EAAiC,8BAAA;A/D+xMrC;;A+D9xMI;EAAiC,gCAAA;A/DkyMrC;;A+DjyMI;EAAiC,+BAAA;A/DqyMrC;;A+DnyMI;EAAkC,oCAAA;A/DuyMtC;;A+DtyMI;EAAkC,kCAAA;A/D0yMtC;;A+DzyMI;EAAkC,gCAAA;A/D6yMtC;;A+D5yMI;EAAkC,uCAAA;A/DgzMtC;;A+D/yMI;EAAkC,sCAAA;A/DmzMtC;;A+DlzMI;EAAkC,iCAAA;A/DszMtC;;A+DpzMI;EAAgC,2BAAA;A/DwzMpC;;A+DvzMI;EAAgC,iCAAA;A/D2zMpC;;A+D1zMI;EAAgC,+BAAA;A/D8zMpC;;A+D7zMI;EAAgC,6BAAA;A/Di0MpC;;A+Dh0MI;EAAgC,+BAAA;A/Do0MpC;;A+Dn0MI;EAAgC,8BAAA;A/Du0MpC;;AgB3zMI;E+ClDA;IAAgC,8BAAA;E/Dk3MlC;E+Dj3ME;IAAgC,iCAAA;E/Do3MlC;E+Dn3ME;IAAgC,sCAAA;E/Ds3MlC;E+Dr3ME;IAAgC,yCAAA;E/Dw3MlC;E+Dt3ME;IAA8B,0BAAA;E/Dy3MhC;E+Dx3ME;IAA8B,4BAAA;E/D23MhC;E+D13ME;IAA8B,kCAAA;E/D63MhC;E+D53ME;IAA8B,yBAAA;E/D+3MhC;E+D93ME;IAA8B,uBAAA;E/Di4MhC;E+Dh4ME;IAA8B,uBAAA;E/Dm4MhC;E+Dl4ME;IAA8B,yBAAA;E/Dq4MhC;E+Dp4ME;IAA8B,yBAAA;E/Du4MhC;E+Dr4ME;IAAoC,sCAAA;E/Dw4MtC;E+Dv4ME;IAAoC,oCAAA;E/D04MtC;E+Dz4ME;IAAoC,kCAAA;E/D44MtC;E+D34ME;IAAoC,yCAAA;E/D84MtC;E+D74ME;IAAoC,wCAAA;E/Dg5MtC;E+D94ME;IAAiC,kCAAA;E/Di5MnC;E+Dh5ME;IAAiC,gCAAA;E/Dm5MnC;E+Dl5ME;IAAiC,8BAAA;E/Dq5MnC;E+Dp5ME;IAAiC,gCAAA;E/Du5MnC;E+Dt5ME;IAAiC,+BAAA;E/Dy5MnC;E+Dv5ME;IAAkC,oCAAA;E/D05MpC;E+Dz5ME;IAAkC,kCAAA;E/D45MpC;E+D35ME;IAAkC,gCAAA;E/D85MpC;E+D75ME;IAAkC,uCAAA;E/Dg6MpC;E+D/5ME;IAAkC,sCAAA;E/Dk6MpC;E+Dj6ME;IAAkC,iCAAA;E/Do6MpC;E+Dl6ME;IAAgC,2BAAA;E/Dq6MlC;E+Dp6ME;IAAgC,iCAAA;E/Du6MlC;E+Dt6ME;IAAgC,+BAAA;E/Dy6MlC;E+Dx6ME;IAAgC,6BAAA;E/D26MlC;E+D16ME;IAAgC,+BAAA;E/D66MlC;E+D56ME;IAAgC,8BAAA;E/D+6MlC;AACF;AgBp6MI;E+ClDA;IAAgC,8BAAA;E/D09MlC;E+Dz9ME;IAAgC,iCAAA;E/D49MlC;E+D39ME;IAAgC,sCAAA;E/D89MlC;E+D79ME;IAAgC,yCAAA;E/Dg+MlC;E+D99ME;IAA8B,0BAAA;E/Di+MhC;E+Dh+ME;IAA8B,4BAAA;E/Dm+MhC;E+Dl+ME;IAA8B,kCAAA;E/Dq+MhC;E+Dp+ME;IAA8B,yBAAA;E/Du+MhC;E+Dt+ME;IAA8B,uBAAA;E/Dy+MhC;E+Dx+ME;IAA8B,uBAAA;E/D2+MhC;E+D1+ME;IAA8B,yBAAA;E/D6+MhC;E+D5+ME;IAA8B,yBAAA;E/D++MhC;E+D7+ME;IAAoC,sCAAA;E/Dg/MtC;E+D/+ME;IAAoC,oCAAA;E/Dk/MtC;E+Dj/ME;IAAoC,kCAAA;E/Do/MtC;E+Dn/ME;IAAoC,yCAAA;E/Ds/MtC;E+Dr/ME;IAAoC,wCAAA;E/Dw/MtC;E+Dt/ME;IAAiC,kCAAA;E/Dy/MnC;E+Dx/ME;IAAiC,gCAAA;E/D2/MnC;E+D1/ME;IAAiC,8BAAA;E/D6/MnC;E+D5/ME;IAAiC,gCAAA;E/D+/MnC;E+D9/ME;IAAiC,+BAAA;E/DigNnC;E+D//ME;IAAkC,oCAAA;E/DkgNpC;E+DjgNE;IAAkC,kCAAA;E/DogNpC;E+DngNE;IAAkC,gCAAA;E/DsgNpC;E+DrgNE;IAAkC,uCAAA;E/DwgNpC;E+DvgNE;IAAkC,sCAAA;E/D0gNpC;E+DzgNE;IAAkC,iCAAA;E/D4gNpC;E+D1gNE;IAAgC,2BAAA;E/D6gNlC;E+D5gNE;IAAgC,iCAAA;E/D+gNlC;E+D9gNE;IAAgC,+BAAA;E/DihNlC;E+DhhNE;IAAgC,6BAAA;E/DmhNlC;E+DlhNE;IAAgC,+BAAA;E/DqhNlC;E+DphNE;IAAgC,8BAAA;E/DuhNlC;AACF;AgB5gNI;E+ClDA;IAAgC,8BAAA;E/DkkNlC;E+DjkNE;IAAgC,iCAAA;E/DokNlC;E+DnkNE;IAAgC,sCAAA;E/DskNlC;E+DrkNE;IAAgC,yCAAA;E/DwkNlC;E+DtkNE;IAA8B,0BAAA;E/DykNhC;E+DxkNE;IAA8B,4BAAA;E/D2kNhC;E+D1kNE;IAA8B,kCAAA;E/D6kNhC;E+D5kNE;IAA8B,yBAAA;E/D+kNhC;E+D9kNE;IAA8B,uBAAA;E/DilNhC;E+DhlNE;IAA8B,uBAAA;E/DmlNhC;E+DllNE;IAA8B,yBAAA;E/DqlNhC;E+DplNE;IAA8B,yBAAA;E/DulNhC;E+DrlNE;IAAoC,sCAAA;E/DwlNtC;E+DvlNE;IAAoC,oCAAA;E/D0lNtC;E+DzlNE;IAAoC,kCAAA;E/D4lNtC;E+D3lNE;IAAoC,yCAAA;E/D8lNtC;E+D7lNE;IAAoC,wCAAA;E/DgmNtC;E+D9lNE;IAAiC,kCAAA;E/DimNnC;E+DhmNE;IAAiC,gCAAA;E/DmmNnC;E+DlmNE;IAAiC,8BAAA;E/DqmNnC;E+DpmNE;IAAiC,gCAAA;E/DumNnC;E+DtmNE;IAAiC,+BAAA;E/DymNnC;E+DvmNE;IAAkC,oCAAA;E/D0mNpC;E+DzmNE;IAAkC,kCAAA;E/D4mNpC;E+D3mNE;IAAkC,gCAAA;E/D8mNpC;E+D7mNE;IAAkC,uCAAA;E/DgnNpC;E+D/mNE;IAAkC,sCAAA;E/DknNpC;E+DjnNE;IAAkC,iCAAA;E/DonNpC;E+DlnNE;IAAgC,2BAAA;E/DqnNlC;E+DpnNE;IAAgC,iCAAA;E/DunNlC;E+DtnNE;IAAgC,+BAAA;E/DynNlC;E+DxnNE;IAAgC,6BAAA;E/D2nNlC;E+D1nNE;IAAgC,+BAAA;E/D6nNlC;E+D5nNE;IAAgC,8BAAA;E/D+nNlC;AACF;AgBpnNI;E+ClDA;IAAgC,8BAAA;E/D0qNlC;E+DzqNE;IAAgC,iCAAA;E/D4qNlC;E+D3qNE;IAAgC,sCAAA;E/D8qNlC;E+D7qNE;IAAgC,yCAAA;E/DgrNlC;E+D9qNE;IAA8B,0BAAA;E/DirNhC;E+DhrNE;IAA8B,4BAAA;E/DmrNhC;E+DlrNE;IAA8B,kCAAA;E/DqrNhC;E+DprNE;IAA8B,yBAAA;E/DurNhC;E+DtrNE;IAA8B,uBAAA;E/DyrNhC;E+DxrNE;IAA8B,uBAAA;E/D2rNhC;E+D1rNE;IAA8B,yBAAA;E/D6rNhC;E+D5rNE;IAA8B,yBAAA;E/D+rNhC;E+D7rNE;IAAoC,sCAAA;E/DgsNtC;E+D/rNE;IAAoC,oCAAA;E/DksNtC;E+DjsNE;IAAoC,kCAAA;E/DosNtC;E+DnsNE;IAAoC,yCAAA;E/DssNtC;E+DrsNE;IAAoC,wCAAA;E/DwsNtC;E+DtsNE;IAAiC,kCAAA;E/DysNnC;E+DxsNE;IAAiC,gCAAA;E/D2sNnC;E+D1sNE;IAAiC,8BAAA;E/D6sNnC;E+D5sNE;IAAiC,gCAAA;E/D+sNnC;E+D9sNE;IAAiC,+BAAA;E/DitNnC;E+D/sNE;IAAkC,oCAAA;E/DktNpC;E+DjtNE;IAAkC,kCAAA;E/DotNpC;E+DntNE;IAAkC,gCAAA;E/DstNpC;E+DrtNE;IAAkC,uCAAA;E/DwtNpC;E+DvtNE;IAAkC,sCAAA;E/D0tNpC;E+DztNE;IAAkC,iCAAA;E/D4tNpC;E+D1tNE;IAAgC,2BAAA;E/D6tNlC;E+D5tNE;IAAgC,iCAAA;E/D+tNlC;E+D9tNE;IAAgC,+BAAA;E/DiuNlC;E+DhuNE;IAAgC,6BAAA;E/DmuNlC;E+DluNE;IAAgC,+BAAA;E/DquNlC;E+DpuNE;IAAgC,8BAAA;E/DuuNlC;AACF;AgElxNI;EAAwB,sBAAA;AhEqxN5B;;AgEpxNI;EAAwB,uBAAA;AhEwxN5B;;AgEvxNI;EAAwB,sBAAA;AhE2xN5B;;AgBvuNI;EgDtDA;IAAwB,sBAAA;EhEkyN1B;EgEjyNE;IAAwB,uBAAA;EhEoyN1B;EgEnyNE;IAAwB,sBAAA;EhEsyN1B;AACF;AgBnvNI;EgDtDA;IAAwB,sBAAA;EhE6yN1B;EgE5yNE;IAAwB,uBAAA;EhE+yN1B;EgE9yNE;IAAwB,sBAAA;EhEizN1B;AACF;AgB9vNI;EgDtDA;IAAwB,sBAAA;EhEwzN1B;EgEvzNE;IAAwB,uBAAA;EhE0zN1B;EgEzzNE;IAAwB,sBAAA;EhE4zN1B;AACF;AgBzwNI;EgDtDA;IAAwB,sBAAA;EhEm0N1B;EgEl0NE;IAAwB,uBAAA;EhEq0N1B;EgEp0NE;IAAwB,sBAAA;EhEu0N1B;AACF;AiE70NE;EAAyB,2BAAA;AjEg1N3B;;AiEh1NE;EAAyB,4BAAA;AjEo1N3B;;AiEp1NE;EAAyB,4BAAA;AjEw1N3B;;AkEx1NE;EAAsB,yBAAA;AlE41NxB;;AkE51NE;EAAsB,2BAAA;AlEg2NxB;;AmE/1NE;EAAyB,2BAAA;AnEm2N3B;;AmEn2NE;EAAyB,6BAAA;AnEu2N3B;;AmEv2NE;EAAyB,6BAAA;AnE22N3B;;AmE32NE;EAAyB,0BAAA;AnE+2N3B;;AmE/2NE;EAAyB,2BAAA;AnEm3N3B;;AmE92NA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a9DiqBkC;ALgtMpC;;AmE92NA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a9DypBkC;ALwtMpC;;AmE72NE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a9DipBgC;ELguMlC;AACF;;AoE34NA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ArE64NF;;AqEn4NE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;ArEq4NJ;;AsEl6NA;EAAa,8DAAA;AtEs6Nb;;AsEr6NA;EAAU,wDAAA;AtEy6NV;;AsEx6NA;EAAa,uDAAA;AtE46Nb;;AsE36NA;EAAe,2BAAA;AtE+6Nf;;AuE96NI;EAAuB,qBAAA;AvEk7N3B;;AuEl7NI;EAAuB,qBAAA;AvEs7N3B;;AuEt7NI;EAAuB,qBAAA;AvE07N3B;;AuE17NI;EAAuB,sBAAA;AvE87N3B;;AuE97NI;EAAuB,sBAAA;AvEk8N3B;;AuEl8NI;EAAuB,sBAAA;AvEs8N3B;;AuEt8NI;EAAuB,sBAAA;AvE08N3B;;AuE18NI;EAAuB,sBAAA;AvE88N3B;;AuE98NI;EAAuB,uBAAA;AvEk9N3B;;AuEl9NI;EAAuB,uBAAA;AvEs9N3B;;AuEl9NA;EAAU,0BAAA;AvEs9NV;;AuEr9NA;EAAU,2BAAA;AvEy9NV;;AuEr9NA;EAAc,2BAAA;AvEy9Nd;;AuEx9NA;EAAc,4BAAA;AvE49Nd;;AuE19NA;EAAU,uBAAA;AvE89NV;;AuE79NA;EAAU,wBAAA;AvEi+NV;;AwE1+NQ;EAAgC,oBAAA;AxE8+NxC;;AwE7+NQ;;EAEE,wBAAA;AxEg/NV;;AwE9+NQ;;EAEE,0BAAA;AxEi/NV;;AwE/+NQ;;EAEE,2BAAA;AxEk/NV;;AwEh/NQ;;EAEE,yBAAA;AxEm/NV;;AwElgOQ;EAAgC,0BAAA;AxEsgOxC;;AwErgOQ;;EAEE,8BAAA;AxEwgOV;;AwEtgOQ;;EAEE,gCAAA;AxEygOV;;AwEvgOQ;;EAEE,iCAAA;AxE0gOV;;AwExgOQ;;EAEE,+BAAA;AxE2gOV;;AwE1hOQ;EAAgC,yBAAA;AxE8hOxC;;AwE7hOQ;;EAEE,6BAAA;AxEgiOV;;AwE9hOQ;;EAEE,+BAAA;AxEiiOV;;AwE/hOQ;;EAEE,gCAAA;AxEkiOV;;AwEhiOQ;;EAEE,8BAAA;AxEmiOV;;AwEljOQ;EAAgC,uBAAA;AxEsjOxC;;AwErjOQ;;EAEE,2BAAA;AxEwjOV;;AwEtjOQ;;EAEE,6BAAA;AxEyjOV;;AwEvjOQ;;EAEE,8BAAA;AxE0jOV;;AwExjOQ;;EAEE,4BAAA;AxE2jOV;;AwE1kOQ;EAAgC,yBAAA;AxE8kOxC;;AwE7kOQ;;EAEE,6BAAA;AxEglOV;;AwE9kOQ;;EAEE,+BAAA;AxEilOV;;AwE/kOQ;;EAEE,gCAAA;AxEklOV;;AwEhlOQ;;EAEE,8BAAA;AxEmlOV;;AwElmOQ;EAAgC,uBAAA;AxEsmOxC;;AwErmOQ;;EAEE,2BAAA;AxEwmOV;;AwEtmOQ;;EAEE,6BAAA;AxEymOV;;AwEvmOQ;;EAEE,8BAAA;AxE0mOV;;AwExmOQ;;EAEE,4BAAA;AxE2mOV;;AwE1nOQ;EAAgC,qBAAA;AxE8nOxC;;AwE7nOQ;;EAEE,yBAAA;AxEgoOV;;AwE9nOQ;;EAEE,2BAAA;AxEioOV;;AwE/nOQ;;EAEE,4BAAA;AxEkoOV;;AwEhoOQ;;EAEE,0BAAA;AxEmoOV;;AwElpOQ;EAAgC,2BAAA;AxEspOxC;;AwErpOQ;;EAEE,+BAAA;AxEwpOV;;AwEtpOQ;;EAEE,iCAAA;AxEypOV;;AwEvpOQ;;EAEE,kCAAA;AxE0pOV;;AwExpOQ;;EAEE,gCAAA;AxE2pOV;;AwE1qOQ;EAAgC,0BAAA;AxE8qOxC;;AwE7qOQ;;EAEE,8BAAA;AxEgrOV;;AwE9qOQ;;EAEE,gCAAA;AxEirOV;;AwE/qOQ;;EAEE,iCAAA;AxEkrOV;;AwEhrOQ;;EAEE,+BAAA;AxEmrOV;;AwElsOQ;EAAgC,wBAAA;AxEssOxC;;AwErsOQ;;EAEE,4BAAA;AxEwsOV;;AwEtsOQ;;EAEE,8BAAA;AxEysOV;;AwEvsOQ;;EAEE,+BAAA;AxE0sOV;;AwExsOQ;;EAEE,6BAAA;AxE2sOV;;AwE1tOQ;EAAgC,0BAAA;AxE8tOxC;;AwE7tOQ;;EAEE,8BAAA;AxEguOV;;AwE9tOQ;;EAEE,gCAAA;AxEiuOV;;AwE/tOQ;;EAEE,iCAAA;AxEkuOV;;AwEhuOQ;;EAEE,+BAAA;AxEmuOV;;AwElvOQ;EAAgC,wBAAA;AxEsvOxC;;AwErvOQ;;EAEE,4BAAA;AxEwvOV;;AwEtvOQ;;EAEE,8BAAA;AxEyvOV;;AwEvvOQ;;EAEE,+BAAA;AxE0vOV;;AwExvOQ;;EAEE,6BAAA;AxE2vOV;;AwEnvOQ;EAAwB,2BAAA;AxEuvOhC;;AwEtvOQ;;EAEE,+BAAA;AxEyvOV;;AwEvvOQ;;EAEE,iCAAA;AxE0vOV;;AwExvOQ;;EAEE,kCAAA;AxE2vOV;;AwEzvOQ;;EAEE,gCAAA;AxE4vOV;;AwE3wOQ;EAAwB,0BAAA;AxE+wOhC;;AwE9wOQ;;EAEE,8BAAA;AxEixOV;;AwE/wOQ;;EAEE,gCAAA;AxEkxOV;;AwEhxOQ;;EAEE,iCAAA;AxEmxOV;;AwEjxOQ;;EAEE,+BAAA;AxEoxOV;;AwEnyOQ;EAAwB,wBAAA;AxEuyOhC;;AwEtyOQ;;EAEE,4BAAA;AxEyyOV;;AwEvyOQ;;EAEE,8BAAA;AxE0yOV;;AwExyOQ;;EAEE,+BAAA;AxE2yOV;;AwEzyOQ;;EAEE,6BAAA;AxE4yOV;;AwE3zOQ;EAAwB,0BAAA;AxE+zOhC;;AwE9zOQ;;EAEE,8BAAA;AxEi0OV;;AwE/zOQ;;EAEE,gCAAA;AxEk0OV;;AwEh0OQ;;EAEE,iCAAA;AxEm0OV;;AwEj0OQ;;EAEE,+BAAA;AxEo0OV;;AwEn1OQ;EAAwB,wBAAA;AxEu1OhC;;AwEt1OQ;;EAEE,4BAAA;AxEy1OV;;AwEv1OQ;;EAEE,8BAAA;AxE01OV;;AwEx1OQ;;EAEE,+BAAA;AxE21OV;;AwEz1OQ;;EAEE,6BAAA;AxE41OV;;AwEt1OI;EAAmB,uBAAA;AxE01OvB;;AwEz1OI;;EAEE,2BAAA;AxE41ON;;AwE11OI;;EAEE,6BAAA;AxE61ON;;AwE31OI;;EAEE,8BAAA;AxE81ON;;AwE51OI;;EAEE,4BAAA;AxE+1ON;;AgBx2OI;EwDlDI;IAAgC,oBAAA;ExE+5OtC;EwE95OM;;IAEE,wBAAA;ExEg6OR;EwE95OM;;IAEE,0BAAA;ExEg6OR;EwE95OM;;IAEE,2BAAA;ExEg6OR;EwE95OM;;IAEE,yBAAA;ExEg6OR;EwE/6OM;IAAgC,0BAAA;ExEk7OtC;EwEj7OM;;IAEE,8BAAA;ExEm7OR;EwEj7OM;;IAEE,gCAAA;ExEm7OR;EwEj7OM;;IAEE,iCAAA;ExEm7OR;EwEj7OM;;IAEE,+BAAA;ExEm7OR;EwEl8OM;IAAgC,yBAAA;ExEq8OtC;EwEp8OM;;IAEE,6BAAA;ExEs8OR;EwEp8OM;;IAEE,+BAAA;ExEs8OR;EwEp8OM;;IAEE,gCAAA;ExEs8OR;EwEp8OM;;IAEE,8BAAA;ExEs8OR;EwEr9OM;IAAgC,uBAAA;ExEw9OtC;EwEv9OM;;IAEE,2BAAA;ExEy9OR;EwEv9OM;;IAEE,6BAAA;ExEy9OR;EwEv9OM;;IAEE,8BAAA;ExEy9OR;EwEv9OM;;IAEE,4BAAA;ExEy9OR;EwEx+OM;IAAgC,yBAAA;ExE2+OtC;EwE1+OM;;IAEE,6BAAA;ExE4+OR;EwE1+OM;;IAEE,+BAAA;ExE4+OR;EwE1+OM;;IAEE,gCAAA;ExE4+OR;EwE1+OM;;IAEE,8BAAA;ExE4+OR;EwE3/OM;IAAgC,uBAAA;ExE8/OtC;EwE7/OM;;IAEE,2BAAA;ExE+/OR;EwE7/OM;;IAEE,6BAAA;ExE+/OR;EwE7/OM;;IAEE,8BAAA;ExE+/OR;EwE7/OM;;IAEE,4BAAA;ExE+/OR;EwE9gPM;IAAgC,qBAAA;ExEihPtC;EwEhhPM;;IAEE,yBAAA;ExEkhPR;EwEhhPM;;IAEE,2BAAA;ExEkhPR;EwEhhPM;;IAEE,4BAAA;ExEkhPR;EwEhhPM;;IAEE,0BAAA;ExEkhPR;EwEjiPM;IAAgC,2BAAA;ExEoiPtC;EwEniPM;;IAEE,+BAAA;ExEqiPR;EwEniPM;;IAEE,iCAAA;ExEqiPR;EwEniPM;;IAEE,kCAAA;ExEqiPR;EwEniPM;;IAEE,gCAAA;ExEqiPR;EwEpjPM;IAAgC,0BAAA;ExEujPtC;EwEtjPM;;IAEE,8BAAA;ExEwjPR;EwEtjPM;;IAEE,gCAAA;ExEwjPR;EwEtjPM;;IAEE,iCAAA;ExEwjPR;EwEtjPM;;IAEE,+BAAA;ExEwjPR;EwEvkPM;IAAgC,wBAAA;ExE0kPtC;EwEzkPM;;IAEE,4BAAA;ExE2kPR;EwEzkPM;;IAEE,8BAAA;ExE2kPR;EwEzkPM;;IAEE,+BAAA;ExE2kPR;EwEzkPM;;IAEE,6BAAA;ExE2kPR;EwE1lPM;IAAgC,0BAAA;ExE6lPtC;EwE5lPM;;IAEE,8BAAA;ExE8lPR;EwE5lPM;;IAEE,gCAAA;ExE8lPR;EwE5lPM;;IAEE,iCAAA;ExE8lPR;EwE5lPM;;IAEE,+BAAA;ExE8lPR;EwE7mPM;IAAgC,wBAAA;ExEgnPtC;EwE/mPM;;IAEE,4BAAA;ExEinPR;EwE/mPM;;IAEE,8BAAA;ExEinPR;EwE/mPM;;IAEE,+BAAA;ExEinPR;EwE/mPM;;IAEE,6BAAA;ExEinPR;EwEzmPM;IAAwB,2BAAA;ExE4mP9B;EwE3mPM;;IAEE,+BAAA;ExE6mPR;EwE3mPM;;IAEE,iCAAA;ExE6mPR;EwE3mPM;;IAEE,kCAAA;ExE6mPR;EwE3mPM;;IAEE,gCAAA;ExE6mPR;EwE5nPM;IAAwB,0BAAA;ExE+nP9B;EwE9nPM;;IAEE,8BAAA;ExEgoPR;EwE9nPM;;IAEE,gCAAA;ExEgoPR;EwE9nPM;;IAEE,iCAAA;ExEgoPR;EwE9nPM;;IAEE,+BAAA;ExEgoPR;EwE/oPM;IAAwB,wBAAA;ExEkpP9B;EwEjpPM;;IAEE,4BAAA;ExEmpPR;EwEjpPM;;IAEE,8BAAA;ExEmpPR;EwEjpPM;;IAEE,+BAAA;ExEmpPR;EwEjpPM;;IAEE,6BAAA;ExEmpPR;EwElqPM;IAAwB,0BAAA;ExEqqP9B;EwEpqPM;;IAEE,8BAAA;ExEsqPR;EwEpqPM;;IAEE,gCAAA;ExEsqPR;EwEpqPM;;IAEE,iCAAA;ExEsqPR;EwEpqPM;;IAEE,+BAAA;ExEsqPR;EwErrPM;IAAwB,wBAAA;ExEwrP9B;EwEvrPM;;IAEE,4BAAA;ExEyrPR;EwEvrPM;;IAEE,8BAAA;ExEyrPR;EwEvrPM;;IAEE,+BAAA;ExEyrPR;EwEvrPM;;IAEE,6BAAA;ExEyrPR;EwEnrPE;IAAmB,uBAAA;ExEsrPrB;EwErrPE;;IAEE,2BAAA;ExEurPJ;EwErrPE;;IAEE,6BAAA;ExEurPJ;EwErrPE;;IAEE,8BAAA;ExEurPJ;EwErrPE;;IAEE,4BAAA;ExEurPJ;AACF;AgBjsPI;EwDlDI;IAAgC,oBAAA;ExEuvPtC;EwEtvPM;;IAEE,wBAAA;ExEwvPR;EwEtvPM;;IAEE,0BAAA;ExEwvPR;EwEtvPM;;IAEE,2BAAA;ExEwvPR;EwEtvPM;;IAEE,yBAAA;ExEwvPR;EwEvwPM;IAAgC,0BAAA;ExE0wPtC;EwEzwPM;;IAEE,8BAAA;ExE2wPR;EwEzwPM;;IAEE,gCAAA;ExE2wPR;EwEzwPM;;IAEE,iCAAA;ExE2wPR;EwEzwPM;;IAEE,+BAAA;ExE2wPR;EwE1xPM;IAAgC,yBAAA;ExE6xPtC;EwE5xPM;;IAEE,6BAAA;ExE8xPR;EwE5xPM;;IAEE,+BAAA;ExE8xPR;EwE5xPM;;IAEE,gCAAA;ExE8xPR;EwE5xPM;;IAEE,8BAAA;ExE8xPR;EwE7yPM;IAAgC,uBAAA;ExEgzPtC;EwE/yPM;;IAEE,2BAAA;ExEizPR;EwE/yPM;;IAEE,6BAAA;ExEizPR;EwE/yPM;;IAEE,8BAAA;ExEizPR;EwE/yPM;;IAEE,4BAAA;ExEizPR;EwEh0PM;IAAgC,yBAAA;ExEm0PtC;EwEl0PM;;IAEE,6BAAA;ExEo0PR;EwEl0PM;;IAEE,+BAAA;ExEo0PR;EwEl0PM;;IAEE,gCAAA;ExEo0PR;EwEl0PM;;IAEE,8BAAA;ExEo0PR;EwEn1PM;IAAgC,uBAAA;ExEs1PtC;EwEr1PM;;IAEE,2BAAA;ExEu1PR;EwEr1PM;;IAEE,6BAAA;ExEu1PR;EwEr1PM;;IAEE,8BAAA;ExEu1PR;EwEr1PM;;IAEE,4BAAA;ExEu1PR;EwEt2PM;IAAgC,qBAAA;ExEy2PtC;EwEx2PM;;IAEE,yBAAA;ExE02PR;EwEx2PM;;IAEE,2BAAA;ExE02PR;EwEx2PM;;IAEE,4BAAA;ExE02PR;EwEx2PM;;IAEE,0BAAA;ExE02PR;EwEz3PM;IAAgC,2BAAA;ExE43PtC;EwE33PM;;IAEE,+BAAA;ExE63PR;EwE33PM;;IAEE,iCAAA;ExE63PR;EwE33PM;;IAEE,kCAAA;ExE63PR;EwE33PM;;IAEE,gCAAA;ExE63PR;EwE54PM;IAAgC,0BAAA;ExE+4PtC;EwE94PM;;IAEE,8BAAA;ExEg5PR;EwE94PM;;IAEE,gCAAA;ExEg5PR;EwE94PM;;IAEE,iCAAA;ExEg5PR;EwE94PM;;IAEE,+BAAA;ExEg5PR;EwE/5PM;IAAgC,wBAAA;ExEk6PtC;EwEj6PM;;IAEE,4BAAA;ExEm6PR;EwEj6PM;;IAEE,8BAAA;ExEm6PR;EwEj6PM;;IAEE,+BAAA;ExEm6PR;EwEj6PM;;IAEE,6BAAA;ExEm6PR;EwEl7PM;IAAgC,0BAAA;ExEq7PtC;EwEp7PM;;IAEE,8BAAA;ExEs7PR;EwEp7PM;;IAEE,gCAAA;ExEs7PR;EwEp7PM;;IAEE,iCAAA;ExEs7PR;EwEp7PM;;IAEE,+BAAA;ExEs7PR;EwEr8PM;IAAgC,wBAAA;ExEw8PtC;EwEv8PM;;IAEE,4BAAA;ExEy8PR;EwEv8PM;;IAEE,8BAAA;ExEy8PR;EwEv8PM;;IAEE,+BAAA;ExEy8PR;EwEv8PM;;IAEE,6BAAA;ExEy8PR;EwEj8PM;IAAwB,2BAAA;ExEo8P9B;EwEn8PM;;IAEE,+BAAA;ExEq8PR;EwEn8PM;;IAEE,iCAAA;ExEq8PR;EwEn8PM;;IAEE,kCAAA;ExEq8PR;EwEn8PM;;IAEE,gCAAA;ExEq8PR;EwEp9PM;IAAwB,0BAAA;ExEu9P9B;EwEt9PM;;IAEE,8BAAA;ExEw9PR;EwEt9PM;;IAEE,gCAAA;ExEw9PR;EwEt9PM;;IAEE,iCAAA;ExEw9PR;EwEt9PM;;IAEE,+BAAA;ExEw9PR;EwEv+PM;IAAwB,wBAAA;ExE0+P9B;EwEz+PM;;IAEE,4BAAA;ExE2+PR;EwEz+PM;;IAEE,8BAAA;ExE2+PR;EwEz+PM;;IAEE,+BAAA;ExE2+PR;EwEz+PM;;IAEE,6BAAA;ExE2+PR;EwE1/PM;IAAwB,0BAAA;ExE6/P9B;EwE5/PM;;IAEE,8BAAA;ExE8/PR;EwE5/PM;;IAEE,gCAAA;ExE8/PR;EwE5/PM;;IAEE,iCAAA;ExE8/PR;EwE5/PM;;IAEE,+BAAA;ExE8/PR;EwE7gQM;IAAwB,wBAAA;ExEghQ9B;EwE/gQM;;IAEE,4BAAA;ExEihQR;EwE/gQM;;IAEE,8BAAA;ExEihQR;EwE/gQM;;IAEE,+BAAA;ExEihQR;EwE/gQM;;IAEE,6BAAA;ExEihQR;EwE3gQE;IAAmB,uBAAA;ExE8gQrB;EwE7gQE;;IAEE,2BAAA;ExE+gQJ;EwE7gQE;;IAEE,6BAAA;ExE+gQJ;EwE7gQE;;IAEE,8BAAA;ExE+gQJ;EwE7gQE;;IAEE,4BAAA;ExE+gQJ;AACF;AgBzhQI;EwDlDI;IAAgC,oBAAA;ExE+kQtC;EwE9kQM;;IAEE,wBAAA;ExEglQR;EwE9kQM;;IAEE,0BAAA;ExEglQR;EwE9kQM;;IAEE,2BAAA;ExEglQR;EwE9kQM;;IAEE,yBAAA;ExEglQR;EwE/lQM;IAAgC,0BAAA;ExEkmQtC;EwEjmQM;;IAEE,8BAAA;ExEmmQR;EwEjmQM;;IAEE,gCAAA;ExEmmQR;EwEjmQM;;IAEE,iCAAA;ExEmmQR;EwEjmQM;;IAEE,+BAAA;ExEmmQR;EwElnQM;IAAgC,yBAAA;ExEqnQtC;EwEpnQM;;IAEE,6BAAA;ExEsnQR;EwEpnQM;;IAEE,+BAAA;ExEsnQR;EwEpnQM;;IAEE,gCAAA;ExEsnQR;EwEpnQM;;IAEE,8BAAA;ExEsnQR;EwEroQM;IAAgC,uBAAA;ExEwoQtC;EwEvoQM;;IAEE,2BAAA;ExEyoQR;EwEvoQM;;IAEE,6BAAA;ExEyoQR;EwEvoQM;;IAEE,8BAAA;ExEyoQR;EwEvoQM;;IAEE,4BAAA;ExEyoQR;EwExpQM;IAAgC,yBAAA;ExE2pQtC;EwE1pQM;;IAEE,6BAAA;ExE4pQR;EwE1pQM;;IAEE,+BAAA;ExE4pQR;EwE1pQM;;IAEE,gCAAA;ExE4pQR;EwE1pQM;;IAEE,8BAAA;ExE4pQR;EwE3qQM;IAAgC,uBAAA;ExE8qQtC;EwE7qQM;;IAEE,2BAAA;ExE+qQR;EwE7qQM;;IAEE,6BAAA;ExE+qQR;EwE7qQM;;IAEE,8BAAA;ExE+qQR;EwE7qQM;;IAEE,4BAAA;ExE+qQR;EwE9rQM;IAAgC,qBAAA;ExEisQtC;EwEhsQM;;IAEE,yBAAA;ExEksQR;EwEhsQM;;IAEE,2BAAA;ExEksQR;EwEhsQM;;IAEE,4BAAA;ExEksQR;EwEhsQM;;IAEE,0BAAA;ExEksQR;EwEjtQM;IAAgC,2BAAA;ExEotQtC;EwEntQM;;IAEE,+BAAA;ExEqtQR;EwEntQM;;IAEE,iCAAA;ExEqtQR;EwEntQM;;IAEE,kCAAA;ExEqtQR;EwEntQM;;IAEE,gCAAA;ExEqtQR;EwEpuQM;IAAgC,0BAAA;ExEuuQtC;EwEtuQM;;IAEE,8BAAA;ExEwuQR;EwEtuQM;;IAEE,gCAAA;ExEwuQR;EwEtuQM;;IAEE,iCAAA;ExEwuQR;EwEtuQM;;IAEE,+BAAA;ExEwuQR;EwEvvQM;IAAgC,wBAAA;ExE0vQtC;EwEzvQM;;IAEE,4BAAA;ExE2vQR;EwEzvQM;;IAEE,8BAAA;ExE2vQR;EwEzvQM;;IAEE,+BAAA;ExE2vQR;EwEzvQM;;IAEE,6BAAA;ExE2vQR;EwE1wQM;IAAgC,0BAAA;ExE6wQtC;EwE5wQM;;IAEE,8BAAA;ExE8wQR;EwE5wQM;;IAEE,gCAAA;ExE8wQR;EwE5wQM;;IAEE,iCAAA;ExE8wQR;EwE5wQM;;IAEE,+BAAA;ExE8wQR;EwE7xQM;IAAgC,wBAAA;ExEgyQtC;EwE/xQM;;IAEE,4BAAA;ExEiyQR;EwE/xQM;;IAEE,8BAAA;ExEiyQR;EwE/xQM;;IAEE,+BAAA;ExEiyQR;EwE/xQM;;IAEE,6BAAA;ExEiyQR;EwEzxQM;IAAwB,2BAAA;ExE4xQ9B;EwE3xQM;;IAEE,+BAAA;ExE6xQR;EwE3xQM;;IAEE,iCAAA;ExE6xQR;EwE3xQM;;IAEE,kCAAA;ExE6xQR;EwE3xQM;;IAEE,gCAAA;ExE6xQR;EwE5yQM;IAAwB,0BAAA;ExE+yQ9B;EwE9yQM;;IAEE,8BAAA;ExEgzQR;EwE9yQM;;IAEE,gCAAA;ExEgzQR;EwE9yQM;;IAEE,iCAAA;ExEgzQR;EwE9yQM;;IAEE,+BAAA;ExEgzQR;EwE/zQM;IAAwB,wBAAA;ExEk0Q9B;EwEj0QM;;IAEE,4BAAA;ExEm0QR;EwEj0QM;;IAEE,8BAAA;ExEm0QR;EwEj0QM;;IAEE,+BAAA;ExEm0QR;EwEj0QM;;IAEE,6BAAA;ExEm0QR;EwEl1QM;IAAwB,0BAAA;ExEq1Q9B;EwEp1QM;;IAEE,8BAAA;ExEs1QR;EwEp1QM;;IAEE,gCAAA;ExEs1QR;EwEp1QM;;IAEE,iCAAA;ExEs1QR;EwEp1QM;;IAEE,+BAAA;ExEs1QR;EwEr2QM;IAAwB,wBAAA;ExEw2Q9B;EwEv2QM;;IAEE,4BAAA;ExEy2QR;EwEv2QM;;IAEE,8BAAA;ExEy2QR;EwEv2QM;;IAEE,+BAAA;ExEy2QR;EwEv2QM;;IAEE,6BAAA;ExEy2QR;EwEn2QE;IAAmB,uBAAA;ExEs2QrB;EwEr2QE;;IAEE,2BAAA;ExEu2QJ;EwEr2QE;;IAEE,6BAAA;ExEu2QJ;EwEr2QE;;IAEE,8BAAA;ExEu2QJ;EwEr2QE;;IAEE,4BAAA;ExEu2QJ;AACF;AgBj3QI;EwDlDI;IAAgC,oBAAA;ExEu6QtC;EwEt6QM;;IAEE,wBAAA;ExEw6QR;EwEt6QM;;IAEE,0BAAA;ExEw6QR;EwEt6QM;;IAEE,2BAAA;ExEw6QR;EwEt6QM;;IAEE,yBAAA;ExEw6QR;EwEv7QM;IAAgC,0BAAA;ExE07QtC;EwEz7QM;;IAEE,8BAAA;ExE27QR;EwEz7QM;;IAEE,gCAAA;ExE27QR;EwEz7QM;;IAEE,iCAAA;ExE27QR;EwEz7QM;;IAEE,+BAAA;ExE27QR;EwE18QM;IAAgC,yBAAA;ExE68QtC;EwE58QM;;IAEE,6BAAA;ExE88QR;EwE58QM;;IAEE,+BAAA;ExE88QR;EwE58QM;;IAEE,gCAAA;ExE88QR;EwE58QM;;IAEE,8BAAA;ExE88QR;EwE79QM;IAAgC,uBAAA;ExEg+QtC;EwE/9QM;;IAEE,2BAAA;ExEi+QR;EwE/9QM;;IAEE,6BAAA;ExEi+QR;EwE/9QM;;IAEE,8BAAA;ExEi+QR;EwE/9QM;;IAEE,4BAAA;ExEi+QR;EwEh/QM;IAAgC,yBAAA;ExEm/QtC;EwEl/QM;;IAEE,6BAAA;ExEo/QR;EwEl/QM;;IAEE,+BAAA;ExEo/QR;EwEl/QM;;IAEE,gCAAA;ExEo/QR;EwEl/QM;;IAEE,8BAAA;ExEo/QR;EwEngRM;IAAgC,uBAAA;ExEsgRtC;EwErgRM;;IAEE,2BAAA;ExEugRR;EwErgRM;;IAEE,6BAAA;ExEugRR;EwErgRM;;IAEE,8BAAA;ExEugRR;EwErgRM;;IAEE,4BAAA;ExEugRR;EwEthRM;IAAgC,qBAAA;ExEyhRtC;EwExhRM;;IAEE,yBAAA;ExE0hRR;EwExhRM;;IAEE,2BAAA;ExE0hRR;EwExhRM;;IAEE,4BAAA;ExE0hRR;EwExhRM;;IAEE,0BAAA;ExE0hRR;EwEziRM;IAAgC,2BAAA;ExE4iRtC;EwE3iRM;;IAEE,+BAAA;ExE6iRR;EwE3iRM;;IAEE,iCAAA;ExE6iRR;EwE3iRM;;IAEE,kCAAA;ExE6iRR;EwE3iRM;;IAEE,gCAAA;ExE6iRR;EwE5jRM;IAAgC,0BAAA;ExE+jRtC;EwE9jRM;;IAEE,8BAAA;ExEgkRR;EwE9jRM;;IAEE,gCAAA;ExEgkRR;EwE9jRM;;IAEE,iCAAA;ExEgkRR;EwE9jRM;;IAEE,+BAAA;ExEgkRR;EwE/kRM;IAAgC,wBAAA;ExEklRtC;EwEjlRM;;IAEE,4BAAA;ExEmlRR;EwEjlRM;;IAEE,8BAAA;ExEmlRR;EwEjlRM;;IAEE,+BAAA;ExEmlRR;EwEjlRM;;IAEE,6BAAA;ExEmlRR;EwElmRM;IAAgC,0BAAA;ExEqmRtC;EwEpmRM;;IAEE,8BAAA;ExEsmRR;EwEpmRM;;IAEE,gCAAA;ExEsmRR;EwEpmRM;;IAEE,iCAAA;ExEsmRR;EwEpmRM;;IAEE,+BAAA;ExEsmRR;EwErnRM;IAAgC,wBAAA;ExEwnRtC;EwEvnRM;;IAEE,4BAAA;ExEynRR;EwEvnRM;;IAEE,8BAAA;ExEynRR;EwEvnRM;;IAEE,+BAAA;ExEynRR;EwEvnRM;;IAEE,6BAAA;ExEynRR;EwEjnRM;IAAwB,2BAAA;ExEonR9B;EwEnnRM;;IAEE,+BAAA;ExEqnRR;EwEnnRM;;IAEE,iCAAA;ExEqnRR;EwEnnRM;;IAEE,kCAAA;ExEqnRR;EwEnnRM;;IAEE,gCAAA;ExEqnRR;EwEpoRM;IAAwB,0BAAA;ExEuoR9B;EwEtoRM;;IAEE,8BAAA;ExEwoRR;EwEtoRM;;IAEE,gCAAA;ExEwoRR;EwEtoRM;;IAEE,iCAAA;ExEwoRR;EwEtoRM;;IAEE,+BAAA;ExEwoRR;EwEvpRM;IAAwB,wBAAA;ExE0pR9B;EwEzpRM;;IAEE,4BAAA;ExE2pRR;EwEzpRM;;IAEE,8BAAA;ExE2pRR;EwEzpRM;;IAEE,+BAAA;ExE2pRR;EwEzpRM;;IAEE,6BAAA;ExE2pRR;EwE1qRM;IAAwB,0BAAA;ExE6qR9B;EwE5qRM;;IAEE,8BAAA;ExE8qRR;EwE5qRM;;IAEE,gCAAA;ExE8qRR;EwE5qRM;;IAEE,iCAAA;ExE8qRR;EwE5qRM;;IAEE,+BAAA;ExE8qRR;EwE7rRM;IAAwB,wBAAA;ExEgsR9B;EwE/rRM;;IAEE,4BAAA;ExEisRR;EwE/rRM;;IAEE,8BAAA;ExEisRR;EwE/rRM;;IAEE,+BAAA;ExEisRR;EwE/rRM;;IAEE,6BAAA;ExEisRR;EwE3rRE;IAAmB,uBAAA;ExE8rRrB;EwE7rRE;;IAEE,2BAAA;ExE+rRJ;EwE7rRE;;IAEE,6BAAA;ExE+rRJ;EwE7rRE;;IAEE,8BAAA;ExE+rRJ;EwE7rRE;;IAEE,4BAAA;ExE+rRJ;AACF;AyEhwRE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AzEgwRJ;;A0E1wRA;EAAkB,4GAAA;A1E8wRlB;;A0E1wRA;EAAiB,8BAAA;A1E8wRjB;;A0E7wRA;EAAiB,8BAAA;A1EixRjB;;A0EhxRA;EAAiB,8BAAA;A1EoxRjB;;A0EnxRA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A3EgyRF;;A0EjxRI;EAAwB,2BAAA;A1EqxR5B;;A0EpxRI;EAAwB,4BAAA;A1EwxR5B;;A0EvxRI;EAAwB,6BAAA;A1E2xR5B;;AgBtvRI;E0DvCA;IAAwB,2BAAA;E1EkyR1B;E0EjyRE;IAAwB,4BAAA;E1EoyR1B;E0EnyRE;IAAwB,6BAAA;E1EsyR1B;AACF;AgBlwRI;E0DvCA;IAAwB,2BAAA;E1E6yR1B;E0E5yRE;IAAwB,4BAAA;E1E+yR1B;E0E9yRE;IAAwB,6BAAA;E1EizR1B;AACF;AgB7wRI;E0DvCA;IAAwB,2BAAA;E1EwzR1B;E0EvzRE;IAAwB,4BAAA;E1E0zR1B;E0EzzRE;IAAwB,6BAAA;E1E4zR1B;AACF;AgBxxRI;E0DvCA;IAAwB,2BAAA;E1Em0R1B;E0El0RE;IAAwB,4BAAA;E1Eq0R1B;E0Ep0RE;IAAwB,6BAAA;E1Eu0R1B;AACF;A0El0RA;EAAmB,oCAAA;A1Eq0RnB;;A0Ep0RA;EAAmB,oCAAA;A1Ew0RnB;;A0Ev0RA;EAAmB,qCAAA;A1E20RnB;;A0Ev0RA;EAAuB,2BAAA;A1E20RvB;;A0E10RA;EAAuB,+BAAA;A1E80RvB;;A0E70RA;EAAuB,2BAAA;A1Ei1RvB;;A0Eh1RA;EAAuB,2BAAA;A1Eo1RvB;;A0En1RA;EAAuB,8BAAA;A1Eu1RvB;;A0Et1RA;EAAuB,6BAAA;A1E01RvB;;A0Et1RA;EAAc,sBAAA;A1E01Rd;;A4Ej4RE;EACE,yBAAA;A5Eo4RJ;;AO13RE;EqELM,yBAAA;A5Em4RR;;A4Ez4RE;EACE,yBAAA;A5E44RJ;;AOl4RE;EqELM,yBAAA;A5E24RR;;A4Ej5RE;EACE,yBAAA;A5Eo5RJ;;AO14RE;EqELM,yBAAA;A5Em5RR;;A4Ez5RE;EACE,yBAAA;A5E45RJ;;AOl5RE;EqELM,yBAAA;A5E25RR;;A4Ej6RE;EACE,yBAAA;A5Eo6RJ;;AO15RE;EqELM,yBAAA;A5Em6RR;;A4Ez6RE;EACE,yBAAA;A5E46RJ;;AOl6RE;EqELM,yBAAA;A5E26RR;;A4Ej7RE;EACE,yBAAA;A5Eo7RJ;;AO16RE;EqELM,yBAAA;A5Em7RR;;A4Ez7RE;EACE,yBAAA;A5E47RJ;;AOl7RE;EqELM,yBAAA;A5E27RR;;A0Ep5RA;EAAa,yBAAA;A1Ew5Rb;;A0Ev5RA;EAAc,yBAAA;A1E25Rd;;A0Ez5RA;EAAiB,oCAAA;A1E65RjB;;A0E55RA;EAAiB,0CAAA;A1Eg6RjB;;A0E55RA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A7Eu9RF;;A0Eh6RA;EAAwB,gCAAA;A1Eo6RxB;;A0El6RA;EACE,iCAAA;EACA,gCAAA;A1Eq6RF;;A0Eh6RA;EAAc,yBAAA;A1Eo6Rd;;A8Er+RA;EACE,8BAAA;A9Ew+RF;;A8Er+RA;EACE,6BAAA;A9Ew+RF;;A+Ex+RE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E/Ew+RJ;E+Ep+RI;IACE,0BAAA;E/Es+RN;E+E79RE;IACE,6BAAA;E/E+9RJ;E+Ej9RE;IACE,gCAAA;E/Em9RJ;E+Ej9RE;;IAEE,yBAAA;IACA,wBAAA;E/Em9RJ;E+Eh9RE;;IAEE,wBAAA;E/Ek9RJ;E+E/8RE;;;IAGE,UAAA;IACA,SAAA;E/Ei9RJ;E+E98RE;;IAEE,uBAAA;E/Eg9RJ;E+Ex8RE;IACE,Q1E2iC8B;EL+5PlC;E+Ex8RE;IACE,2BAAA;E/E08RJ;E+Ex8RE;IACE,2BAAA;E/E08RJ;E+Et8RE;IACE,aAAA;E/Ew8RJ;E+Et8RE;IACE,sBAAA;E/Ew8RJ;E+Er8RE;IACE,oCAAA;E/Eu8RJ;E+Er8RI;;IAEE,iCAAA;E/Eu8RN;E+El8RI;;IAEE,oCAAA;E/Eo8RN;E+Eh8RE;IACE,cAAA;E/Ek8RJ;E+Eh8RI;;;;IAIE,qB1E9GG;ELgjST;E+E97RE;IACE,cAAA;IACA,qB1EpHK;ELojST;AACF;AgF/jSA;EACC,gCAAA;AhFikSD;;AgF9jSA;EACC,uBAAA;AhFikSD;;AgF5jSA;EACC,UAAA;AhF+jSD;;AgF5jSA;EACC,qBAAA;EACA,eAAA;EACA,yB/EVW;E+EWX,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AhF+jSD;AgF3jSC;EACC,cAAA;AhF6jSF;AgF3jSE;EAHD;IAIE,eAAA;IACA,aAAA;EhF8jSD;AACF;AgF3jSC;EACC,cAAA;AhF6jSF;AgF3jSE;EAHD;IAIE,eAAA;EhF8jSD;AACF;AgF1jSC;EACC,yB/ElDqB;AD8mSvB;AgFzjSC;EACC,kBAAA;EACA,eAAA;AhF2jSF;AgFtjSC;EACC,YAAA;EACA,WAAA;EACA,qBAAA;AhFwjSF;AgFpjSC;EACC,sBAAA;EACA,c/EjEW;ADunSb;AgFnjSC;EACC,yBAAA;EACA,cAAA;EACA,eAAA;AhFqjSF;AgFnjSE;EACC,YAAA;EACA,cAAA;EACA,qBAAA;AhFqjSH;;AgF9iSC;EACC,eAAA;AhFijSF;AgF7iSE;EADD;IAEE,gBAAA;EhFgjSD;AACF;AgF7iSC;EACC,iBAAA;AhF+iSF;;AgF3iSA;EACC,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,mBAAA;EAEA,qBAAA;AhF4iSD;AgF1iSC;EAbD;IAcE,uBAAA;IACA,SAAA;EhF6iSA;AACF;;AgFtiSA;EACC,YAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AhFyiSD;AgFtiSC;EACC,yB/ElIW;E+EmIX,WAAA;EACA,YAAA;EACA,yBAAA;AhFwiSF;AgFriSC;EAfD;IAgBE,iBAAA;EhFwiSA;AACF;AgFtiSC;EACC,yB/E7IW;E+E8IX,WAAA;EACA,yBAAA;AhFwiSF;;AgFniSA;EAEC,eAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,sBAAA;AhFqiSD;AgFniSC;EAVD;IAWE,eAAA;IACA,WAAA;IACA,WAAA;IACA,MAAA;IACA,QAAA;IACA,OAAA;IACA,6BAAA;EhFsiSA;AACF;AgFpiSC;EACC,WAAA;AhFsiSF;AgFliSE;EADD;IAEE,sBAAA;IACA,6BAAA;EhFqiSD;EgFniSC;IACC,cAAA;EhFqiSF;EgFliSC;IACC,yB/E1LmB;I+E2LnB,WAAA;EhFoiSF;AACF;AgF/hSC;EACC,kDAAA;EACA,eAAA;AhFiiSF;AgF/hSE;EAJD;IAKE,eAAA;IACA,YAAA;EhFkiSD;AACF;AgF7hSE;EACC,6BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;AhF+hSH;AgF7hSG;EACC,yB/EhNQ;AD+uSZ;AgF1hSC;EACC,kBAAA;AhF4hSF;AgF1hSE;EAHD;IAIE,aAAA;EhF6hSD;AACF;AgF1hSC;EACC,SAAA;AhF4hSF;AgFxhSC;EACC,SAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhF0hSF;AgFthSC;EACC,kBAAA;AhFwhSF;AgFrhSC;EACC,eAAA;EACA,SAAA;EACA,c/EhPa;ADuwSf;AgFrhSE;EACC,SAAA;AhFuhSH;AgFnhSC;EACC,sBAAA;EACA,aAAA;EACA,0BAAA;AhFqhSF;AgFnhSE;EALD;IAME,YAAA;IACA,aAAA;IACA,6BAAA;EhFshSD;AACF;AgFphSE;EACC,cAAA;AhFshSH;AgFhhSC;EACC,UAAA;EACA,SAAA;EACA,gBAAA;EACA,2CAAA;AhFkhSF;AgFhhSE;EACC,sBAAA;AhFkhSH;AgFhhSG;EAHD;IAIE,6BAAA;EhFmhSF;AACF;AgFhhSE;EAdD;IAeE,YAAA;IACA,aAAA;EhFmhSD;AACF;AgFhhSC;EACC,kBAAA;AhFkhSF;AgFhhSE;EAHD;IAIE,kBAAA;EhFmhSD;AACF;AgFjhSE;EACC,yBAAA;AhFmhSH;AgFjhSG;EAHD;IAIE,6BAAA;EhFohSF;AACF;AgF/gSC;EACC,c/EtTW;E+EuTX,gBAAA;EACA,cAAA;EACA,kBAAA;AhFihSF;AgF/gSE;EAND;IAOE,eAAA;IACA,WAAA;EhFkhSD;EgFhhSC;IACC,c/E9TQ;I+E+TR,qBAAA;EhFkhSF;AACF;AgF9gSE;EACC,kBAAA;EACA,YAAA;EACA,0DAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,4BAAA;EACA,wBAAA;EACA,MAAA;AhFghSH;AgF9gSG;EAZD;IAaE,YAAA;EhFihSF;AACF;AgF7gSC;EACC,+CAAA;EACA,kDAAA;EACA,eAAA;AhF+gSF;AgFvgSE;EACC,kBAAA;AhFygSH;AgFtgSE;EACC,0BAAA;AhFwgSH;AgFrgSE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AhFugSH;AgFpgSI;EACC,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AhFsgSL;AgFlgSK;EACC,yBAAA;AhFogSN;AgF1/RC;EACC,c/ErYU;E+EsYV,gBAAA;EACA,eAAA;EACA,mBAAA;AhF4/RF;AgFz/RC;EACC,eAAA;EACA,QAAA;AhF2/RF;AgFx/RC;EACC,QAAA;AhF0/RF;AgFt/RE;EADD;IAEE,SAAA;EhFy/RD;AACF;;AgFl/RA;EACC,gBAAA;AhFq/RD;AgFn/RC;EAHD;IAIE,aAAA;EhFs/RA;AACF;AgFp/RC;EACC,WAAA;EACA,yB/EzaW;AD+5Sb;AgFn/RC;EACC,eAAA;AhFq/RF;AgFn/RE;EAHD;IAIE,eAAA;IACA,sBAAA;EhFs/RD;AACF;AgFh/RC;EACC,iC/E5aW;E+E6aX,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AhFk/RF;AgFh/RE;EARD;IASE,eAAA;IACA,iBAAA;IACA,mBAAA;EhFm/RD;AACF;AgF/+RC;EACC,oB/E7bY;E+E8bZ,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AhFi/RF;AgF/+RE;EARD;IASE,eAAA;IACA,iBAAA;IACA,mBAAA;EhFk/RD;AACF;AgF9+RC;EACC,SAAA;EACA,mBAAA;AhFg/RF;AgF9+RE;EAJD;IAKE,mBAAA;EhFi/RD;AACF;AgF/+RE;EACC,YAAA;AhFi/RH;AgF/+RG;EAHD;IAKE,YAAA;EhFi/RF;AACF;AgF5+RC;EACC,mBAAA;EACA,iBAAA;EACA,cAAA;AhF8+RF;AgF5+RE;EALD;IAME,gBAAA;IACA,iBAAA;EhF++RD;AACF;AgF1+RE;EADD;IAEE,gBAAA;EhF6+RD;AACF;AgF1+RC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AhF4+RF;AgFz+RG;EACC,UAAA;EACA,WAAA;EACA,mDAAA;EACA,kBAAA;EACA,qBAAA;AhF2+RJ;AgFv+RI;EACC,sBAAA;AhFy+RL;;AgF/9RA;EACC,eAAA;EACA,kBAAA;AhFk+RD;AgFh+RC;EAJD;IAKE,oBAAA;EhFm+RA;AACF;AgFh+RC;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AhFk+RF;AgF/9RC;EACC,iBAAA;EACA,eAAA;EACA,c/EriBa;E+EsiBb,gBAAA;EACA,qBAAA;EACA,mBAAA;AhFi+RF;AgF/9RE;EARD;IASE,iBAAA;IACA,eAAA;IACA,iBAAA;EhFk+RD;AACF;AgF19RE;EAHD;IAIE,gBAAA;IACA,qBAAA;EhF69RD;EgF39RC;IACC,gBAAA;IACA,YAAA;IACA,qBAAA;EhF69RF;AACF;;AgFt9RA;EACC,kBAAA;EACA,kBAAA;AhFy9RD;AgFv9RC;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AhFy9RF;AgFt9RC;EAXD;IAYE,kBAAA;EhFy9RA;AACF;AgFv9RC;EACC,yBAAA;EACA,mBAAA;EACA,kBAAA;AhFy9RF;AgFv9RE;EALD;IAME,mBAAA;IACA,aAAA;EhF09RD;AACF;AgFv9RC;EACC,eAAA;EACA,kBAAA;EACA,iC/E5lBW;E+E6lBX,c/E1mBW;E+E2mBX,gBAAA;EACA,iBAAA;AhFy9RF;AgFv9RE;EARD;IASE,mBAAA;EhF09RD;EgFx9RC;IACC,aAAA;EhF09RF;AACF;AgFt9RC;EACC,eAAA;EACA,kBAAA;EACA,oB/E9mBY;E+E+mBZ,c/EpnBa;E+EqnBb,gBAAA;AhFw9RF;AgFt9RE;EAPD;IAQE,eAAA;EhFy9RD;AACF;AgFt9RC;EACC,mBAAA;EACA,SAAA;AhFw9RF;AgFr9RC;EACC,eAAA;EACA,gBAAA;EACA,iC/E9nBW;E+E+nBX,c/E5oBW;E+E6oBX,kBAAA;AhFu9RF;AgFr9RE;EAPD;IAQE,mBAAA;IACA,eAAA;EhFw9RD;AACF;AgFr9RC;EACC,c/E/oBa;E+EgpBb,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AhFu9RF;AgFr9RE;EAPD;IAQE,eAAA;EhFw9RD;AACF;AgFp9RE;EADD;IAEE,mBAAA;IACA,YAAA;EhFu9RD;AACF;AgFn9RE;EADD;IAEE,mBAAA;EhFs9RD;EgFp9RC;IACC,gBAAA;EhFs9RF;AACF;;AgF/8RA;EACC,eAAA;AhFk9RD;AgF/8RE;EACC,WAAA;AhFi9RH;AgF78RC;EACC,eAAA;EACA,kBAAA;EACA,iC/EprBW;E+EqrBX,c/ElsBW;E+EmsBX,gBAAA;EACA,iBAAA;EACA,mBAAA;AhF+8RF;AgF78RE;EATD;IAUE,mBAAA;EhFg9RD;EgF98RC;IACC,aAAA;EhFg9RF;AACF;AgF58RC;EACC,c/E1sBa;E+E2sBb,oB/EtsBY;E+EusBZ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AhF88RF;AgF58RE;EACC;IACC,aAAA;EhF88RF;AACF;AgF18RC;EACC,gBAAA;EACA,UAAA;EACA,mBAAA;AhF48RF;AgF18RE;EALD;IAME,mBAAA;EhF68RD;AACF;AgFz8RC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AhF28RF;AgFx8RE;EAPD;IAQE,mBAAA;IACA,SAAA;EhF28RD;AACF;AgFz8RE;EACC,gBAAA;AhF28RH;AgFt8RC;EACC,WAAA;EACA,YAAA;EACA,yB/E/vBW;E+EgwBX,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iC/E1vBW;E+E2vBX,eAAA;AhFw8RF;AgFr8RC;EACC,iBAAA;EACA,c/EtwBa;E+EuwBb,qBAAA;EACA,gBAAA;EACA,mBAAA;AhFu8RF;AgFp8RC;EACC,eAAA;EACA,gBAAA;EACA,oB/E1wBY;E+E2wBZ,iBAAA;EACA,gBAAA;EACA,c/ElxBa;E+EmxBb,qBAAA;AhFs8RF;AgFn8RC;EACC,iBAAA;EACA,gBAAA;EACA,c/EzxBa;E+E0xBb,qBAAA;EACA,gBAAA;AhFq8RF;AgFl8RE;EARD;IASE,iBAAA;EhFq8RD;AACF;;AgF/7RA;EACC,kBAAA;EACA,wDAAA;EACA,eAAA;AhFk8RD;AgFh8RC;EALD;IAME,eAAA;EhFm8RA;AACF;AgFh8RE;EADD;IAEE,eAAA;EhFm8RD;AACF;AgFj8RE;EALD;IAME,aAAA;IACA,UAAA;IACA,mBAAA;IACA,uBAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;EhFo8RD;AACF;AgFh8RC;EACC,WAAA;EACA,iC/E7zBW;E+E8zBX,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AhFk8RF;AgF37RC;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AhF67RF;AgF37RE;EAND;IAOE,gBAAA;EhF87RD;AACF;AgF37RC;EACC,aAAA;EACA,eAAA;AhF67RF;AgF17RC;EACC,UAAA;AhF47RF;AgFz7RC;EACC,YAAA;AhF27RF;AgFz7RE;EAHD;IAIE,aAAA;EhF47RD;AACF;AgFv7RC;EACC,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AhFy7RF;AgFv7RE;EAdD;IAeE,mBAAA;IACA,aAAA;EhF07RD;AACF;AgFv7RC;EACC,mBAAA;AhFy7RF;AgFt7RC;EACC,iC/E/3BW;E+Eg4BX,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,c/Ez4Ba;E+E04Bb,SAAA;EACA,WAAA;AhFw7RF;AgFt7RE;EACC,WAAA;EACA,mBAAA;AhFw7RH;AgFr7RE;EAdD;IAeE,eAAA;EhFw7RD;AACF;AgFr7RC;EACC,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EAEA,UAAA;EACA,kDAAA;EACA,yB/E16BW;E+E26BX,WAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;AhFq7RF;AgFn7RE;EAnBD;IAoBE,eAAA;EhFs7RD;AACF;AgFj7RC;EACC,yB/Ez7BW;AD42Tb;AgFh7RC;EACC,UAAA;EACA,wBAAA;EACA,cAAA;AhFk7RF;AgF/6RC;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AhFi7RF;;AgFx6RA;EACC,eAAA;EACA,uBAAA;AhF26RD;AgFx6RE;EADD;IAEE,aAAA;IACA,eAAA;IACA,uBAAA;EhF26RD;AACF;AgFv6RC;EACC,iC/Eh9BW;E+Ei9BX,c/E99BW;E+E+9BX,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AhFy6RF;AgFt6RE;EATD;IAUE,kBAAA;IACA,gBAAA;EhFy6RD;AACF;AgFv6RE;EAdD;IAeE,eAAA;IACA,iBAAA;IACA,mBAAA;EhF06RD;AACF;AgFt6RC;EACC,eAAA;EACA,gBAAA;EACA,c/E9+Ba;E+E++Bb,mBAAA;EACA,kBAAA;AhFw6RF;AgFn6RC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,kFAAA;AhFq6RF;AgFn6RE;EAXD;IAYE,kGAAA;EhFs6RD;AACF;AgFj6RC;EACC,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,4BAAA;EACA,wBAAA;EACA,yB/ExhCU;E+EyhCV,kBAAA;EACA,gBAAA;AhFm6RF;AgF95RE;EAnBD;IAoBE,gBAAA;IACA,eAAA;IACA,sBAAA;IACA,4BAAA;EhFi6RD;AACF;AgF95RC;EACC,WAAA;EACA,+B/E9hCW;E+E+hCX,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AhFg6RF;AgF95RE;EACC,gBAAA;AhFg6RH;AgF55RE;EAbD;IAcE,gBAAA;IACA,0BAAA;EhF+5RD;EgF75RC;IACC,aAAA;EhF+5RF;AACF;;AgFv5RA;EACC,uBAAA;AhF05RD;;AgFv5RA;EACC,uBAAA;AhF05RD;;AgFv5RA;EACC,oDAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,uBAAA;AhF05RD;AgFx5RC;EAPD;IAQE,eAAA;EhF25RA;AACF;AgFv5RC;EACC,sBAAA;EACA,YAAA;EACA,mBAAA;AhFy5RF;AgFv5RE;EALD;IAME,mBAAA;EhF05RD;EgFx5RC;IACC,gBAAA;EhF05RF;AACF;AgFt5RC;EACC,cAAA;AhFw5RF;AgFn5RC;EACC,WAAA;EACA,eAAA;AhFq5RF;AgFl5RC;EACC,aAAA;EACA,cAAA;AhFo5RF;AgFl5RE;EAJD;IAKE,kBAAA;EhFq5RD;AACF;AgFl5RC;EACC,iC/E/mCW;E+EgnCX,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,c/EnoCW;E+EooCX,mBAAA;AhFo5RF;AgFh5RC;EACC,oB/E7nCY;E+E8nCZ,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,c/ExoCa;E+EyoCb,mBAAA;AhFk5RF;AgFh5RE;EACC,kBAAA;AhFk5RH;AgF74RE;EADD;IAEE,gBAAA;IACA,YAAA;IACA,qBAAA;EhFg5RD;AACF;AgF74RC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AhF+4RF;AgF54RG;EACC,UAAA;EACA,WAAA;EACA,mDAAA;EACA,kBAAA;EACA,qBAAA;AhF84RJ;AgF14RI;EACC,sBAAA;AhF44RL;;AgFh4RA;EACC,sBAAA;EACA,eAAA;AhFm4RD;AgFj4RC;EAJD;IAKE,eAAA;IACA,eAAA;EhFo4RA;AACF;AgFh4RC;EACC,eAAA;EACA,kBAAA;EACA,iC/E9rCW;E+E+rCX,c/E5sCW;E+E6sCX,gBAAA;EACA,iBAAA;EACA,mBAAA;AhFk4RF;AgFh4RE;EATD;IAUE,mBAAA;IACA,mBAAA;EhFm4RD;EgFj4RC;IACC,aAAA;EhFm4RF;AACF;AgF/3RC;EACC,oB/EhtCY;E+EitCZ,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AhFi4RF;AgF/3RE;EACC,yBAAA;AhFi4RH;AgF/3RG;EACC,WAAA;AhFi4RJ;AgF93RG;EACC,WAAA;AhFg4RJ;AgF53RE;EAnBD;IAqBE,aAAA;IACA,eAAA;IACA,qBAAA;EhF83RD;AACF;AgFz3RC;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oB/EjvCY;AD4mUd;AgFz3RE;EACC,WAAA;AhF23RH;AgFr3RC;EACC,sBAAA;EACA,kBAAA;EACA,eAAA;AhFu3RF;AgFr3RE;EALD;IAME,sBAAA;EhFw3RD;AACF;AgFp3RC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oB/EzwCY;E+E0wCZ,c/EtxCW;E+EuxCX,SAAA;AhFs3RF;AgFp3RE;EACC,WAAA;AhFs3RH;AgFl3RC;EACC,aAAA;EACA,mBAAA;AhFo3RF;AgFj3RC;EACC,YAAA;AhFm3RF;AgF92RC;EACC,yBAAA;EACA,UAAA;EACA,6BAAA;AhFg3RF;AgF92RE;EAEC,kBAAA;AhF+2RH;;AgFv2RA;EAEC,eAAA;EACA,yB/E/zCsB;E+Eg0CtB,iBAAA;AhFy2RD;AgFt2RC;EAPD;IAQE,eAAA;IACA,oBAAA;IACA,0DAAA;IACA,oBAAA;IACA,0BAAA;IACA,4BAAA;EhFy2RA;AACF;AgFt2RC;EAjBD;IAmBE,0DAAA;IACA,oBAAA;IACA,0BAAA;IACA,4BAAA;IACA,gBAAA;EhFw2RA;AACF;AgFp2RC;EACC,iC/Ex0CW;E+Ey0CX,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AhFs2RF;AgFj2RE;EAXD;IAYE,eAAA;IACA,iBAAA;IACA,mBAAA;EhFo2RD;AACF;AgFh2RC;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AhFk2RF;AgFh2RE;EAND;IAOE,eAAA;IACA,iBAAA;EhFm2RD;AACF;AgF/1RC;EACC,WAAA;EACA,gBAAA;AhFi2RF;AgF91RC;EACC,aAAA;EACA,SAAA;EACA,eAAA;AhFg2RF;AgF71RC;EACC,qBAAA;EACA,+BAAA;AhF+1RF;AgF71RE;EACC,sBAAA;AhF+1RH;AgF31RC;EACC,YAAA;EACA,cAAA;AhF61RF;;AgFv1RA;EAEC,eAAA;EACA,uBAAA;AhFy1RD;AgFv1RC;EALD;IAME,gBAAA;IACA,mBAAA;EhF01RA;AACF;AgFx1RC;EACC,mBAAA;AhF01RF;AgFx1RE;EAHD;IAIE,gBAAA;IACA,mBAAA;EhF21RD;AACF;AgFx1RC;EACC,iC/Ev5CW;E+Ew5CX,c/Er6CW;E+Es6CX,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AhF01RF;AgFv1RE;EATD;IAUE,eAAA;IACA,iBAAA;EhF01RD;AACF;AgFr1RC;EACC,mBAAA;AhFu1RF;AgFp1RC;EACC,qBAAA;EACA,gBAAA;AhFs1RF;AgFj1RC;EACC,6BAAA;EACA,eAAA;AhFm1RF;AgFh1RC;EACC,WAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AhFk1RF;AgF/0RC;EACC,eAAA;EACA,c/E38Ca;E+E48Cb,eAAA;AhFi1RF;AgF90RC;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AhFg1RF;AgF70RC;EACC,WAAA;EACA,YAAA;EAEA,gCAAA;AhF80RF;AgF10RC;EACC,yBAAA;AhF40RF;;AgFt0RA;EAEC,yBAAA;EACA,WAAA;AhFw0RD;AgFt0RC;EACC,eAAA;AhFw0RF;AgFr0RC;EACC,uDAAA;EACA,eAAA;AhFu0RF;AgFp0RC;EACC,mBAAA;AhFs0RF;AgFn0RC;EACC,mBAAA;AhFq0RF;AgFh0RC;EACC,aAAA;EACA,SAAA;AhFk0RF;AgFh0RE;EAJD;IAKE,eAAA;EhFm0RD;AACF;AgF1zRC;EACC,WAAA;AhF4zRF;AgF1zRE;EAHD;IAIE,aAAA;IACA,YAAA;EhF6zRD;AACF;AgFzzRC;EACC,mBAAA;AhF2zRF;AgFzzRE;EAHD;IAIE,gBAAA;EhF4zRD;AACF;AgFzzRC;EACC,mBAAA;AhF2zRF;AgFzzRE;EAHD;IAIE,gBAAA;EhF4zRD;AACF;AgFjzRC;EACC,eAAA;AhFmzRF;AgFhzRC;EACC,UAAA;EACA,gBAAA;AhFkzRF;AgF/yRC;EACC,gBAAA;EACA,WAAA;EACA,mBAAA;AhFizRF;AgF/yRE;EACC,gBAAA;AhFizRH;AgF7yRC;EACC,WAAA;AhF+yRF;AgF7yRE;EACC,WAAA;EACA,YAAA;AhF+yRH;AgFxyRC;EACC,WAAA;EACA,aAAA;EACA,SAAA;AhF0yRF;AgFxyRE;EACC,WAAA;EACA,YAAA;AhF0yRH;AgFhyRC;EACC,aAAA;EACA,SAAA;AhFkyRF;AgF3wRC;EACC,mBAAA;AhF6wRF;AgF3wRE;EAHD;IAIE,gBAAA;EhF8wRD;AACF;AgFpwRA;EACC,eAAA;EACA,QAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AhFqwRD;;AgFlwRA;EACC,kBAAA;EACA,QAAA;EACA,8BAAA;AhFqwRD;;AgFlwRA;EACC,kBAAA;EACA,UAAA;EAEA,UAAA;EACA,gBAAA;EAEA,aAAA;EAEA,gBAAA;EACA,mBAAA;EAEA,kBAAA;AhFiwRD;;AgF5vRA;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iC/E3qDY;AD06Ub;;AgF3vRA;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AhF8vRD;;AgF3vRA;EACC,aAAA;EACA,uBAAA;AhF8vRD;;AgF3vRA;EACC,YAAA;EACA,eAAA;EACA,YAAA;AhF8vRD;;AgF3vRA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EAEA,YAAA;EACA,uBAAA;EACA,eAAA;AhF4vRD;;AgFzvRA;EACC,YAAA;EACA,eAAA;AhF4vRD","sourcesContent":["@import './variables';\r\n@import \"~bootstrap/scss/bootstrap\";\r\n@import './custom';\r\n\r\n@import \"~owl.carousel/dist/assets/owl.carousel.css\";\r\n@import \"~owl.carousel/dist/assets/owl.theme.default.css\";","// Paleta Primaria\r\n$toke-primario-morado: #5649B3;\r\n$toke-primario-acqua: #00C4BB;\r\n\r\n// Paleta Complementaria\r\n$toke-royal: #362893;\r\n$toke-purpura: #9A7FF6;\r\n$toke-teal: #00A6A6;\r\n$toke-mar: #00EBDF;\r\n\r\n// Paleta Complementaria\r\n$toke-gris: #f2f2f2;\r\n$toke-granito: #485974;\r\n$toke-teal-oscuro: #006680;\r\n\r\n\r\n// Tipografias\r\n$inter-font : 'Inter';\r\n$museo-font: 'Museo Sans Rounded';\r\n\r\n@font-face {\r\n    font-family: 'Inter';\r\n    src: url('../assets/fonts/Inter/Inter-Regular.ttf') format('truetype');\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Inter';\r\n    src: url('../assets/fonts/Inter/Inter-Semibold.ttf') format('truetype');\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Inter';\r\n    src: url('../assets/fonts/Inter/Inter-Bold.ttf') format('truetype');\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 100 - Thin */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded100.ttf') format('truetype');\r\n    font-weight: 100;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 300 - Light */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded300.ttf') format('truetype');\r\n    font-weight: 300;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 500 - Medium */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded500.ttf') format('truetype');\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 700 - Bold */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded700.ttf') format('truetype');\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 900 - Black */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded900.ttf') format('truetype');\r\n    font-weight: 900;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 1000 - Heavy / Ultra */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded1000.ttf') format('truetype');\r\n    font-weight: 1000;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}","/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","body {\r\n\tfont-family: $inter-font, sans-serif;\r\n}\r\n\r\nhtml {\r\n\tscroll-behavior: smooth;\r\n}\r\n\r\n// 00-Utils\r\n\r\n.no-gutter[class*=\"col-\"] {\r\n\tpadding: 0;\r\n}\r\n\r\n.link-global {\r\n\ttext-decoration: none;\r\n\tfont-size: 16px;\r\n\tbackground-color: $toke-teal;\r\n\tcolor: #fff;\r\n\tfont-weight: 600;\r\n\tpadding: 12px 20px;\r\n\ttext-align: center;\r\n\tborder-radius: 24px;\r\n\ttransition: all 0.3s ease-in-out;\r\n\ttext-decoration: none;\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tgap: 8px;\r\n\r\n\r\n\r\n\t&--block {\r\n\t\tdisplay: block;\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tfont-size: 16px;\r\n\t\t\tpadding: 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t&--semi-block {\r\n\t\tdisplay: block;\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tfont-size: 16px;\r\n\r\n\t\t}\r\n\t}\r\n\r\n\t&--purple {\r\n\t\tbackground-color: $toke-primario-morado;\r\n\t}\r\n\r\n\t&--lg {\r\n\t\tpadding: 12px 36px;\r\n\t\tfont-size: 16px;\r\n\t}\r\n\r\n\r\n\r\n\t&:hover {\r\n\t\topacity: 0.8;\r\n\t\tcolor: #fff;\r\n\t\ttext-decoration: none;\r\n\r\n\t}\r\n\r\n\t&--white {\r\n\t\tbackground-color: #fff;\r\n\t\tcolor: $toke-royal;\r\n\t}\r\n\r\n\t&--fade {\r\n\t\tbackground-color: #F7F5FD;\r\n\t\tcolor: #3B3187;\r\n\t\tfont-size: 16px;\r\n\r\n\t\t&:hover {\r\n\t\t\topacity: 0.9;\r\n\t\t\tcolor: #352c78;\r\n\t\t\ttext-decoration: none;\r\n\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.container {\r\n\t&--space {\r\n\t\tpadding: 0 40px;\r\n\t}\r\n\r\n\t&--shrink {\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmax-width: 978px;\r\n\t\t}\r\n\t}\r\n\r\n\t&--large {\r\n\t\tmax-width: 1260px;\r\n\t}\r\n}\r\n\r\n.global-tabs {\r\n\tmargin-bottom: 32px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tgap: 12px;\r\n\toverflow-x: auto;\r\n\toverflow-y: hidden;\r\n\r\n\tflex-wrap: nowrap;\r\n\twhite-space: nowrap;\r\n\r\n\tscrollbar-width: thin;\r\n\r\n\t@media (min-width:768px) {\r\n\t\tjustify-content: center;\r\n\t\tgap: 24px;\r\n\r\n\r\n\t}\r\n\r\n\r\n}\r\n\r\n.global-tab {\r\n\tborder: none;\r\n\tbackground-color: transparent;\r\n\tcolor: #151D28;\r\n\tborder: 1px solid #C4CAD4;\r\n\tpadding: 12px 20px;\r\n\r\n\r\n\t&:hover {\r\n\t\tbackground-color: $toke-royal;\r\n\t\tcolor: #fff;\r\n\t\topacity: 0.9;\r\n\t\tborder: 1px solid $toke-royal;\r\n\t}\r\n\r\n\t@media (min-width:1024px) {\r\n\t\tflex-basis: 176px;\r\n\t}\r\n\r\n\t&--active {\r\n\t\tbackground-color: $toke-royal;\r\n\t\tcolor: #fff;\r\n\t\tborder: 1px solid $toke-royal;\r\n\t}\r\n}\r\n\r\n// 01-Navigation\r\n.navigation {\r\n\r\n\tposition: fixed;\r\n\tz-index: 99;\r\n\twidth: 100%;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tleft: 0;\r\n\tbackground-color: #fff;\r\n\r\n\t@media (min-width: 1024px) {\r\n\t\tposition: fixed;\r\n\t\tz-index: 99;\r\n\t\twidth: 100%;\r\n\t\ttop: 0;\r\n\t\tright: 0;\r\n\t\tleft: 0;\r\n\t\tbackground-color: transparent;\r\n\t}\r\n\r\n\t&__logo-image {\r\n\t\twidth: 80px;\r\n\t}\r\n\r\n\t&--sticky {\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\tbackground-color: #fff;\r\n\t\t\ttransition: all ease-out 0.5s;\r\n\r\n\t\t\t.navigation__link {\r\n\t\t\t\tcolor: #362893;\r\n\t\t\t}\r\n\r\n\t\t\t.navigation__popup-cta {\r\n\t\t\t\tbackground-color: $toke-primario-morado;\r\n\t\t\t\tcolor: #fff;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\r\n\t&__inner {\r\n\t\tborder-bottom: 1px solid rgba(126, 138, 159, 0.24);\r\n\t\tpadding: 24px 0;\r\n\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\tpadding: 19px 0;\r\n\t\t\tborder: none;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__actions {\r\n\t\t.navigation__hamburger {\r\n\t\t\tbackground-color: transparent;\r\n\t\t\theight: 44px;\r\n\t\t\twidth: 44px;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\tborder: none;\r\n\t\t\tcursor: pointer;\r\n\t\t\ttransition: all 0.3s ease-in-out;\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\tbackground-color: $toke-gris;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&__popup {\r\n\t\tposition: relative;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n\r\n\t&__popup-item {\r\n\t\tgap: 16px;\r\n\r\n\t}\r\n\r\n\t&__popup-close {\r\n\t\tgap: 16px;\r\n\t\tposition: absolute;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\r\n\t}\r\n\r\n\t&__popup {\r\n\t\tpadding: 13px 16px;\r\n\t}\r\n\r\n\t&__popup-description {\r\n\t\tfont-size: 12px;\r\n\t\tmargin: 0;\r\n\t\tcolor: $toke-granito;\r\n\r\n\t\tp {\r\n\t\t\tmargin: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t&__mobile {\r\n\t\tbackground-color: #fff;\r\n\t\tdisplay: none;\r\n\t\theight: calc(100vh - 94px);\r\n\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\theight: auto;\r\n\t\t\tdisplay: flex;\r\n\t\t\tbackground-color: transparent;\r\n\t\t}\r\n\r\n\t\t&--desktop {\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\t}\r\n\r\n\r\n\r\n\t&__list {\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\tlist-style: none;\r\n\t\tborder: 1px solid rgba(126, 138, 159, 0.24);\r\n\r\n\t\t&--mobile {\r\n\t\t\tbackground-color: #fff;\r\n\r\n\t\t\t@media (min-width: 1024px) {\r\n\t\t\t\tbackground-color: transparent;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\tborder: none;\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\t}\r\n\r\n\t&__item {\r\n\t\tpadding: 26px 15px;\r\n\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\tpadding: 10px 15px;\r\n\t\t}\r\n\r\n\t\t&--active {\r\n\t\t\tbackground-color: #E2DCFD;\r\n\r\n\t\t\t@media (min-width: 1024px) {\r\n\t\t\t\tbackground-color: transparent;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__link {\r\n\t\tcolor: $toke-royal;\r\n\t\tfont-weight: 700;\r\n\t\tdisplay: block;\r\n\t\tposition: relative;\r\n\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\tfont-size: 14px;\r\n\t\t\tcolor: #fff;\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\tcolor: $toke-teal;\r\n\t\t\t\ttext-decoration: none;\r\n\t\t\t}\r\n\r\n\t\t}\r\n\r\n\t\t&.dropdown-toggle::after {\r\n\t\t\tposition: absolute;\r\n\t\t\tborder: none;\r\n\t\t\tbackground-image: url(\"../assets/images/navigation/arrow-down.svg\");\r\n\t\t\theight: 20px;\r\n\t\t\twidth: 20px;\r\n\t\t\tright: 0;\r\n\t\t\tmargin: 0;\r\n\t\t\tbackground-repeat: no-repeat;\r\n\t\t\tbackground-size: contain;\r\n\t\t\ttop: 0;\r\n\r\n\t\t\t@media (min-width: 1024px) {\r\n\t\t\t\tright: -28px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&__slide {\r\n\t\tborder-top: 1px solid rgba(126, 138, 159, 0.24);\r\n\t\tborder-bottom: 1px solid rgba(126, 138, 159, 0.24);\r\n\t\tpadding: 15px 0;\r\n\r\n\r\n\r\n\r\n\t}\r\n\r\n\t.navigation__owl {\r\n\t\timg {\r\n\t\t\taspect-ratio: 15/8;\r\n\t\t}\r\n\r\n\t\t.owl-item.cloned {\r\n\t\t\tmargin-right: 0 !important;\r\n\t\t}\r\n\r\n\t\t.owl-dots {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: center;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\r\n\t\t\t.owl-dot {\r\n\t\t\t\tspan {\r\n\t\t\t\t\twidth: 8px;\r\n\t\t\t\t\theight: 8px;\r\n\t\t\t\t\tbackground-color: #AC9AED;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&.active {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tbackground-color: #2F1886;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t}\r\n\r\n\t\t}\r\n\t}\r\n\r\n\r\n\t&__slide-title {\r\n\t\tcolor: $toke-teal;\r\n\t\tfont-weight: 600;\r\n\t\tfont-size: 14px;\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\r\n\t&__mobile-actions {\r\n\t\tpadding: 28px 0;\r\n\t\tgap: 8px;\r\n\t}\r\n\r\n\t&__mobile-actions-item {\r\n\t\tgap: 8px;\r\n\t}\r\n\r\n\t.container--gap {\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\tgap: 32px;\r\n\t\t}\r\n\t}\r\n\r\n}\r\n\r\n// 02-Banner-slider\r\n\r\n.banner-slider {\r\n\tmargin-top: 93px;\r\n\r\n\t@media (min-width: 1024px) {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\r\n\t&__carousel {\r\n\t\twidth: 100%;\r\n\t\tbackground-color: $toke-royal;\r\n\t}\r\n\r\n\t&__slide {\r\n\t\tpadding: 18px 0;\r\n\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\tfont-size: 48px;\r\n\t\t\tpadding: 80px 0 48px 0;\r\n\r\n\t\t}\r\n\t}\r\n\r\n\r\n\r\n\t&__title {\r\n\t\tfont-family: $museo-font;\r\n\t\tcolor: #fff;\r\n\t\tfont-weight: 900;\r\n\t\tfont-size: 40px;\r\n\t\tmargin-bottom: 18px;\r\n\t\tline-height: 48px;\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tfont-size: 48px;\r\n\t\t\tline-height: 56px;\r\n\t\t\tmargin-bottom: 48px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__description {\r\n\t\tfont-family: $inter-font;\r\n\t\tcolor: #fff;\r\n\t\tfont-weight: 400;\r\n\t\tfont-size: 16px;\r\n\t\tmargin-bottom: 18px;\r\n\t\tletter-spacing: 0.2px;\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tfont-size: 20px;\r\n\t\t\tline-height: 28px;\r\n\t\t\tmargin-bottom: 40px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__stores {\r\n\t\tgap: 12px;\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tmargin-bottom: 40px;\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\theight: 30px;\r\n\r\n\t\t\t@media (min-width: 1200px) {\r\n\r\n\t\t\t\theight: 43px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\r\n\t&__link {\r\n\t\tmargin-bottom: 16px;\r\n\t\tflex-basis: 343px;\r\n\t\tdisplay: block;\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t\tflex-basis: 258px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__link-box {\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t.owl-dots {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t\tpadding-bottom: 16px;\r\n\r\n\t\t.owl-dot {\r\n\t\t\tspan {\r\n\t\t\t\twidth: 8px;\r\n\t\t\t\theight: 8px;\r\n\t\t\t\tbackground-color: #ffffff36;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tdisplay: inline-block;\r\n\t\t\t}\r\n\r\n\t\t\t&.active {\r\n\t\t\t\tspan {\r\n\t\t\t\t\tbackground-color: #fff;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t}\r\n\r\n\t}\r\n}\r\n\r\n// 03-Intro\r\n.intro {\r\n\tpadding: 48px 0;\r\n\tposition: relative;\r\n\r\n\t@media (min-width:1024px) {\r\n\t\tpadding-bottom: 24px;\r\n\t}\r\n\r\n\r\n\t&__decal {\r\n\t\tposition: absolute;\r\n\t\tright: 15%;\r\n\t\ttop: -120px;\r\n\t\tz-index: 9;\r\n\t}\r\n\r\n\t&__content {\r\n\t\tline-height: 140%;\r\n\t\tfont-size: 16px;\r\n\t\tcolor: $toke-granito;\r\n\t\tfont-weight: 400;\r\n\t\tletter-spacing: 0.2px;\r\n\t\tmargin-bottom: 26px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmax-width: 1024px;\r\n\t\t\tfont-size: 20px;\r\n\t\t\tline-height: 28px;\r\n\t\t}\r\n\r\n\r\n\t}\r\n\r\n\t&__actions {\r\n\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmax-width: 185px;\r\n\t\t\tdisplay: inline-block;\r\n\r\n\t\t\ta {\r\n\t\t\t\tmax-width: 185px;\r\n\t\t\t\twidth: 185px;\r\n\t\t\t\tdisplay: inline-block;\r\n\t\t\t}\r\n\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// 04-Ventajas\r\n.ventajas {\r\n\tpadding: 30px 16px;\r\n\tposition: relative;\r\n\r\n\t&__decal {\r\n\t\tposition: absolute;\r\n\t\tleft: 15%;\r\n\t\ttop: -92px;\r\n\t\tz-index: 9;\r\n\t}\r\n\r\n\t@media (min-width:1024px) {\r\n\t\tpadding: 48px 64px;\r\n\t}\r\n\r\n\t&__box {\r\n\t\tbackground-color: #F2F2F2;\r\n\t\tborder-radius: 16px;\r\n\t\tpadding: 18px 16px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tborder-radius: 56px;\r\n\t\t\tpadding: 36px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__title {\r\n\t\tfont-size: 40px;\r\n\t\ttext-align: center;\r\n\t\tfont-family: $museo-font;\r\n\t\tcolor: $toke-royal;\r\n\t\tfont-weight: 900;\r\n\t\tline-height: 48px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 16px;\r\n\r\n\t\t\tbr {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&__subtitle {\r\n\t\tfont-size: 16px;\r\n\t\ttext-align: center;\r\n\t\tfont-family: $inter-font;\r\n\t\tcolor: $toke-granito;\r\n\t\tfont-weight: 400;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tfont-size: 20px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__item {\r\n\t\tmargin-bottom: 28px;\r\n\t\tgap: 30px;\r\n\t}\r\n\r\n\t&__item-title {\r\n\t\tfont-size: 18px;\r\n\t\tfont-weight: 700;\r\n\t\tfont-family: $museo-font;\r\n\t\tcolor: $toke-royal;\r\n\t\tmargin-bottom: 8px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 12px;\r\n\t\t\tfont-size: 24px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__item-subtitle {\r\n\t\tcolor: $toke-granito;\r\n\t\tline-height: 140%;\r\n\t\tletter-spacing: 0.2px;\r\n\t\tfont-size: 16px;\r\n\t\tmargin-bottom: 0;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tfont-size: 20px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__item-image {\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 28px;\r\n\t\t\twidth: 160px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__item-box {\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 80px;\r\n\r\n\t\t\t&:last-of-type {\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// 05-Unete\r\n\r\n.unete {\r\n\tpadding: 32px 0;\r\n\r\n\t&__image {\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\t}\r\n\r\n\t&__title {\r\n\t\tfont-size: 40px;\r\n\t\ttext-align: center;\r\n\t\tfont-family: $museo-font;\r\n\t\tcolor: $toke-royal;\r\n\t\tfont-weight: 900;\r\n\t\tline-height: 48px;\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 16px;\r\n\r\n\t\t\tbr {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&__intro {\r\n\t\tcolor: $toke-granito;\r\n\t\tfont-family: $inter-font;\r\n\t\tfont-size: 20px;\r\n\t\tfont-weight: 700;\r\n\t\tline-height: 28px;\r\n\t\tmargin-bottom: 36px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tbr {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&__steps {\r\n\t\tlist-style: none;\r\n\t\tpadding: 0;\r\n\t\tmargin-bottom: 32px;\r\n\r\n\t\t@media (min-width:1200px) {\r\n\t\t\tpadding-right: 54px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__step {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 18px;\r\n\t\tmargin-bottom: 24px;\r\n\r\n\r\n\t\t@media (min-width:1200px) {\r\n\t\t\tmargin-bottom: 32px;\r\n\t\t\tgap: 32px;\r\n\t\t}\r\n\r\n\t\t&:last-of-type {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__step-number {\r\n\t\twidth: 32px;\r\n\t\theight: 32px;\r\n\t\tbackground-color: $toke-royal;\r\n\t\tborder-radius: 50%;\r\n\t\tcolor: #fff;\r\n\t\tdisplay: flex;\r\n\t\tfont-weight: 800;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tflex-shrink: 0;\r\n\t\tfont-family: $museo-font;\r\n\t\tfont-size: 22px;\r\n\t}\r\n\r\n\t&__description {\r\n\t\tline-height: 140%;\r\n\t\tcolor: $toke-granito;\r\n\t\tletter-spacing: 0.2px;\r\n\t\tfont-weight: 400;\r\n\t\tmargin-bottom: 32px;\r\n\t}\r\n\r\n\t&__step-title {\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 600;\r\n\t\tfont-family: $inter-font;\r\n\t\tline-height: 140%;\r\n\t\tmargin-bottom: 0;\r\n\t\tcolor: $toke-granito;\r\n\t\tletter-spacing: 0.2px;\r\n\t}\r\n\r\n\t&__step-text {\r\n\t\tline-height: 140%;\r\n\t\tmargin-bottom: 0;\r\n\t\tcolor: $toke-granito;\r\n\t\tletter-spacing: 0.2px;\r\n\t\tfont-weight: 400;\r\n\r\n\r\n\t\t@media (min-width:1200px) {\r\n\t\t\tline-height: 28px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// 06-funcionalidades\r\n\r\n.beneficios {\r\n\tposition: relative;\r\n\tbackground: linear-gradient(to bottom, #9A7FF6, #2F1886);\r\n\tpadding: 48px 0;\r\n\r\n\t@media (min-width:1200px) {\r\n\t\tpadding: 84px 0;\r\n\t}\r\n\r\n\t&__header {\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tpadding: 14px 0;\r\n\t\t}\r\n\r\n\t\t@media (min-width:1200px) {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex: wrap;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\tflex-direction: column;\r\n\t\t\tjustify-content: center;\r\n\t\t\talign-items: center;\r\n\t\t\theight: 100%;\r\n\r\n\t\t}\r\n\t}\r\n\r\n\t&__titulo {\r\n\t\tcolor: #fff;\r\n\t\tfont-family: $museo-font;\r\n\t\tfont-weight: 900;\r\n\t\tline-height: 44px;\r\n\t\tfont-size: 36px;\r\n\t\tmargin-bottom: 20px;\r\n\r\n\r\n\r\n\r\n\t}\r\n\r\n\t&__subtitulo {\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 500;\r\n\t\tcolor: #fff;\r\n\t\tmargin-bottom: 28px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t&__grid {\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: wrap;\r\n\t}\r\n\r\n\t&__item {\r\n\t\twidth: 50%;\r\n\t}\r\n\r\n\t&__item[class*=\"col-\"] {\r\n\t\tpadding: 4px;\r\n\r\n\t\t@media (min-width:1200px) {\r\n\t\t\tpadding: 13px;\r\n\t\t}\r\n\t}\r\n\r\n\r\n\r\n\t&__card {\r\n\t\tbackground-color: #fff;\r\n\t\tborder-radius: 20px;\r\n\t\taspect-ratio: 1;\r\n\t\ttext-align: center;\r\n\t\tpadding: 16px;\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: wrap;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\talign-content: center;\r\n\t\toverflow: hidden;\r\n\t\tposition: relative;\r\n\r\n\t\t@media (min-width:1200px) {\r\n\t\t\taspect-ratio: 21/23;\r\n\t\t\tpadding: 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__icono {\r\n\t\tmargin-bottom: 16px;\r\n\t}\r\n\r\n\t&__item-titulo {\r\n\t\tfont-family: $museo-font;\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 600;\r\n\t\ttext-align: center;\r\n\t\tcolor: $toke-granito;\r\n\t\tmargin: 0;\r\n\t\twidth: 100%;\r\n\r\n\t\t&--flipped {\r\n\t\t\tcolor: #fff;\r\n\t\t\tmargin-bottom: 12px;\r\n\t\t}\r\n\r\n\t\t@media (min-width:1200px) {\r\n\t\t\tfont-size: 22px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__descripcion {\r\n\t\tposition: absolute;\r\n\t\tinset: 0;\r\n\t\talign-content: center;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\r\n\t\tpadding: 12px;\r\n\r\n\t\topacity: 0;\r\n\t\ttransition: opacity .3s ease, transform .3s ease;\r\n\t\tbackground-color: $toke-royal;\r\n\t\tcolor: #fff;\r\n\t\tfont-size: 12px;\r\n\t\tborder-radius: 18px;\r\n\t\tmargin: 0;\r\n\t\ttransform: translateY(12px);\r\n\r\n\t\t@media (min-width:1200px) {\r\n\t\t\tfont-size: 16px;\r\n\t\t}\r\n\r\n\r\n\t}\r\n\r\n\t&__card:hover {\r\n\t\tbackground-color: $toke-royal;\r\n\t}\r\n\r\n\t&__card:hover &__descripcion {\r\n\t\topacity: 1;\r\n\t\ttransform: translateY(0);\r\n\t\tdisplay: block;\r\n\t}\r\n\r\n\t&__decal {\r\n\t\tposition: absolute;\r\n\t\tleft: 10%;\r\n\t\ttop: -92px;\r\n\t\tz-index: 9;\r\n\t}\r\n\r\n\r\n}\r\n\r\n\r\n// 07-activar\r\n\r\n.activar {\r\n\tpadding: 48px 0;\r\n\tscroll-margin-top: 86px;\r\n\r\n\t&__intro {\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\tjustify-content: center;\r\n\r\n\t\t}\r\n\t}\r\n\r\n\t&__title {\r\n\t\tfont-family: $museo-font;\r\n\t\tcolor: $toke-royal;\r\n\t\tfont-weight: 900;\r\n\t\tfont-size: 36px;\r\n\t\tmargin-bottom: 18px;\r\n\t\tline-height: 48px;\r\n\r\n\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\ttext-align: center;\r\n\t\t\tpadding: 0 164px;\r\n\t\t}\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tfont-size: 48px;\r\n\t\t\tline-height: 56px;\r\n\t\t\tmargin-bottom: 48px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__description {\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 400;\r\n\t\tcolor: $toke-granito;\r\n\t\tmargin-bottom: 32px;\r\n\t\ttext-align: center;\r\n\r\n\r\n\t}\r\n\r\n\t&__overlay {\r\n\t\tposition: absolute;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\ttop: 0;\r\n\t\tbottom: 0;\r\n\t\tright: 0;\r\n\t\tleft: 0;\r\n\t\tz-index: 1;\r\n\t\tbackground: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.46) 100%);\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tbackground: linear-gradient(188.33deg, rgba(0, 0, 0, 0.162) 56.32%, rgba(0, 0, 0, 0.7128) 112.93%);\r\n\r\n\r\n\t\t}\r\n\t}\r\n\r\n\t&__box-step {\r\n\t\tborder-radius: 32px;\r\n\t\twidth: 100%;\r\n\t\tmargin-bottom: 16px;\r\n\t\taspect-ratio: 3/2;\r\n\t\tdisplay: flex;\r\n\t\tposition: relative;\r\n\t\tpadding: 34px 26px;\r\n\t\talign-items: flex-end;\r\n\t\tbackground-size: cover;\r\n\t\tbackground-repeat: no-repeat;\r\n\t\tbackground-position: top;\r\n\t\tbackground-color: $toke-teal;\r\n\t\tposition: relative;\r\n\t\toverflow: hidden;\r\n\r\n\r\n\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t\taspect-ratio: 1;\r\n\t\t\tbackground-size: cover;\r\n\t\t\tbackground-repeat: no-repeat;\r\n\t\t}\r\n\t}\r\n\r\n\t&__step-text {\r\n\t\tcolor: #fff;\r\n\t\tfont-size: $museo-font;\r\n\t\tfont-weight: 600;\r\n\t\tfont-size: 18px;\r\n\t\tposition: relative;\r\n\t\tz-index: 2;\r\n\r\n\t\tp {\r\n\t\t\tmargin-bottom: 0;\r\n\r\n\t\t}\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t\tbackground-position: right;\r\n\r\n\t\t\tbr {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// 08-Negocio\r\n\r\n#negocio-1 {\r\n\tscroll-margin-top: 92px;\r\n}\r\n\r\n#negocio-2 {\r\n\tscroll-margin-top: 92px;\r\n}\r\n\r\n.negocio {\r\n\tbackground: url(\"../../src/assets/images/negocio/fondo-negocio.png\");\r\n\tbackground-position: center;\r\n\tbackground-repeat: no-repeat;\r\n\tpadding: 24px 12px;\r\n\tscroll-margin-top: 86px;\r\n\r\n\t@media (min-width:1024px) {\r\n\t\tpadding: 80px 0;\r\n\t}\r\n\r\n\t&__list {}\r\n\r\n\t&__slide {\r\n\t\tbackground-color: #fff;\r\n\t\theight: 100%;\r\n\t\tborder-radius: 40px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 40px;\r\n\r\n\t\t\t&:last-of-type {\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.owl-item {\r\n\t\tpadding: 0 8px;\r\n\t}\r\n\r\n\r\n\r\n\t&__img {\r\n\t\twidth: 100%;\r\n\t\taspect-ratio: 1;\r\n\t}\r\n\r\n\t&__body {\r\n\t\tpadding: 16px;\r\n\t\tpadding-top: 0;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tpadding: 80px 60px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__title {\r\n\t\tfont-family: $museo-font;\r\n\t\tfont-weight: 600;\r\n\t\tfont-style: 700;\r\n\t\tfont-size: 40px;\r\n\t\tline-height: 48px;\r\n\t\tletter-spacing: 0%;\r\n\t\tvertical-align: middle;\r\n\t\tcolor: $toke-royal;\r\n\t\tmargin-bottom: 24px;\r\n\r\n\t}\r\n\r\n\t&__text {\r\n\t\tfont-family: $inter-font;\r\n\t\tfont-weight: 400;\r\n\t\tfont-size: 20px;\r\n\t\tleading-trim: NONE;\r\n\t\tline-height: 28px;\r\n\t\tletter-spacing: 0%;\r\n\t\tcolor: $toke-granito;\r\n\t\tmargin-bottom: 24px;\r\n\r\n\t\tul {\r\n\t\t\tpadding-left: 20px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__cta {\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmax-width: 185px;\r\n\t\t\twidth: 185px;\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\t}\r\n\r\n\t.owl-dots {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t\tpadding-bottom: 16px;\r\n\r\n\t\t.owl-dot {\r\n\t\t\tspan {\r\n\t\t\t\twidth: 8px;\r\n\t\t\t\theight: 8px;\r\n\t\t\t\tbackground-color: #ffffff36;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tdisplay: inline-block;\r\n\t\t\t}\r\n\r\n\t\t\t&.active {\r\n\t\t\t\tspan {\r\n\t\t\t\t\tbackground-color: #fff;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t}\r\n\r\n\t}\r\n\r\n}\r\n\r\n// 09-Testimonios\r\n\r\n.testimonios {\r\n\tbackground-color: #fff;\r\n\tpadding: 38px 0;\r\n\r\n\t@media (min-width: 1024px) {\r\n\t\tfont-size: 48px;\r\n\t\tpadding: 80px 0;\r\n\r\n\t}\r\n\r\n\r\n\t&__title {\r\n\t\tfont-size: 40px;\r\n\t\ttext-align: center;\r\n\t\tfont-family: $museo-font;\r\n\t\tcolor: $toke-royal;\r\n\t\tfont-weight: 900;\r\n\t\tline-height: 48px;\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 16px;\r\n\t\t\tmargin-bottom: 56px;\r\n\r\n\t\t\tbr {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&__slide {\r\n\t\tfont-family: $inter-font;\r\n\t\tborder-radius: 12px;\r\n\t\topacity: 1;\r\n\t\tpadding: 28px 16px;\r\n\t\tbackground-color: #DCD9F2;\r\n\r\n\t\t&--par {\r\n\t\t\tbackground-color: #28205A;\r\n\r\n\t\t\t.testimonios__comentario {\r\n\t\t\t\tcolor: #fff;\r\n\t\t\t}\r\n\r\n\t\t\t.testimonios__autor {\r\n\t\t\t\tcolor: #fff;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t@media (min-width:1024px) {\r\n\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\talign-content: center;\r\n\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__comentario {\r\n\t\tcolor: #151D28;\r\n\t\tfont-weight: 600;\r\n\t\tfont-size: 16px;\r\n\t\tline-height: 24px;\r\n\t\tfont-family: $inter-font;\r\n\r\n\t\t&--impar {\r\n\t\t\tcolor: #fff;\r\n\t\t}\r\n\r\n\r\n\t}\r\n\r\n\t&__cita {\r\n\t\twidth: 12px !important;\r\n\t\tmargin-bottom: 8px;\r\n\t\tfont-size: 12px;\r\n\r\n\t\t@media (min-width: 1024px) {\r\n\t\t\twidth: 24px !important;\r\n\r\n\t\t}\r\n\t}\r\n\r\n\t&__autor {\r\n\t\tfont-weight: 700;\r\n\t\tfont-size: 12px;\r\n\t\tline-height: 20px;\r\n\t\tfont-family: $inter-font;\r\n\t\tcolor: $toke-royal;\r\n\t\tmargin: 0;\r\n\r\n\t\t&--impar {\r\n\t\t\tcolor: #fff;\r\n\t\t}\r\n\t}\r\n\r\n\t.owl-stage {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t}\r\n\r\n\t.owl-item {\r\n\t\theight: 100%;\r\n\r\n\r\n\t}\r\n\r\n\t.owl-item.center {\r\n\t\theight: calc(100% + 24px);\r\n\t\topacity: 1;\r\n\t\ttransition: all ease-out 0.5s;\r\n\r\n\t\t.testimonios__slide {\r\n\r\n\t\t\tpadding: 48px 16px;\r\n\t\t}\r\n\r\n\t}\r\n}\r\n\r\n// 10 Descarga \r\n\r\n.descarga {\r\n\r\n\tpadding: 48px 0;\r\n\tbackground-color: $toke-primario-morado;\r\n\tpadding-bottom: 0;\r\n\r\n\r\n\t@media (min-width: 1024px) {\r\n\t\tpadding: 48px 0;\r\n\t\tpadding-bottom: 48px;\r\n\t\tbackground-image: url(../assets/images/descarga/bg-dekstop.png);\r\n\t\tbackground-size: 50%;\r\n\t\tbackground-position: right;\r\n\t\tbackground-repeat: no-repeat;\r\n\t}\r\n\r\n\r\n\t@media (min-width: 1200px) {\r\n\r\n\t\tbackground-image: url(../assets/images/descarga/bg-dekstop.png);\r\n\t\tbackground-size: 50%;\r\n\t\tbackground-position: right;\r\n\t\tbackground-repeat: no-repeat;\r\n\t\tpadding: 148px 0;\r\n\t}\r\n\r\n\r\n\r\n\t&__title {\r\n\t\tfont-family: $museo-font;\r\n\t\tcolor: #fff;\r\n\t\tfont-weight: 900;\r\n\t\tfont-size: 36px;\r\n\t\tmargin-bottom: 18px;\r\n\t\tline-height: 48px;\r\n\r\n\r\n\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tfont-size: 48px;\r\n\t\t\tline-height: 56px;\r\n\t\t\tmargin-bottom: 48px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__description {\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 400;\r\n\t\tcolor: #fff;\r\n\t\tmargin-bottom: 32px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tfont-size: 20px;\r\n\t\t\tline-height: 30px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__image {\r\n\t\twidth: 100%;\r\n\t\tmargin-top: 32px;\r\n\t}\r\n\r\n\t&__stores {\r\n\t\tdisplay: flex;\r\n\t\tgap: 16px;\r\n\t\tflex-wrap: wrap;\r\n\t}\r\n\r\n\t&__store {\r\n\t\tdisplay: inline-block;\r\n\t\ttransition: transform .2s ease;\r\n\r\n\t\t&:hover {\r\n\t\t\ttransform: scale(1.05);\r\n\t\t}\r\n\t}\r\n\r\n\t&__store-img {\r\n\t\theight: 48px;\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n// 11-preguntas\r\n\r\n.preguntas {\r\n\r\n\tpadding: 80px 0;\r\n\tscroll-margin-top: 86px;\r\n\r\n\t@media (min-width: 992px) {\r\n\t\tmargin-bottom: 0;\r\n\t\tpadding-right: 40px;\r\n\t}\r\n\r\n\t&__info {\r\n\t\tmargin-bottom: 32px;\r\n\r\n\t\t@media (min-width: 992px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t\tpadding-right: 40px;\r\n\t\t}\r\n\t}\r\n\r\n\t&__title {\r\n\t\tfont-family: $museo-font;\r\n\t\tcolor: $toke-royal;\r\n\t\tfont-weight: 900;\r\n\t\tfont-size: 36px;\r\n\t\tmargin-bottom: 18px;\r\n\t\tline-height: 48px;\r\n\r\n\r\n\t\t@media (min-width: 1200px) {\r\n\t\t\tfont-size: 41px;\r\n\t\t\tline-height: 56px;\r\n\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__description {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\r\n\t&__link {\r\n\t\tdisplay: inline-block;\r\n\t\tfont-weight: 600;\r\n\t}\r\n\r\n\t&__faq {}\r\n\r\n\t&__item {\r\n\t\tborder-bottom: 1px solid #eee;\r\n\t\tpadding: 12px 0;\r\n\t}\r\n\r\n\t&__question {\r\n\t\twidth: 100%;\r\n\t\tbackground: none;\r\n\t\tborder: 0;\r\n\t\ttext-align: left;\r\n\t\tfont-weight: 600;\r\n\t\tcursor: pointer;\r\n\t\tpadding: 8px 0;\r\n\t\tfont-size: 18px;\r\n\t\tcolor: #151D28;\r\n\t}\r\n\r\n\t&__answer {\r\n\t\tmargin-top: 8px;\r\n\t\tcolor: $toke-granito;\r\n\t\tfont-size: 16px;\r\n\t}\r\n\r\n\t&__question {\r\n\t\twidth: 100%;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: flex-start;\r\n\t\tgap: 24px;\r\n\t\tbackground: none;\r\n\t\tborder: 0;\r\n\t\tcursor: pointer;\r\n\t\tpadding: 14px 0;\r\n\t\tfont-weight: 600;\r\n\t}\r\n\r\n\t&__chevron {\r\n\t\twidth: 24px;\r\n\t\theight: 24px;\r\n\r\n\t\ttransition: transform .25s ease;\r\n\t}\r\n\r\n\r\n\t&__item.is-open &__chevron {\r\n\t\ttransform: rotate(180deg);\r\n\t}\r\n}\r\n\r\n// 12-footer\r\n\r\n.footer {\r\n\r\n\tbackground-color: #3B3187;\r\n\tcolor: #fff;\r\n\r\n\t&__top {\r\n\t\tpadding: 64px 0;\r\n\t}\r\n\r\n\t&__bottom {\r\n\t\tborder-top: 1px solid #f1f1f17b;\r\n\t\tpadding: 36px 0;\r\n\t}\r\n\r\n\t&__brand {\r\n\t\tmargin-bottom: 32px;\r\n\t}\r\n\r\n\t&__logo {\r\n\t\tmargin-bottom: 32px;\r\n\t}\r\n\r\n\t&__download-text {}\r\n\r\n\t&__stores {\r\n\t\tdisplay: flex;\r\n\t\tgap: 16px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tflex-wrap: wrap;\r\n\t\t}\r\n\t}\r\n\r\n\t&__store {\r\n\t\t&--google-play {}\r\n\r\n\t\t&--app-store {}\r\n\t}\r\n\r\n\t&__store-img {\r\n\t\twidth: 75px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tflex-basis: 1;\r\n\t\t\twidth: 135px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__legales {\r\n\t\tmargin-bottom: 50px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t&__contact {\r\n\t\tmargin-bottom: 50px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t&__section {\r\n\r\n\r\n\r\n\r\n\t\t&--social {}\r\n\t}\r\n\r\n\t&__title {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\r\n\t&__list {\r\n\t\tpadding: 0;\r\n\t\tlist-style: none;\r\n\t}\r\n\r\n\t&__item {\r\n\t\tfont-weight: 600;\r\n\t\tcolor: #fff;\r\n\t\tmargin-bottom: 12px;\r\n\r\n\t\t&:last-of-type {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t&__link {\r\n\t\tcolor: #fff;\r\n\r\n\t\t&:hover {\r\n\t\t\tcolor: #fff;\r\n\t\t\topacity: 0.9;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t&__contact {}\r\n\r\n\t&__contact-link {\r\n\t\tcolor: #fff;\r\n\t\tdisplay: flex;\r\n\t\tgap: 12px;\r\n\r\n\t\t&:hover {\r\n\t\t\tcolor: #fff;\r\n\t\t\topacity: 0.9;\r\n\t\t}\r\n\t}\r\n\r\n\t&__text {}\r\n\r\n\t&__regulator {}\r\n\r\n\t&__regulator-logo {}\r\n\r\n\t&__social {\r\n\t\tdisplay: flex;\r\n\t\tgap: 24px;\r\n\t}\r\n\r\n\t&__social-link {}\r\n\r\n\t&__icon {\r\n\t\t&--mail {}\r\n\r\n\t\t&--phone {}\r\n\r\n\t\t&--chat {}\r\n\r\n\t\t&--x {}\r\n\r\n\t\t&--facebook {}\r\n\r\n\t\t&--instagram {}\r\n\r\n\t\t&--youtube {}\r\n\r\n\t\t&--tiktok {}\r\n\t}\r\n\r\n\t&__disclaimer {\r\n\t\tmargin-bottom: 32px;\r\n\r\n\t\t@media (min-width:1024px) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t&--dark {}\r\n\r\n\t&--light {}\r\n}\r\n\r\n// 13-modal\r\n\r\n.toke-modal {\r\n\tposition: fixed;\r\n\tinset: 0;\r\n\tz-index: 2000;\r\n\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n\r\n.toke-modal__overlay {\r\n\tposition: absolute;\r\n\tinset: 0;\r\n\tbackground: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.toke-modal__container {\r\n\tposition: relative;\r\n\tz-index: 1;\r\n\r\n\twidth: 90%;\r\n\tmax-width: 500px;\r\n\r\n\tpadding: 48px;\r\n\r\n\tbackground: #fff;\r\n\tborder-radius: 48px;\r\n\r\n\ttext-align: center;\r\n}\r\n\r\n.toke-modal__content {}\r\n\r\n.toke-modal__title {\r\n\tmargin: 0 0 12px;\r\n\tfont-size: 40px;\r\n\tfont-weight: 900;\r\n\tfont-family: $museo-font;\r\n\r\n}\r\n\r\n.toke-modal__subtitle {\r\n\tmargin: 0 0 20px;\r\n\tfont-size: 14px;\r\n\tfont-weight: 400;\r\n\tline-height: 1.4;\r\n}\r\n\r\n.toke-modal__qr {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n}\r\n\r\n.toke-modal__qr-image {\r\n\twidth: 180px;\r\n\tmax-width: 100%;\r\n\theight: auto;\r\n}\r\n\r\n.toke-modal__close {\r\n\tposition: absolute;\r\n\ttop: 12px;\r\n\tright: 24px;\r\n\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tcursor: pointer;\r\n}\r\n\r\n.toke-modal__close::before {\r\n\tcontent: \"✕\";\r\n\tfont-size: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
